/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import cn from 'classnames';
import { useCallback, useContext, useEffect, useMemo, useState, useRef } from 'react';
// eslint-disable-next-line
import { DndProvider } from 'react-dnd';
// eslint-disable-next-line
import { HTML5Backend } from 'react-dnd-html5-backend';
import ListingModal from 'Components/ListingModal';
import FilterIconx from 'Assets/filter.png';
import { initializeApp } from 'firebase/app';
import { ref, getDatabase, off, onValue, update } from 'firebase/database';
import { useSelector, useDispatch } from 'react-redux';
import { saveDummy, removeDummy, saveUploadInfo } from 'store/store';
import Skeleton from '@material-ui/lab/Skeleton';
import Spinner from 'Components/Spinner';
import { toast } from 'react-toastify';
import {
  Box,
  Tab,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tabs,
  CircularProgress,
  Typography,
  Tooltip,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  ExpandLessOutlined,
  ExpandMoreOutlined,
  RadioButtonChecked,
  RadioButtonUnchecked,
  ArrowUpward,
  ArrowDownward,
  Sort as SortIcon,
  Event as DateIcon,
  TextFields as TextIcon,
  Category as CategoryIcon,
  Visibility as VisibilityIcon,
  GetApp as DownloadIcon,
  ViewList as LayoutIcon,
  ArrowBack as ArrowBackIcon,
  Link as ShareLinkIcon,
  EditOutlined as EditFolderIcon,
  PersonAddOutlined as AddViewerIcon,
  HowToReg as IsViewerIcon,
  Schedule as PendingViewerIcon,
} from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DropMe from 'Components/DropMe/DropMe';
import { ALLOWED_UPLOADS_COUNT, PLANS } from 'Commons';
import RotatingLoader from 'Components/RotatingLoader';
import {
  axios,
  dataFetcher,
  endpoints,
  firebaseCredentials,
  baseUrl,
} from 'Api';
import {
  getVideosDetail, listContributions, listLinks, listContributorsByLink, reactivateContributionLink,
  searchUserToInvite, addViewer, getViewersList, getPendingViewersList,
} from 'Api/apiFunctions';
import UploadLinkModal from 'Components/UploadDropdown/UploadLinkModal';
import { logAppEvent } from 'Api/errorLogger';
import { resolveContributionTitle } from 'Utils/contributionTitle';
import { SHARED_FEATURE_ENABLED } from 'Config/featureFlags';
import { ReactComponent as DownIcon } from 'Assets/downIcon.svg';
import { ReactComponent as FilterIcon } from 'Assets/filter.svg';
import AlterImage from 'Assets/no-image-available.png';
import Close from 'Assets/close.svg';
import { ReactComponent as UpIcon } from 'Assets/upIcon.svg';
import { Page, Modal } from 'Components';
import { VideoPopupModal } from 'Components/VideoPopup';
import { AppContext, AuthContext } from 'Context';
import useConvertHeicImages from 'hooks/useConvertHeicImages';
import { changeDateFormatToMMDDYY } from 'Utils/utils';
import Aos from 'aos';
import 'aos/dist/aos.css';
import ReactPaginate from 'react-paginate';
import useSWR from 'swr';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUID } from 'react-uid';
import { v4 as uuid } from 'uuid';
import TrailpopUp from 'Components/VideoPopup/TrailpopUp';
import BulkEdit from 'Components/BulkEdit';
import { VideoEditModal, MultipleVideoEditModal } from 'Components/VideoUploadModal';
import PhotoEditModal from 'Components/PhotoUploadModal/PhotoEditModal';
import contentDashboardPreviewImage from '../../../Assets/conten_dashboard_prview.png';
import PhotoPreview from '../../../Components/upload-modal/components/PhotoPreview';
import projectorLogo from '../../public/landing-external/assets/img/logo-p.svg';
import { InfoModal } from '../dashboard/info-modal';
import {
  Checkbox,
  TableCell,
  TableHeaderCell,
  SquareCheckbox,
} from './components/CustomDesignsClassic';
import CategoryFilter from './components/CategoryFilter';
import CategoriesSidebar from './components/CategoriesSidebar';
import AlbumsSidebar from './components/AlbumsSidebar';
import SharedSidebar from './components/SharedSidebar';
import DraggableVideoCard from './components/DraggableVideoCard';
import DragLayer from './components/DragLayer';
import AlbumPhotosModal from './components/AlbumPhotosModal';
import AlbumPhotosView from './components/AlbumPhotosView';
import PublishSettingsModal from './components/PublishSettingsModal';
import ContributorFolderCard from './components/ContributorFolderCard';
import LinkFolderCard from './components/LinkFolderCard';
import useFolderCovers from './hooks/useFolderCovers';
import VideoPanel from './components/VideoPanel';
import PhotoList from './components/PhotoList';
import PrefDropDown from './components/PrefDropDown';
import { EditModal } from './components/upload-modal';
import styles from './index.legacy.module.css';
import CategoriesMenuContainer from './menu/CategoriesMenuContainer';
import EditMenu from './menu/EditMenu';
import VisibilityMenu from './menu/VisibilityMenu';
import { DummyRow } from './dummyRow';
import AddDotLoader from './AddDotLoader';
import { UploadModal } from '../../../Components/upload-modal/index';
import ArrowDown from '../../../Assets/arrowdown.png';
import Cross from '../../../Assets/Crossfilter.png';
import uploadManager, { UPLOAD_STATUS } from '../../../Utils/uploadManagerSecure';
import { UPLOAD_CONFIG } from '../../../Config/uploadConfig';

let tempUploadPercentages;
let tempUploadSizes;

// Stable empty reference so the folder-cover hook's effect doesn't re-run every
// render when the Shared tab isn't active.
const EMPTY_LINKS = [];

const PreloadData = ({ children }) => (
  <tr className={styles.preLoadDataContainer}>
    <td className={styles.preLoadData} colSpan={7}>
      <div className={styles.preloadDataContent}>{children}</div>
    </td>
  </tr>
);

const MacTooltip = withStyles({
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#1d1d1f',
    fontSize: 11,
    fontWeight: 400,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif',
    border: '1px solid rgba(0, 0, 0, 0.18)',
    borderRadius: 3,
    padding: '2px 6px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
    maxWidth: '100%',
    width: '100%',
    boxSizing: 'border-box',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    margin: '2px 0 0 0',
  },
  popper: {
    pointerEvents: 'none',
  },
})(Tooltip);

const TruncatedTitle = ({ title, className }) => {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [anchorWidth, setAnchorWidth] = useState(0);
  const titleText = title || '';

  useEffect(() => {
    const checkTruncation = () => {
      const el = ref.current;
      if (!el) return;
      const parent = el.parentElement;
      const parentWidth = parent ? parent.clientWidth : el.clientWidth;
      setIsTruncated(el.scrollWidth > parentWidth);
      setAnchorWidth(parentWidth);
    };
    checkTruncation();
    const id = window.setTimeout(checkTruncation, 0);
    window.addEventListener('resize', checkTruncation);
    return () => {
      window.clearTimeout(id);
      window.removeEventListener('resize', checkTruncation);
    };
  }, [titleText]);

  return (
    <MacTooltip
      title={isTruncated ? titleText : ''}
      placement="bottom-start"
      enterDelay={400}
      enterNextDelay={200}
      PopperProps={{
        style: anchorWidth ? { maxWidth: anchorWidth, width: anchorWidth } : undefined,
        modifiers: {
          flip: { enabled: false },
          preventOverflow: { enabled: true, boundariesElement: 'viewport' },
        },
      }}
    >
      <span
        ref={ref}
        className={className}
        style={{ maxWidth: '100%' }}
      >
        {titleText}
      </span>
    </MacTooltip>
  );
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  customStyleOnTab: {
    fontSize: '28px',
    color: '#95969A',
    fontWeight: 700,
    textTransform: 'capitalize',
    fontFamily: "'Poppins', sans-serif",
  },
  activeTab: {
    fontSize: '28px',
    color: '#02071A',
    fontWeight: 700,
    textTransform: 'capitalize',
    fontFamily: "'Poppins', sans-serif",
  },
}));
function LoadingTableItem({ items = [], setExpanded }) {
  const [expanded, setIsExpanded] = useState(false);

  function handleExpandCLick() {
    setExpanded((t) => !t);
    setIsExpanded((t) => !t);
  }

  return (
    <Box width="100%">
      <Box display="flex" padding={1} alignItems="center">
        <Box
          display="flex"
          padding={1}
          alignItems="center"
          margin={1}
          bgcolor="black"
          borderRadius="10px"
        >
          <img
            src={projectorLogo}
            style={{ width: '50px', height: '50px' }}
            alt="projector logo"
          />
        </Box>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box>
            <Typography className={styles.progressIndicatorTitle}>
              Uploading in In Progress
            </Typography>
            <Typography className={styles.progressIndicatorSubTitle}>
              {items?.length}
              {' '}
              items being uploaded
            </Typography>
          </Box>
        </Box>
        {/* eslint-disable-next-line */}
        <Box onClick={handleExpandCLick}>
          {expanded ? (
            <ExpandLessOutlined color="primary" className={styles.expand} />
          ) : (
            <ExpandMoreOutlined color="primary" className={styles.expand} />
          )}
        </Box>
      </Box>
    </Box>
  );
}

const YourVideos = () => {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const query = new URLSearchParams(window.location.search);
  const showModal = query.get('showModal');
  const quickUserModal = query.get('quickUserModal');
  const [modalShowPopUp, setModalShowPopUp] = useState(showModal);
  const {
    setHoldTheWeb,
    setTopOrBottom,
    userDetails,
    subscriptionDetails,
    langText,
    singleEdit,
    setSingleEdit,
    setUploadPercentagesInNumber,
    setAppSnackbar,
    getSubscription,
    setDraftContent,
    closeModal: closeUploadModal,
    selectedItems,
    setSelectedItems,
    getAccessChecker,
    eta,
    setIamUploading,
    textOfUpload,
    firebaseDatabase,
    autoSignIn,
    setUploadContainer,
    setNeedToShowETA,
    uploadQueue,
    setisCompleted,
    holdWhileDelete,
    setholdWhileDelete,
    setAllvideoData,
    tabTitle,
    setTabTitle,
    categoryRefreshTrigger,
    downloadingFiles,
    setDownloadingFiles,
    setDownloadBox,
    isBulkDownloading,
    setIsBulkDownloading,
    setDownloadBatchProgress,
    downloadAbortControllersRef,
    pausedDownloadsRef,
    resumeTriggersRef,
    bulkDownloadCancelRef,
    onDownloadPanelVisibleRef,
    handleCancelAllDownloads,
    handleCancelDownload,
    handlePauseDownload,
    handleResumeDownload,
  } = useContext(AppContext);
  const { getToken, isInActiveUser } = useContext(AuthContext);
  const location = useLocation();
  const profileID = userDetails.myId;
  const [timer, setTimer] = useState(null);
  const [selectedVideo, selectVideo] = useState(undefined);
  const [videoData, setVideoData] = useState(undefined);
  const [handlingAction, setActionHandlingStatus] = useState(false);
  const [videoList, setVideoList] = useState([]);
  const [editMenu, setEditMenu] = useState(undefined);
  const [visibilityMenu, setVisibilityMenu] = useState(undefined);
  const [downloadMenuAnchor, setDownloadMenuAnchor] = useState(null);
  const downloadControlRef = useRef(null);
  const [categoriesMenu, setCategoriesMenu] = useState(false);
  const [content, setContent] = useState([]);
  // Tracks which tab the most recent SWR fetch was issued for. If the user
  // switches tabs before the response arrives, onSuccess discards the data
  // so wrong-shape content never lands in `content` (would crash the renderer
  // and show a blank screen).
  const lastFetchTabRef = useRef(undefined);
  const [showImage, setShowImage] = useState(null);
  const [albumImages, setAlbumImages] = useState(undefined);
  const [selectedType, selectType] = useState(undefined);
  const contentText = langText?.content;
  const commonText = langText?.common;
  const [switchPoint, setswitchPoint] = useState(false);
  const [allContent, setAllContent] = useState(undefined);
  const [tableContentLoading, setTableContentLoading] = useState(false);
  const [isOpenPopupModal, setOpenPopupModal] = useState(false);
  const [filter, setFilter] = useState(false);
  const [albumIdGroup, setAlbumIdGroup] = useState([]);
  const [cancelConfirmState, setCancelConfirmState] = useState({});
  const [cancellingState, setCancellingState] = useState({});
  const [viewMode, setViewMode] = useState('grid');
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const videoListContainerRef = useRef(null);
  const [callAlbum, setCallAlbum] = useState([]);
  const [order, setOrder] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState('date');
  const classes = useStyles();
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [openEditInBulk, setOpenEditInBulk] = useState(false);
  const [openEditVideoModal, setEditVideoModal] = useState(false);
  const [contentDetails, setContentDetails] = useState(undefined);
  const [cancelSelection, setCancelSelection] = useState(false);
  const [isDownloading, setDownloading] = useState(false);
  const [bulkDownloadProgress, setBulkDownloadProgress] = useState({ current: 0, total: 0 });
  const [preparingDownload, setPreparingDownload] = useState(false);
  const [preparingProgress, setPreparingProgress] = useState({ current: 0, total: 0 });
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);
  const [isCheckingDownload, setIsCheckingDownload] = useState(false);
  const [cachedVideoRawFile, setCachedVideoRawFile] = useState(null);
  const [cachedVideoTitle, setCachedVideoTitle] = useState(null);
  // const [iosDownloadOverlay, setIosDownloadOverlay] = useState(false);

  // Register callback to hide loader when download panel becomes visible (only for bulk download)
  useEffect(() => {
    if (onDownloadPanelVisibleRef && preparingDownload) {
      onDownloadPanelVisibleRef.current = () => {
        setPreparingDownload(false);
      };
    }
    return () => {
      if (onDownloadPanelVisibleRef) {
        onDownloadPanelVisibleRef.current = null;
      }
    };
  }, [onDownloadPanelVisibleRef, preparingDownload]);
  const [paginatedData, setPaginatedData] = useState(undefined);
  const [selectedPage, selectPage] = useState(1);
  const [isOpenModal, setModal] = useState(false);
  const [isOpenModalinClick, setOpenModalinClick] = useState(false);
  const [isOpenVideoPopup, setOpenVideoPopup] = useState(true);
  const [videoProcessingList, setVideoProcessingList] = useState([]);
  const [albumProcessingList, setAlbumProcessingList] = useState([]);
  const [progressListExpanded, setProgressListExpanded] = useState(false);
  const [videodraftid, setVideodraftid] = useState('');
  const [videodraftTitle, setVideodraftTitle] = useState([]);
  const [selectedIdType, setSelectedIdType] = useState();
  const [selectedVideoContent, setSelectedVideoContent] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [isDummyLoader, setIsDummyLoader] = useState(false);
  const loadingTexts = ['...', '..', '.'];
  const [editLoader, setEditLoader] = useState(false);
  const [loadingTextIndex, setLoadingTextIndex] = useState(0);
  const [showText, setShowText] = useState(true);
  const uploadPercentages = useSelector((state) => state.upload);
  const uploadSizes = useSelector((state) => state.uploadSizes);
  const dummyObject = useSelector((state) => state.dummy);
  // const [selectedItems, setSelectedItems] = useState([]);
  const [editItems, setEditItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState(''); // State to hold the selected value
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to manage dropdown visibility
  const [categrory, setCategrory] = useState(undefined);

  // New category filter state
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState(null);
  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);

  // Album filter state
  const [selectedAlbumFilter, setSelectedAlbumFilter] = useState(null);
  const [albumFilterOptions, setAlbumFilterOptions] = useState([]);

  // Album photos modal state
  const [albumPhotosModalOpen, setAlbumPhotosModalOpen] = useState(false);
  const [selectedAlbumForPhotos, setSelectedAlbumForPhotos] = useState(null);

  // Multi-select state for photos shown inside a specific album.
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [photosPanelTransitionState, setPhotosPanelTransitionState] = useState('exited');
  const albumPhotosViewRef = useRef(null);

  // Panel transition state
  const [panelTransitionState, setPanelTransitionState] = useState('exited');
  const [editItemsStatus, setEditItemsStatus] = useState([]);
  const [selectedDraftIds, setSelectedDraftIds] = useState([]);
  const [selectedContentIds, setSelectedContentIds] = useState([]);
  const [dataLoader, setDataLoader] = useState(false);
  const [loading, setLoading] = useState(false);

  // Shared tab folder (link) state
  const [links, setLinks] = useState([]);
  const [selectedLink, setSelectedLink] = useState(null);
  const [fetchingLinks, setFetchingLinks] = useState(false);

  // Shared tab contributor state
  const [contributors, setContributors] = useState([]);
  const [selectedContributor, setSelectedContributor] = useState(null);
  // Right-sidebar filter within the "All Contents" view: null = all
  // contributors, else only that contributor's contributions.
  const [sidebarContributor, setSidebarContributor] = useState(null);
  // Loading flag for a sidebar filter swap — kept separate from
  // fetchingContributions so the sidebar itself doesn't flip to the
  // full-screen skeleton on every click (only the grid area dims).
  const [filteringContributions, setFilteringContributions] = useState(false);
  // Viewer-status lookup for the "add as viewer" icon in the sidebar. Sets of
  // lowercased emails already an active viewer / pending invite.
  const [viewerEmails, setViewerEmails] = useState(() => new Set());
  const [pendingViewerEmails, setPendingViewerEmails] = useState(() => new Set());
  const [viewersStatusLoading, setViewersStatusLoading] = useState(false);
  // Invite confirmation popup. null when closed; otherwise:
  //   { contributor, email, checking, foundUser, notFound, inviting }
  const [invitePopup, setInvitePopup] = useState(null);
  const [contributions, setContributions] = useState([]);
  const [fetchingContributors, setFetchingContributors] = useState(false);
  const [fetchingContributions, setFetchingContributions] = useState(false);
  const [selectedContributions, setSelectedContributions] = useState([]);
  const [publishingContributions, setPublishingContributions] = useState(false);
  // Folder-level view toggle: 'contributions' shows every contribution in the
  // folder (default), 'contributors' shows the per-contributor folder cards.
  const [sharedFolderView, setSharedFolderView] = useState('contributions');
  const [showPublishSettingsModal, setShowPublishSettingsModal] = useState(false);
  // Copy Link / reactivate state for the Shared tab folder header
  const [copiedFolderLink, setCopiedFolderLink] = useState(false);
  const [showReactivatePopup, setShowReactivatePopup] = useState(false);
  const [reactivatingFolder, setReactivatingFolder] = useState(false);
  // Shared-tab folder edit — reuses the shared UploadLinkModal (edit view).
  const [showEditFolderModal, setShowEditFolderModal] = useState(false);

  // Drag and drop state
  const [isDragActive, setIsDragActive] = useState(false);
  const [selectedVideoForPanel, setSelectedVideoForPanel] = useState(null);
  const [canICall, setCanICall] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const isSearchPending = searchTerm !== debouncedSearchTerm;

  useEffect(() => {
    if (searchTerm === debouncedSearchTerm) return undefined;
    const handle = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);
    return () => clearTimeout(handle);
  }, [searchTerm, debouncedSearchTerm]);
  const temp = {};
  const directoryHandleRef = useRef(null);
  const isPickerOpenRef = useRef(false);
  console.log('edited item', editItems);

  // Reorder state
  const [reorderLoading, setReorderLoading] = useState(false);
  const reorderedContentRef = useRef(null);

  // Track upload statuses from new upload manager
  const [uploadStatuses, setUploadStatuses] = useState({});
  const { isValidating: fetchingGetMyContent, mutate: fetchContent } = useSWR(
    // Skip fetching for Shared tab (tabTitle === 2) - it uses contribution APIs instead
    isSearchPending || (tabTitle === 1 && selectedAlbumFilter) || tabTitle === 2
      ? null
      : [
        endpoints.getMyContentsBasedOnUploadDate,
        profileID,
        order,
        sortBy,
        selectedPage,
        debouncedSearchTerm,
        selectedCategoryFilter?.value || selectedOption?.value,
      ],
    {
      fetcher: (url, user_id, order_by, sort_by, page, search, category) => dataFetcher(url, {
        user_id,
        // Layout Order: always request order_by 1 so the BE returns the
        // reversed layout order (matches content-layout/viewer pages).
        // The local `order` state stays 1 to keep the dropdown value intact.
        order_by: sort_by === 'order_number' ? 1 : order_by,
        sort_by,
        page,
        search,
        category,
      }),
      onSuccess: ({ success, data, paginate }) => {
        // Stale-response guard: if the user switched tabs since this fetch was
        // issued, the response shape no longer matches the active renderers.
        // Dropping it prevents the blank-screen race when navigating fast.
        if (lastFetchTabRef.current !== undefined && lastFetchTabRef.current !== tabTitle) {
          return;
        }
        // Only set content for Videos (0) and Albums (1) tabs
        if (tabTitle === 0) {
          setContent(data?.video || []); // Use the `video` array
        } else if (tabTitle === 1) {
          setContent(data?.album || []); // Use the `album` array
        }
        // tabTitle === 2 (Shared) is handled separately via contribution APIs
        setIsDummyLoader(false);
        setAllvideoData(data);
        setDataLoader(false);
        setLoading(false);
        setSelectAllChecked(false);
        if (success) {
          // if (!isEqual(allContent, data)) {
          setAllContent(data);
          setTimeout(() => {
            setIsContentLoaded(true);
          }, 1000);
          // }
          setPaginatedData(paginate);
          setVideoProcessingList(
            tabTitle === 0 ? data?.videos_in_progress : data?.albums_in_progress
          );
          setAlbumProcessingList(data?.albums_in_progress);
        }
      },
      onError: () => { },
    }
  );
  const formatFileSize = (sizeStr) => {
    if (!sizeStr) return '0 MB';
    const sizeMB = parseFloat(sizeStr); // convert string to number
    if (sizeMB >= 1024) {
      const sizeGB = (sizeMB / 1024).toFixed(2);
      return `${sizeGB} GB`;
    }
    return `${sizeMB.toFixed(2)} MB`;
  };
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const databaseRefD = ref(firebaseDatabase, 'local-transcorder');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  const closeToast = (draft_id, message, type) => {
    toast.update(draft_id, {
      closeButton: false,
      render: message,
      type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR,
      autoClose: 3000,
    });
    setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
  };
  const dispatch = useDispatch();
  const updateDummy = (dummy, status) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const tempRef = useRef({});
  const fetchData = () => {
    const uuidparam = uuid();
    const allFalse = Object.values(tempRef.current).every(
      (value) => value === false
    );
    if (allFalse) {
      tempRef.current[uuidparam] = true;
      fetchContent()
        .then((res) => {
          tempRef.current[uuidparam] = false;
        })
        .catch((error) => {
          tempRef.current[uuidparam] = false;
        });
    }
  };
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };
  useEffect(() => {
    fetchData();
  }, [dummyObject]);

  // Fetch folders (contribution links) for Shared tab - include all statuses
  // (active, expired, revoked) so nothing is hidden.
  const fetchLinksList = async () => {
    setFetchingLinks(true);
    try {
      const response = await listLinks({ status: 'all' });
      if (response?.data?.success) {
        setLinks(response.data.links || []);
      } else {
        setLinks([]);
      }
    } catch (error) {
      console.error('Error fetching links:', error);
      setLinks([]);
    } finally {
      setFetchingLinks(false);
    }
  };

  // Fetch a single folder's contents just to derive its cover image. Returns
  // the raw contributions array (the hook extracts the first usable thumbnail).
  const fetchCoverContributions = useCallback(async (uuid) => {
    try {
      const response = await listContributions({ filter_by: 'uuid', value: uuid, uuid });
      if (response?.data?.success) {
        return response.data.contributions || [];
      }
    } catch (error) {
      console.error('Error fetching folder cover:', error);
    }
    return [];
  }, []);

  // Derive cover thumbnails for the folder cards. Only feed the hook while the
  // Shared folder list is actually on screen so we don't fire listContributions
  // for a tab the user isn't looking at.
  const coverLinks = SHARED_FEATURE_ENABLED && tabTitle === 2 && !selectedLink
    ? links
    : EMPTY_LINKS;
  const { covers: folderCovers } = useFolderCovers(coverLinks, fetchCoverContributions);

  // The Shared feature is behind SHARED_FEATURE_ENABLED. If the flag is off but
  // a stale sessionStorage value left us on the (now hidden) Shared tab, fall
  // back to the Videos tab so the user isn't stranded on an unreachable tab.
  useEffect(() => {
    if (!SHARED_FEATURE_ENABLED && tabTitle === 2) {
      setTabTitle(0);
    }
  }, [tabTitle, setTabTitle]);

  // Fetch folders when switching to Shared tab
  useEffect(() => {
    if (SHARED_FEATURE_ENABLED && tabTitle === 2) {
      fetchLinksList();
    }
  }, [tabTitle]);

  // Load every contribution in a folder (across all contributors) by its uuid
  const fetchFolderContributions = async (link) => {
    if (!link?.uuid) return;
    setFetchingContributions(true);
    try {
      const response = await listContributions({ filter_by: 'uuid', value: link.uuid, uuid: link.uuid });
      if (response?.data?.success) {
        setContributions(response.data.contributions || []);
      } else {
        setContributions([]);
      }
    } catch (error) {
      console.error('Error fetching folder contributions:', error);
      setContributions([]);
    } finally {
      setFetchingContributions(false);
    }
  };

  // Load the list of contributors for a folder
  const fetchFolderContributors = async (link) => {
    if (!link?.uuid) return;
    setFetchingContributors(true);
    try {
      const response = await listContributorsByLink({ uuid: link.uuid });
      if (response?.data?.success) {
        setContributors(response.data.contributors || []);
      } else {
        setContributors([]);
      }
    } catch (error) {
      console.error('Error fetching contributors by link:', error);
      setContributors([]);
    } finally {
      setFetchingContributors(false);
    }
  };

  // Handle folder (link) selection - loads folder content based on the active
  // folder view (all contributions by default, or the contributor list)
  const handleLinkSelect = async (link) => {
    setSelectedLink(link);
    // Reset the deeper levels whenever the folder changes
    setSelectedContributor(null);
    setSidebarContributor(null);
    setContributions([]);
    setContributors([]);
    setSelectedContributions([]);

    if (link) {
      if (sharedFolderView === 'contributors') {
        await fetchFolderContributors(link);
      } else {
        // "All Contents" view also needs the contributor list for the
        // right-sidebar filter.
        fetchFolderContributors(link);
        await fetchFolderContributions(link);
      }
    }
  };

  // Switch the folder-level view and (re)load the matching data for the
  // currently-selected folder
  const handleSharedFolderViewChange = (view) => {
    if (view === sharedFolderView) return;
    setSharedFolderView(view);
    setSelectedContributions([]);
    setSidebarContributor(null);
    if (selectedLink && !selectedContributor) {
      if (view === 'contributors') {
        setContributions([]);
        fetchFolderContributors(selectedLink);
      } else {
        // Keep the contributor list loaded for the sidebar filter.
        fetchFolderContributors(selectedLink);
        fetchFolderContributions(selectedLink);
      }
    }
  };

  // Right-sidebar filter select within the "All Contents" view. null = all
  // contributors; otherwise reload just that contributor's contributions.
  // We intentionally do NOT set selectedContributor, so the view chrome
  // (toggle, Select All, Publish) stays put — this only swaps the grid data.
  const handleSidebarContributorSelect = async (contributor) => {
    setSidebarContributor(contributor);
    setSelectedContributions([]);
    if (!selectedLink) return;
    // Uses filteringContributions (not fetchingContributions) so the grid
    // dims in place instead of the whole view collapsing to a skeleton.
    setFilteringContributions(true);
    try {
      const filterBy = contributor
        ? (contributor.contributor_email ? 'email' : 'uuid')
        : 'uuid';
      const value = contributor
        ? (contributor.contributor_email || contributor.uuid)
        : selectedLink.uuid;
      const response = await listContributions({ filter_by: filterBy, value, uuid: selectedLink.uuid });
      setContributions(response?.data?.success ? (response.data.contributions || []) : []);
    } catch (error) {
      setContributions([]);
    } finally {
      setFilteringContributions(false);
    }
  };

  // ── Add-as-viewer (invite) support for the contributor sidebar ──
  const isEmailAddress = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((s || '').trim());

  // Load current + pending viewers so each contributor row can show whether
  // they're already a viewer / pending, or offer the invite icon.
  const fetchViewerStatusLists = useCallback(async () => {
    setViewersStatusLoading(true);
    try {
      const [avRes, pvRes] = await Promise.all([
        getViewersList().catch(() => null),
        getPendingViewersList().catch(() => null),
      ]);
      const emailsOf = (res) => new Set(
        (res?.data?.data || [])
          .map((v) => (v.email || '').trim().toLowerCase())
          .filter(Boolean),
      );
      setViewerEmails(emailsOf(avRes));
      setPendingViewerEmails(emailsOf(pvRes));
    } finally {
      setViewersStatusLoading(false);
    }
  }, []);

  // 'viewer' | 'pending' | 'none' for a given contributor email.
  const getViewerStatusFor = (email) => {
    const e = (email || '').trim().toLowerCase();
    if (!e) return 'none';
    if (viewerEmails.has(e)) return 'viewer';
    if (pendingViewerEmails.has(e)) return 'pending';
    return 'none';
  };

  // Icon click → look the email up, then open the confirmation popup.
  const openInvitePopup = async (contributor) => {
    const email = (contributor.contributor_email || '').trim();
    if (!email) return;
    setInvitePopup({
      contributor, email, checking: true, foundUser: null, notFound: false, inviting: false,
    });
    try {
      const res = await searchUserToInvite({ email });
      const found = res?.data?.success && Array.isArray(res.data.data) && res.data.data.length > 0
        ? res.data.data[0]
        : null;
      setInvitePopup((prev) => (prev && prev.email === email
        ? { ...prev, checking: false, foundUser: found, notFound: !found }
        : prev));
    } catch (e) {
      setInvitePopup((prev) => (prev && prev.email === email
        ? { ...prev, checking: false, foundUser: null, notFound: true }
        : prev));
    }
  };

  const confirmInvite = async () => {
    if (!invitePopup || invitePopup.checking) return;
    const { email, foundUser } = invitePopup;
    setInvitePopup((prev) => (prev ? { ...prev, inviting: true } : prev));
    try {
      const data = foundUser
        ? [{
          id: foundUser.id,
          email: foundUser.email || email,
          firstname: foundUser.firstname || '',
          lastname: foundUser.lastname || '',
          image: foundUser.image || '',
          status: null,
          firstName: foundUser.firstname || '',
          lastName: foundUser.lastname || '',
        }]
        : [{
          email,
          id: email,
          status: null,
          firstname: '',
          lastname: '',
          firstName: '',
          lastName: '',
        }];
      const res = await addViewer({ data });
      if (res?.data?.success === false) {
        toast.error(res?.data?.message || 'Failed to send invite');
        setInvitePopup((prev) => (prev ? { ...prev, inviting: false } : prev));
        return;
      }
      // Optimistically mark pending, then re-sync from the server.
      setPendingViewerEmails((prev) => new Set(prev).add(email.toLowerCase()));
      setInvitePopup(null);
      toast.success('Invite sent');
      fetchViewerStatusLists();
    } catch (e) {
      toast.error('Failed to send invite');
      setInvitePopup((prev) => (prev ? { ...prev, inviting: false } : prev));
    }
  };

  // Load viewer status whenever the contributor sidebar is on screen.
  useEffect(() => {
    if (tabTitle === 2 && selectedLink && sharedFolderView === 'contributions') {
      fetchViewerStatusLists();
    }
  }, [tabTitle, selectedLink, sharedFolderView, fetchViewerStatusLists]);

  // Derive folder (link) status: 'revoked' | 'expired' | 'active'
  const getFolderStatus = (link) => {
    if (!link) return 'active';
    if (link.is_active === '0' || link.is_active === 0 || link.is_active === false) return 'revoked';
    if (link.is_expired === true || link.is_expired === 1 || link.is_expired === '1') return 'expired';
    return 'active';
  };

  // Copy the selected folder's share link to the clipboard
  const copyFolderLinkToClipboard = async (link) => {
    const url = link?.short_link || link?.link || '';
    if (!url) {
      toast.error('No share link available for this folder');
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopiedFolderLink(true);
      setTimeout(() => setCopiedFolderLink(false), 2000);
      toast.success('Folder link copied to clipboard');
    } catch (error) {
      console.error('Failed to copy folder link:', error);
      toast.error('Failed to copy link');
    }
  };

  // Copy Link button handler: active copies directly, revoked opens the
  // reactivate-and-copy confirmation popup.
  const handleCopyFolderLink = () => {
    const status = getFolderStatus(selectedLink);
    if (status === 'revoked') {
      setShowReactivatePopup(true);
      return;
    }
    copyFolderLinkToClipboard(selectedLink);
  };

  // Reactivate the revoked folder link, then copy it
  const handleReactivateAndCopy = async () => {
    if (!selectedLink?.uuid) return;
    setReactivatingFolder(true);
    try {
      const response = await reactivateContributionLink({ uuid: selectedLink.uuid });
      if (response?.data?.success === false) {
        toast.error(response?.data?.message || 'Failed to reactivate link');
        return;
      }
      // Reflect the reactivated state locally and in the folder list
      const updatedLink = { ...selectedLink, is_active: '1', is_expired: false };
      setSelectedLink(updatedLink);
      setLinks((prev) => prev.map((l) => (l.uuid === updatedLink.uuid ? { ...l, is_active: '1', is_expired: false } : l)));
      await copyFolderLinkToClipboard(updatedLink);
      setShowReactivatePopup(false);
    } catch (error) {
      console.error('Error reactivating folder link:', error);
      toast.error(error.response?.data?.message || 'Failed to reactivate link');
    } finally {
      setReactivatingFolder(false);
    }
  };

  // Open the edit-folder popup, pre-filled from the selected folder
  const openEditFolderModal = () => {
    if (!selectedLink?.uuid) return;
    setShowEditFolderModal(true);
  };

  // Called by UploadLinkModal after a successful edit. Patch the selected
  // link + the list locally so the UI reflects the change immediately.
  const handleFolderEdited = ({ uuid, label, expires_at }) => {
    const patch = {
      label,
      expires_at,
      ...(expires_at ? { is_expired: false } : {}),
    };
    setSelectedLink((prev) => (prev && prev.uuid === uuid ? { ...prev, ...patch } : prev));
    setLinks((prev) => prev.map((l) => (l.uuid === uuid ? { ...l, ...patch } : l)));
    toast.success('Folder updated');
  };

  // Handle contributor selection
  const handleContributorSelect = async (contributor) => {
    setSelectedContributor(contributor);

    if (contributor) {
      setFetchingContributions(true);
      try {
        const filterBy = contributor.contributor_email ? 'email' : 'uuid';
        const value = contributor.contributor_email || contributor.uuid;
        const response = await listContributions({ filter_by: filterBy, value, uuid: selectedLink?.uuid });
        if (response?.data?.success) {
          setContributions(response.data.contributions || []);
        } else {
          setContributions([]);
        }
      } catch (error) {
        console.error('Error fetching contributions:', error);
        setContributions([]);
      } finally {
        setFetchingContributions(false);
      }
    } else {
      setContributions([]);
    }
  };

  // Get thumbnail URL for contribution (use signed URLs)
  const getContributionThumbnail = (contrib) => {
    if (contrib.type === 'album') {
      // Prefer icon_signed, fallback to icon
      const iconSigned = contrib.payload?.payload?.icon_signed;
      if (iconSigned) {
        return iconSigned;
      }
      const icon = contrib.payload?.payload?.icon;
      if (icon) {
        return icon.startsWith('http') ? icon : `https://d1lnmqwvmebyqc.cloudfront.net/${icon}`;
      }
    } else if (contrib.type === 'video') {
      // For videos, use thumbnail_signed
      const thumbnailSigned = contrib.payload?.payload?.thumbnail_signed;
      if (thumbnailSigned) {
        return thumbnailSigned;
      }
      // Fallback to first item in thumbnail_list_signed
      const thumbnailsSigned = contrib.payload?.payload?.thumbnails_signed;
      if (thumbnailsSigned && thumbnailsSigned.length > 0) {
        return thumbnailsSigned[0];
      }
    }
    return AlterImage;
  };

  // Toggle contribution selection
  const toggleContributionSelection = (contributionId) => {
    setSelectedContributions((prev) => {
      if (prev.includes(contributionId)) {
        return prev.filter((id) => id !== contributionId);
      }
      return [...prev, contributionId];
    });
  };

  // Check if contribution is selected
  const isContributionSelected = (contributionId) => selectedContributions.includes(contributionId);

  // Get unpublished contributions (connected_source is empty)
  const unpublishedContributions = contributions.filter(
    (c) => !c.connected_source || c.connected_source === ''
  );

  // Select/Deselect all unpublished contributions
  const toggleSelectAllContributions = () => {
    const unpublishedIds = unpublishedContributions.map((c) => c.id);
    if (selectedContributions.length === unpublishedIds.length) {
      setSelectedContributions([]);
    } else {
      setSelectedContributions(unpublishedIds);
    }
  };

  // Clear selection when contributor changes
  useEffect(() => {
    setSelectedContributions([]);
  }, [selectedContributor]);

  // Publish selected contributions with settings from modal
  const publishSelectedContributions = async (settings) => {
    if (selectedContributions.length === 0) return;

    setPublishingContributions(true);
    setShowPublishSettingsModal(false);
    const selectedItems = contributions.filter((c) => selectedContributions.includes(c.id));

    // Check if using advanced settings (individual item settings)
    const useAdvanced = settings?.useAdvanced && settings?.items;

    try {
      const results = await Promise.all(
        selectedItems.map(async (contrib) => {
          const { payload } = contrib.payload;

          // Get individual item settings if using advanced mode
          // Match using uniqueKey which is set to (contrib.id || contrib.uuid) in PublishSettingsModal
          const contribKey = contrib.id || contrib.uuid;
          const itemSettings = useAdvanced
            ? settings.items.find((item) => item.uniqueKey === contribKey)
            : null;

          if (contrib.type === 'video') {
            // Publish video using V6/addVideo
            const formData = new FormData();
            formData.append('contribution_id', contrib.id || '');
            formData.append('uuid', contrib.uuid || '');
            formData.append('draft_id', payload.draft_id || '');

            // Use individual title if advanced mode, otherwise use payload title
            formData.append('title', itemSettings?.title || payload.title || '');

            // Use settings from modal for category
            if (itemSettings) {
              // Advanced mode: use individual item's category settings
              if (itemSettings.selectedCategory?.type === 'id' && itemSettings.selectedCategory?.value) {
                formData.append('category_id', itemSettings.selectedCategory.value);
                formData.append('category_name', '');
              } else {
                formData.append('category_id', '');
                formData.append('category_name', itemSettings.selectedCategory?.name || payload.category_name || '');
              }
            } else if (settings?.video?.category_id) {
              formData.append('category_id', settings.video.category_id);
              formData.append('category_name', '');
            } else {
              formData.append('category_id', '');
              formData.append('category_name', settings?.video?.category_name || payload.category_name || '');
            }

            formData.append('file_name', payload.file_name || '');
            formData.append('file_key', payload.file_key || '');
            formData.append('document_id', payload.document_id || '');
            formData.append('bucket_folder_path', payload.bucket_folder_path || payload.file_key || '');
            // Use individual description if advanced mode
            formData.append('description', itemSettings?.description || payload.description || '');
            formData.append('video_size', payload.video_size || '');

            // Use group_ids from individual settings or modal settings
            // Format: comma-separated string like "178,179,180"
            let videoGroupIds;
            if (itemSettings?.visibility === '3' && itemSettings?.selectedGroups?.length > 0) {
              videoGroupIds = itemSettings.selectedGroups.join(',');
            } else if (settings?.video?.group_ids?.length > 0) {
              videoGroupIds = settings.video.group_ids.join(',');
            } else {
              // Handle existing payload.group_ids (could be array or string)
              const existingIds = payload.group_ids;
              if (Array.isArray(existingIds)) {
                videoGroupIds = existingIds.join(',');
              } else if (typeof existingIds === 'string' && existingIds !== '[]') {
                // Already a string, use as-is (but strip brackets if JSON array string)
                videoGroupIds = existingIds.replace(/^\[|\]$/g, '');
              } else {
                videoGroupIds = '';
              }
            }
            formData.append('group_ids', videoGroupIds);

            // Use visibility from individual settings or modal settings
            formData.append('visibility', itemSettings?.visibility || settings?.video?.visibility || payload.visibility || '1');
            formData.append('subcategory_id', payload.subcategory_id || '');
            formData.append('playlist_ids', payload.playlist_ids || '');
            formData.append('videoHeight', payload.videoHeight || '');
            formData.append('videoWidth', payload.videoWidth || '');
            formData.append('videoOreintation', payload.videoOreintation || '');
            formData.append('s3_status', 'completed');

            // Use S3 paths for thumbnails
            // In advanced mode, use the selected thumbnail from itemSettings
            const selectedThumbnail = itemSettings?.thumbnail || payload.thumbnail;
            if (selectedThumbnail) {
              formData.append('thumbnails_s3_path', selectedThumbnail);
            }
            if (payload.thumbnails && payload.thumbnails.length > 0) {
              formData.append('thumbnail_list_s3_paths', JSON.stringify(payload.thumbnails));
            }

            const response = await axios.post(endpoints.addVideo, formData);
            return { success: response?.data?.success, type: 'video', title: itemSettings?.title || payload.title };
          }

          if (contrib.type === 'album') {
            // Publish album using createAndAttachAlbum
            // Photos need to have path (S3 key), size, and name - not signed URLs
            const photosData = (payload.photos || []).map((photo) => ({
              path: photo.path,
              size: String(photo.size || '0'),
              name: photo.name || '',
            }));

            // Use group_ids from individual settings or modal settings
            // Format: comma-separated string like "178,179,180"
            let albumGroupIds;
            if (itemSettings?.visibility === '3' && itemSettings?.selectedGroups?.length > 0) {
              albumGroupIds = itemSettings.selectedGroups.join(',');
            } else if (settings?.album?.group_ids?.length > 0) {
              albumGroupIds = settings.album.group_ids.join(',');
            } else {
              // Handle existing payload.group_ids (could be array or string)
              const existingIds = payload.group_ids;
              if (Array.isArray(existingIds)) {
                albumGroupIds = existingIds.join(',');
              } else if (typeof existingIds === 'string' && existingIds !== '[]') {
                albumGroupIds = existingIds.replace(/^\[|\]$/g, '');
              } else {
                albumGroupIds = '';
              }
            }

            const albumPayload = {
              contribution_id: contrib.id || '',
              uuid: contrib.uuid || '',
              // Use individual title if advanced mode
              title: itemSettings?.title || payload.title || '',
              // Use individual description if advanced mode
              description: itemSettings?.description || payload.description || '',
              // Use visibility from individual settings or modal settings
              visibility: itemSettings?.visibility || settings?.album?.visibility || payload.visibility || '2',
              group_id: albumGroupIds,
              icon: payload.icon || '',
              photos: photosData,
            };

            const response = await axios.post(endpoints.createAndAttachAlbum, albumPayload);
            return { success: response?.data?.success, type: 'album', title: itemSettings?.title || payload.title };
          }

          return { success: false, type: contrib.type, title: payload?.title };
        })
      );

      const successCount = results.filter((r) => r.success).length;
      const failCount = results.length - successCount;

      if (successCount > 0) {
        toast.success(`Successfully published ${successCount} item(s)`);
      }
      if (failCount > 0) {
        toast.error(`Failed to publish ${failCount} item(s)`);
      }

      // Clear selection and refresh
      setSelectedContributions([]);
      if (selectedContributor) {
        handleContributorSelect(selectedContributor);
      } else if (selectedLink) {
        // Folder-level "all contributions" view - reload the whole folder
        fetchFolderContributions(selectedLink);
      }
    } catch (error) {
      console.error('Error publishing contributions:', error);
      toast.error('Failed to publish contributions');
    } finally {
      setPublishingContributions(false);
    }
  };

  // Subscribe to upload manager for status updates (new system)
  useEffect(() => {
    if (UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM) {
      const unsubscribe = uploadManager.subscribe(({ uploads }) => {
        const statusMap = {};
        uploads.forEach((upload) => {
          statusMap[upload.draftId] = upload.status;
        });
        setUploadStatuses(statusMap);
      });

      return unsubscribe;
    }
  }, []);

  const handleEncouter = (draft_id) => {
    // Cancel upload in new system first (if using new system)
    if (UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM) {
      uploadManager.cancelUpload(draft_id);
    }

    const deletePromise = axios
      .post(`${baseUrl}/deleteDraftContent`, {
        token: getToken(),
        draft_id: [draft_id],
        content_id: [],
      })
      .then((response) => {
        // fetchContent();
        updateDummy(draft_id, 0);
        changeFieldFromFirebase(draft_id, 'DELETED');
        updateUploadPercentages(draft_id, 'Cancelled');
        closeToast(draft_id, 'Upload has been canceled by user', 'error');
        return response;
      })
      .catch((error) => {
        updateDummy(draft_id, 0);
        console.error(`Error deleting items for draftId ${draft_id}:`, error);
        throw error;
      });
  };
  // temp add
  useEffect(() => {
    setUploadPercentagesInNumber(uploadPercentages);
    // const allPropertiesAreNumericOrString = Object.values(uploadPercentages).some((value) => typeof value === 'number' || value === 'Starting Upload' || value === 'Initializing');
    //     if (allPropertiesAreNumericOrString) {
    //         setIamUploading(false);
    //       } else setIamUploading(true);
    const handleBeforeUnload = (e) => {
      const allPropertiesAreNumericOrString = Object.values(
        uploadPercentages
      ).some(
        (value) => typeof value === 'number'
          || value === 'Starting Upload'
          || value === 'Initializing'
      );
      if (allPropertiesAreNumericOrString) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [uploadPercentages]);

  // temp end
  /**
   * The draft array where progressing videos with are shown
   * The videodraftcontent where corresponsidng content of draft is shown
   * theres video_id and conte_id both same in these array, will be checkig both for some conditoins
   */
  const mergeDrafts = useMemo(() => {
    if (!allContent || !allContent?.videoDraftContents || !allContent?.draft) {
      return [];
    }

    const mergedItems = [];
    const draftLookup = {};

    if (allContent && allContent.videoDraftContents && allContent.draft) {
      allContent.draft.forEach((draft) => {
        draftLookup[draft.content_id] = draft;
      });

      allContent.videoDraftContents.forEach((videoDraftContent) => {
        const draftContent = draftLookup[videoDraftContent?.video_id];
        const mergedItem = draftContent
          ? { ...videoDraftContent, ...draftContent }
          : videoDraftContent;
        mergedItems.push(mergedItem);
      });
    }
    return allContent?.videoDraftContents;
  }, [allContent]);
  const { isValidating: deletingVideo, mutate: deleteVideo } = useSWR(
    [
      selectedType
        ? endpoints.deleteMyAlbum
        : (tabTitle === 2 || (tabTitle === 0 && !videoData?.status))
        && endpoints.deleteVideo,
      tabTitle === 2
        ? videoData?.draft_id
        : !singleEdit
          ? selectedItems?.map((item) => item?.id) || videoData?.content_id
          : videoData?.content_id || selectedItems,
    ],
    {
      fetcher: (url, id) => dataFetcher(
        url,
        selectedType
          ? { album_id: id }
          : tabTitle === 2 || (tabTitle === 0 && !videoData?.status)
            ? { draft_id: id }
            : { video_id: id }
      ),
      onSuccess: ({ success, data }) => {
        if (success) {
          // fetchContent();
          getSubscription();
          setModal(false);
          selectVideo(null);
          setTimeout(() => {
            setDataLoading(false);
          }, 2000);
          autoSignIn();
        }
      },
      onError: () => {
        autoSignIn();
        // fetchContent();
        getSubscription();
        setModal(false);
        selectVideo(null);
        setSelectAllChecked(false);
        setEditItems([]);
        setEditItemsStatus([]);
        setSelectedItems([]);
        setSelectedDraftIds([]);
        setSelectedContentIds([]);
        setTimeout(() => {
          setDataLoading(false);
        }, 2000);
      },
    }
  );
  /**
   * API for fetching selected content details
   *
   */

  const { isValidating: gettingContentDetails, mutate: getContentDetails } = useSWR(
    [
      tabTitle === 0
        ? content?.length && content[0].status
          ? endpoints.getVideosDetail
          : endpoints.getVideoDraftDetail
        : tabTitle === 2
          ? endpoints.getVideoDraftDetail
          : endpoints.getMyAlbumDetail,
      selectedVideo || selectedItems[0],
    ],
    {
      fetcher: (url, id) => dataFetcher(
        url,
        tabTitle === 0 || tabTitle === 2 ? { id } : { album_id: id }
      ),
      onSuccess: ({ success, data }) => {
        if (success) {
          let newData = tabTitle === 0 || tabTitle === 2 ? data : data[0];
          let matchdata = {};
          if (tabTitle === 2) {
            matchdata = allContent?.videoDraftContents.find(
              (x) => newData?.id === x?.draft_content_id
            );
            newData = {
              ...newData,
              description: matchdata.video_description,
              title: matchdata.title,
              playlist_id: matchdata.playlist_id,
              visibility: matchdata.visibility,
              category_id: matchdata.category_id,
            };
          }
          if (
            newData?.draft_id
            && newData?.draft_id?.slice(0, 9) !== 'old_video'
          ) {
            setSelectedDraftIds([newData?.draft_id]);
          } else {
            setSelectedContentIds([newData?.id]);
          }
          setContentDetails(newData);
          if (!singleEdit) {
            setEditLoader(false);
            setEditVideoModal(true);
          }
          setIsDummyLoader(false);
          if (isOpenModalinClick) {
            // setEditVideoModal(true);
          }
        } else {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message: 'Oops! Something went wrong',
          });
        }
      },
      onError: () => {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong',
        });
      },
    }
  );

  const fetchAlbumData = (selectedItems) => {
    setEditLoader(true);
    selectVideo(selectedItems);
    setswitchPoint(!switchPoint);
  };

  const showAlbumImages = (content_id) => {
    setEditLoader(true);
    const apiUrl = `${baseUrl}/getMyAlbumDetail`;
    const requestData = {
      album_id: content_id,
      token: getToken(),
    };
    // When viewing a specific album with a Name sort applied, honor it on expand.
    if (tabTitle === 1 && selectedAlbumFilter && sortBy === 'name') {
      requestData.sort_by = 'name';
      requestData.order_by = order === 1 ? 0 : 1;
    }
    axios
      .post(apiUrl, requestData)
      .then((response) => {
        setCallAlbum(response.data?.data);
        setEditLoader(false);
        setEditVideoModal(false);
      })
      .catch((error) => {
        setEditLoader(false);
        console.error('Error:', error);
      });
  };
  const handleButtonClick = (theId, status = null) => {
    setEditLoader(true);
    const requestBody = {
      id: theId,
      token: getToken(),
    };
    const f = content.filter((item) => item?.content_id === theId);
    const apiEndpoint = tabTitle === 0 && f[0]?.status
      ? `${baseUrl}/getVideosDetail`
      : `${baseUrl}/getVideoDraftDetail`;
    axios
      .post(apiEndpoint, requestBody)
      .then((response) => {
        setSelectedVideoContent(
          content?.filter(
            (item) => (tabTitle === 2
              ? item?.draft_content_id
              : item?.content_id || item?.video_id) === theId
          )
        );
        setContentDetails(response?.data?.data);
        setEditLoader(false);
        setEditVideoModal(true);
      })
      .catch((error) => {
        setEditLoader(false);
        setEditVideoModal(true);
        console.error('Error fetching content details:', error);
      });
  };
  useEffect(() => {
    Aos.init({ duration: 500, once: true });
    setIsDummyLoader(true);
  }, []);

  useEffect(() => {
    if (selectedVideo) {
      getContentDetails();
    }
  }, [selectedVideo, switchPoint]);

  useEffect(() => {
    if (
      modalShowPopUp
      && modalShowPopUp === '1'
      && !userDetails?.isSubscription
    ) {
      setOpenPopupModal(true);
    }
  }, [modalShowPopUp, subscriptionDetails]);

  useEffect(() => {
    if (quickUserModal !== '1') return undefined;

    const promotionVideoUrl = 'https://projector-optimized.s3.us-west-2.amazonaws.com/production/background-videos/Web.mp4';
    const preloader = document.createElement('video');
    preloader.src = promotionVideoUrl;
    preloader.muted = true;
    preloader.playsInline = true;
    preloader.preload = 'auto';
    preloader.style.cssText = 'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;left:-9999px;';
    document.body.appendChild(preloader);
    preloader.load();

    let opened = false;
    const openOnce = () => {
      if (opened) return;
      opened = true;
      setOpenPopupModal(true);
    };

    preloader.addEventListener('canplaythrough', openOnce);

    return () => {
      preloader.removeEventListener('canplaythrough', openOnce);
      preloader.src = '';
      preloader.remove();
    };
  }, [quickUserModal]);

  useEffect(() => {
    tempUploadPercentages = uploadPercentages;
  }, [uploadPercentages]);

  useEffect(() => {
    tempUploadSizes = uploadSizes;
  }, [uploadSizes]);
  const onDataChange = (id, changes = []) => {
    const changeObjects = {};

    changes.forEach(([key, value]) => {
      changeObjects[key] = value;
    });

    setVideoList(
      videoList.map((d) => ({ ...d, ...(id === d.id && changeObjects) }))
    );
  };

  const onMenuClose = () => {
    if (!handlingAction) {
      setCategoriesMenu(false);
      setEditMenu(undefined);
      setVisibilityMenu(undefined);
    }
  };

  function groupProcessing(array) {
    const noStatusItems = [];
    const itemsWithStatus = [];

    array?.length
      && array?.forEach((item) => {
        if (item.status === undefined) {
          noStatusItems.push(item);
        } else {
          itemsWithStatus.push(item);
        }
      });

    const sortedArray = [...noStatusItems, ...itemsWithStatus];
    // Find duplicate draft_id values
    const draftIds = sortedArray.reduce((acc, item) => {
      acc[item.draft_id] = (acc[item.draft_id] || 0) + 1;
      return acc;
    }, {});

    // Filter out items with duplicate draft_id and no status
    const filteredData = sortedArray.filter(
      (item) => !(draftIds[item.draft_id] > 1 && !item.status)
    );

    return filteredData;
  }
  const checkIfDraftIdExists = (allContent = {}, currentDummyObject) => {
    const {
      album = [],
      draft = [],
      video = [],
      videoDraftContents = [],
    } = allContent;
    const draftId = currentDummyObject?.draft_id;
    // Check if the draft_id exists in any of the arrays (album, draft, video, videoDraftContents)
    return (
      (Array.isArray(album)
        && album.some((item) => item?.draft_id === draftId))
      || (Array.isArray(draft)
        && draft.some((item) => item?.draft_id === draftId))
      || (Array.isArray(video)
        && video.some((item) => item?.draft_id === draftId))
      || (Array.isArray(videoDraftContents)
        && videoDraftContents.some((item) => item?.draft_id === draftId))
    );
  };
  const addDummyObject = () => {
    if (dummyObject && selectedIdType === undefined) {
      Object.keys(dummyObject).forEach((key) => {
        const currentDummyObject = dummyObject[key];
        const hasDraftID = content?.some(
          (item) => item?.draft_id === currentDummyObject?.draft_id
        );
        if (!hasDraftID) {
          if (
            content
            && currentDummyObject?.type === tabTitle
            && searchTerm === ''
          ) {
            setContent((prevContent) => [currentDummyObject, ...prevContent]);
            // fetchContent();
          }
        } else {
          const needUpdatedContent = content.some(
            (item) => item?.draft_id === currentDummyObject?.draft_id
              && item?.title === null
          );
          const isDraftIdPresent = checkIfDraftIdExists(
            allContent,
            currentDummyObject
          );
          if (isDraftIdPresent) {
            dispatch(removeDummy(currentDummyObject?.draft_id));
          }
          if (needUpdatedContent) {
            const updatedContent = content.filter(
              (item) => item?.draft_id !== currentDummyObject?.draft_id
                && item?.title !== null
            );
            setContent(updatedContent);
          }
        }
      });
    }
  };

  const toggleVideoSelection = (id, data, type, isEditing) => {
    setSelectAllChecked(false);
    setEditItems([]);
    setEditItemsStatus([]);
    setSelectedItems([]);
    setSelectedDraftIds([]);
    setSelectedContentIds([]);
    setTableContentLoading(false);
    setVisibilityMenu(undefined);
    setEditMenu(undefined);
    setCategoriesMenu(false);
    setSingleEdit(true);
    if (!singleEdit) {
      selectVideo();
    }
    if (tabTitle === 1) {
      setContent(allContent?.album);
    } else if (tabTitle === 0) {
      setContent(
        groupProcessing(
          allContent?.video.filter((obj) => obj.content_status !== 'Draft')
        )
      );
      // } else if (tabTitle === 2) {
      //   setContent(mergeDrafts);
    }
    // if already selected deselects
    if (selectedVideo === id) {
      selectVideo(undefined);
      setVideoData(undefined);
      selectType(undefined);
      setSelectedVideoContent();
    } else {
      selectVideo(id);
      setVideoData(data);
      selectType(type);
      setSelectedVideoContent(
        content?.filter(
          (item) => (tabTitle === 2
            ? item?.draft_content_id
            : item?.content_id || item?.video_id) === id
        )
      );
      setContent(
        content?.filter(
          (item) => (tabTitle === 2
            ? item?.draft_content_id
            : item?.content_id || item?.video_id) === id
        )
      );
    }
    if (isEditing) {
      setOpenModalinClick(isEditing);
      // setEditVideoModal(true);
    }
  };

  useEffect(() => {
    if (editMenu) {
      setCategoriesMenu(undefined);
    }
  }, [editMenu]);

  useEffect(() => {
    if (categoriesMenu) {
      setEditMenu(undefined);
    }
  }, [categoriesMenu]);

  useEffect(() => {
    setVisibilityMenu(undefined);
  }, []);
  useEffect(() => {
    const databaseRefGetVideos = ref(
      firebaseDatabase,
      `videos_updates/${localStorage.getItem('id')}`
    );
    const dataCallbackVideos = (snapshot) => {
      if (snapshot.exists()) {
        fetchData();
      }
    };
    onValue(databaseRefGetVideos, dataCallbackVideos);
    return () => {
      off(databaseRefGetVideos, 'value', dataCallbackVideos);
    };
  }, []);
  useEffect(() => {
    const databaseRefGetPhotos = ref(
      firebaseDatabase,
      `photo_album_updates/${localStorage.getItem('id')}`
    );
    const dataCallbackPhotos = (snapshot) => {
      if (snapshot.exists()) {
        fetchData();
      }
    };
    onValue(databaseRefGetPhotos, dataCallbackPhotos);
    return () => {
      off(databaseRefGetPhotos, 'value', dataCallbackPhotos);
    };
  }, []);
  useEffect(() => {
    const databaseRefGetVideosDraft = ref(
      firebaseDatabase,
      `draft_videos_updates/${localStorage.getItem('id')}`
    );
    const dataCallbackVideosDraft = (snapshot) => {
      if (snapshot.exists()) {
        fetchData();
      }
    };
    onValue(databaseRefGetVideosDraft, dataCallbackVideosDraft);
    return () => {
      off(databaseRefGetVideosDraft, 'value', dataCallbackVideosDraft);
    };
  }, []);
  useEffect(() => {
    fetchData();
  }, [
    sortBy,
    order,
    selectedPage,
    tabTitle,
    closeUploadModal,
    debouncedSearchTerm,
    textOfUpload,
  ]);

  // Trigger API call when category filter changes
  useEffect(() => {
    if (selectedCategoryFilter !== null || selectedCategoryFilter === null) {
      fetchContent();
    }
  }, [selectedCategoryFilter, fetchContent]);

  useEffect(() => {
    if (cancelSelection) {
      if (tabTitle === 1) {
        setContent(allContent?.album);
      } else if (tabTitle === 0) {
        setContent(
          groupProcessing(
            allContent?.video.filter((obj) => obj.content_status !== 'Draft')
          )
        );
      } else if (tabTitle === 2) {
        setContent(mergeDrafts);
      }
      setCancelSelection(false);
    }
  }, [cancelSelection]);

  useEffect(() => {
    setTableContentLoading(false);
    if (tabTitle === 1) {
      setContent(allContent?.album);
    } else if (tabTitle === 0 && !openEditVideoModal) {
      setContent(
        groupProcessing(
          allContent?.video.filter((obj) => obj.content_status !== 'Draft')
        )
      );
    } else if (tabTitle === 2 && allContent && allContent?.videoDraftContents) {
      const mergedContent = mergeDrafts || [];
      setContent(
        mergedContent.sort((a, b) => new Date(b.created) - new Date(a.created))
      );
      if (
        allContent
        && allContent?.videoDraftContents?.length > 0
        && allContent?.videoDraftContents[0]?.video_id === null
      ) {
        // fetchContent();
      }
      // if video already selected and when rerender happens make the selection persist
      if (selectedVideo) {
        const alreadySelectedItem = content?.filter(
          (item) => (tabTitle === 2
            ? item?.draft_content_id
            : item?.content_id || item?.video_id) === selectedVideo
        );
        setContent(alreadySelectedItem);
        if (!alreadySelectedItem) {
          selectedVideo(null);
        }
      }
    }
    setDraftContent(mergeDrafts);
  }, [tabTitle, allContent]);

  // Update album filter options when album data changes
  useEffect(() => {
    if (tabTitle === 1 && allContent?.album) {
      setAlbumFilterOptions(allContent.album);
    }
  }, [tabTitle, allContent?.album]);

  useEffect(() => {
    if (tabTitle === 1) {
      setPageCount(parseInt(paginatedData?.album?.no_of_pages, 10));
    } else if (tabTitle === 0) {
      setPageCount(parseInt(paginatedData?.video?.no_of_pages, 10));
    } else if (tabTitle === 2) {
      setPageCount(parseInt(paginatedData?.draft?.no_of_pages, 10));
    }
  });
  const { isValidating: fetchingCategoryFilter, mutate: fetchCategoryFilter } = useSWR([`${endpoints.getMyCategories}_filter`], {
    fetcher: (url) => dataFetcher(endpoints.getMyCategories),
    onSuccess: ({ success, data }) => {
      if (success) {
        setCategoryFilterOptions(
          data?.map(({ title: name, id: value }) => ({ name, value }))
        );
      }
    },
    onError: () => { },
  });
  useEffect(() => {
    const videosPage = document.getElementById('videos-page');

    const onScroll = () => {
      const preferencesBar = document.getElementById('menu-bar-table');

      if (preferencesBar?.offsetTop !== undefined) {
        if (window.pageYOffset > preferencesBar?.offsetTop) {
          videosPage?.classList.add(styles.fixedPreferenceContainer);
          videosPage.style.setProperty(
            '--menu-bar-width',
            `${videosPage.offsetWidth}px`
          );
        } else {
          videosPage?.classList.remove(styles.fixedPreferenceContainer);
        }
      } else {
        videosPage?.classList.remove(styles.fixedPreferenceContainer);
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  // Fetch categories on component mount and when categories are updated anywhere in the app
  useEffect(() => {
    fetchCategoryFilter();
  }, [categoryRefreshTrigger]);

  /**
   * Handler for sorting in subtitle
   *
   */
  const makeEveryThingNull = () => {
    setEditMenu(undefined);
    setSelectAllChecked(false);
    setEditItems([]);
    setEditItemsStatus([]);
    setSingleEdit(false);
    setSelectedContentIds([]);
    setSelectedDraftIds([]);
    setVisibilityMenu(false);
    setSelectedItems([]);
    setCategoriesMenu(false);
    selectVideo(undefined);
    setCancelSelection(true);
    setOpenEditInBulk(false);
  };

  const [removeSort, setRemoveSort] = useState(false);
  const sortHandler = (value) => {
    // Parse the combined value (e.g., "date-0" -> sortType="date", orderValue=0)
    const [sortType, orderValue] = value.split('-');

    setDataLoader(true);
    // Don't show cancel icon if selecting layout order on a category or album (it's the default)
    const isDefaultLayoutSort = sortType === 'order_number'
      && (selectedCategoryFilter || (tabTitle === 1 && selectedAlbumFilter));
    setRemoveSort(!isDefaultLayoutSort);
    setLoading(true);
    setSortBy(sortType);
    setOrder(parseInt(orderValue, 10)); // Set order: 0 for ascending, 1 for descending
    selectPage(1);

    setTimeout(() => {
      setLoading(false);
    }, 4000); // Replace 4000 with the actual time it takes to sort the table
  };
  const publishedInfo = `A video is considered Published once you have given it a title,
   description, assigned Categories and a Group who has access to view it`;
  const draftInfo = `A video is considered a Draft if you have not given it a title, 
  description, assigned Categories and a Group who has access to view it`;
  const privateInfo = 'A video is considered Private if it is only visible to you';
  /**
   * Handler for heading selection
   *
   */
  const resetFilters = () => {
    setDataLoader(true);
    setRemoveSort(false);
    // setFilter(false);
    setLoading(true);
    setOrder(0);
    setSortBy('date');
  };
  const handleSearchInputChange = (event) => {
    resetFilters();
    selectPage(1);
    setSelectAllChecked(false);
    setSelectedItems([]);
    setSelectedDraftIds([]); // Clear the selected draft IDs
    setSelectedContentIds([]);
    setSearchTerm(event?.target?.value);
  };
  const performSearch = () => {
    setSearchTerm('');
    setSelectAllChecked(false);
    setSelectedItems([]);
    setSelectedDraftIds([]); // Clear the selected draft IDs
    setSelectedContentIds([]);
  };
  const handleTabChange = (event, newValue) => {
    if (newValue !== tabTitle) {
      resetFilters();
      setSelectedItems([]);
      performSearch();
      setEditItems([]);
      setEditItemsStatus([]);
      setSelectAllChecked(false);
      setSelectedContentIds([]);
      setSelectedDraftIds([]);
      sessionStorage.removeItem('tabTitle');
      selectPage(1);
      // Clear stale content immediately so the previous tab's data shape
      // never renders against the new tab's renderers (caused blank screen
      // when switching from albums → videos with stale album content).
      setContent([]);
      setIsDummyLoader(true);
      lastFetchTabRef.current = newValue;
      // Reset Shared tab navigation (folder -> contributor -> files) on tab switch
      setSelectedLink(null);
      setSelectedContributor(null);
      setContributors([]);
      setContributions([]);
      setSelectedContributions([]);
      // setContent(null);
      setTabTitle(newValue);
      selectVideo(undefined);
      reorderedContentRef.current = null;
    }
  };
  const { isValidating: fetchingCategories, mutate: fetchCategories } = useSWR(
    [endpoints.getMyCategories],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: ({ success, data }) => {
        setIsDropdownOpen(!isDropdownOpen);
        if (success) {
          setCategrory(
            data?.map(({ title: name, id: value }) => ({ name, value }))
          );
        }
      },
      onError: () => { },
    }
  );

  // New category filter fetcher - separate from the existing one

  const options = [
    { label: 'Cancel Selection', value: '' }, // First option to cancel selection
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },
    { label: 'Option 3', value: 'option3' },
  ];

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleSelect = (value) => {
    setSelectedOption(value);
    setIsDropdownOpen(false); // Close dropdown on selection
  };

  // Handler for the new category filter
  const handleCategoryFilterSelect = (category) => {
    setSelectedCategoryFilter(category);
    selectPage(1); // Reset to first page when changing filter

    // Trigger immediate API call when category changes
    setTimeout(() => {
      fetchContent();
    }, 0);
  };
  // Handler for sidebar category selection
  const handleSidebarCategorySelect = (category) => {
    if (category) {
      // When a specific category is clicked, sort by order_number descending
      setDataLoader(true);
      setRemoveSort(false);
      setLoading(true);
      setOrder(1);
      setSortBy('order_number');
    } else {
      // "All Videos" clicked — reset to default date sort
      resetFilters();
    }
    setSelectedCategoryFilter(category);
    reorderedContentRef.current = null; // Clear any pending reorder
    selectPage(1); // Reset to first page when changing filter

    // Trigger immediate API call when category changes
    setTimeout(() => {
      fetchContent();
    }, 0);
  };

  // Handler for sidebar album selection
  const handleSidebarAlbumSelect = (album) => {
    setSelectedAlbumFilter(album);
    selectPage(1); // Reset to first page when changing filter

    // Filter content based on selected album
    if (album) {
      // Default to Layout Order (matches AlbumPhotosView's drag-and-drop order)
      setSortBy('order_number');
      setOrder(1);
      // Clear search since the search bar is hidden in this view
      setSearchTerm('');
      // Filter content to show only items from selected album
      const filteredContent = allContent?.album?.filter(
        (item) => item.content_id === album.content_id
      ) || [];
      setContent(filteredContent);
    } else {
      // Show all albums — restore default date sort
      setSortBy('date');
      setOrder(0);
      setContent(allContent?.album || []);
    }
  };

  // When entering album view (e.g., returning from Videos tab), handleTabChange
  // runs resetFilters() which sets sortBy='date'/order=0 — but 'date' isn't a
  // valid option in the album sort dropdown, so the Select renders as a blank
  // white box. Restore Layout Order (album view's default) so the dropdown
  // shows the right label and AlbumPhotosView fetches with the right sort.
  useEffect(() => {
    if (
      tabTitle === 1
      && selectedAlbumFilter
      && sortBy !== 'order_number'
      && sortBy !== 'name'
    ) {
      setSortBy('order_number');
      setOrder(1);
    }
  }, [tabTitle, selectedAlbumFilter]);

  // When viewing a specific album in list view, fetch photos via getMyAlbumDetail
  // with the current sort. The parent's getMyContentsBasedOnUploadDate SWR is
  // disabled in this case, so we fetch here and update callAlbum (used by PhotoList
  // when an album row is expanded). Also restores the album row to `content` (the
  // tab-change handler clears it) and closes the shimmer/loader on completion.
  useEffect(() => {
    if (!(tabTitle === 1 && selectedAlbumFilter && viewMode === 'list')) return;
    const albumId = selectedAlbumFilter.content_id;

    // Restore the single-album row so list view has something to render.
    // selectedAlbumFilter itself carries the album's metadata, so we don't need
    // to depend on allContent.album which may be stale after a tab switch.
    setContent([selectedAlbumFilter]);
    setIsDummyLoader(false);

    const payload = { album_id: albumId };
    if (sortBy === 'name') {
      payload.sort_by = 'name';
      payload.order_by = order === 1 ? 0 : 1;
    }
    let cancelled = false;
    setDataLoader(true);
    dataFetcher(endpoints.getMyAlbumDetail, payload)
      .then((res) => {
        if (cancelled) return;
        if (res?.success) {
          setCallAlbum(res.data || []);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (cancelled) return;
        setDataLoader(false);
        setLoading(false);
        setIsDummyLoader(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tabTitle, selectedAlbumFilter, sortBy, order, viewMode]);

  // Handler for viewing album photos
  const handleViewAlbumPhotos = (album) => {
    setSelectedAlbumForPhotos(album);
    setAlbumPhotosModalOpen(true);
  };

  // Handler for closing album photos modal
  const handleCloseAlbumPhotosModal = () => {
    setAlbumPhotosModalOpen(false);
    setSelectedAlbumForPhotos(null);
  };

  const SubTitle = ({ titleName, sortType, isTitle }) => (
    <div
      // onClick={() => sortHandler(sortType)}
      className={cn({ [styles.flexCenter]: true, [styles.flexLeft]: isTitle })}
    >
      {titleName}
      &nbsp;&nbsp;
    </div>
  );

  const hideModal = (val) => {
    if (val === 'edit') {
      selectVideo(undefined);
      setVideoData(undefined);
      selectType(undefined);
      // fetchContent();
    }
    // fetchContent(); called to update list
    setEditVideoModal(false);
  };

  const changeDateFormat = (date) => {
    if (date) {
      const [year, month, day] = date?.split('-');
      return `${month}/${day}/${year}`;
    }
  };

  // Grid of contribution cards - shared by the folder-level "all contributions"
  // view and the per-contributor files view
  const renderContributionsGrid = () => (
    <div className={`${styles.videoGrid} ${styles.contributionsGrid}`}>
      {contributions.map((contrib, index) => {
        const thumbnail = getContributionThumbnail(contrib);
        const { type } = contrib;
        const createdAt = contrib.created_at?.split(' ')[0];
        const formattedDate = changeDateFormat ? changeDateFormat(createdAt) : createdAt;
        // Contributions are submitted without a title (the owner titles them
        // later after approval). Empty or date-like placeholder titles are
        // hidden; the "Type · Date" line is promoted to primary instead.
        const displayTitle = resolveContributionTitle(contrib.payload?.payload?.title);
        const typeLabel = type === 'album' ? 'Album' : 'Video';
        const duration = contrib.payload?.payload?.duration;
        // video_size is in MB as string (e.g., "11.86"), photos have size in bytes
        const videoSize = contrib.payload?.payload?.video_size;
        const photosCount = contrib.payload?.payload?.photos?.length;
        const isSelected = isContributionSelected(contrib.id);
        // Check if already published (connected_source is not empty)
        const isPublished = contrib.connected_source && contrib.connected_source !== '';
        // In the folder-level "all contributions" view, surface who sent it —
        // but not when the list is already filtered to one contributor.
        const contributorLabel = (!selectedContributor && !sidebarContributor)
          ? (contrib.contributor_name || contrib.contributor_email)
          : null;

        // Format duration (seconds to MM:SS)
        const formatDuration = (seconds) => {
          if (!seconds) return null;
          const mins = Math.floor(seconds / 60);
          const secs = Math.floor(seconds % 60);
          return `${mins}:${secs.toString().padStart(2, '0')}`;
        };

        return (
          <div
            key={contrib.id || index}
            className={`${styles.videoCard} ${isSelected ? styles.selectedCard : ''} ${isPublished ? styles.publishedCard : ''}`}
            onClick={() => !isPublished && toggleContributionSelection(contrib.id)}
            style={{ cursor: isPublished ? 'default' : 'pointer' }}
          >
            <div className={styles.thumbnailContainer}>
              <img
                src={thumbnail}
                alt={displayTitle || typeLabel}
                className={styles.thumbnail}
                onError={(e) => {
                  e.target.src = AlterImage;
                }}
              />
              {/* Selection checkbox or Published badge */}
              {isPublished ? (
                <div className={styles.publishedBadge}>
                  Published
                </div>
              ) : (
                <div className={styles.selectionCheckbox}>
                  {isSelected ? (
                    <RadioButtonChecked style={{ color: '#5aa5ef' }} />
                  ) : (
                    <RadioButtonUnchecked style={{ color: '#fff' }} />
                  )}
                </div>
              )}
              <div className={styles.typeBadge}>
                {type === 'album' ? 'Album' : 'Video'}
              </div>
              {duration && (
                <div className={styles.durationBadge}>
                  {formatDuration(duration)}
                </div>
              )}
              {type === 'album' && photosCount > 0 && (
                <div className={styles.photosCountBadge}>
                  {`${photosCount} ${photosCount === 1 ? 'photo' : 'photos'}`}
                </div>
              )}
            </div>
            <div className={`${styles.cardContent} ${styles.contributionCardContent}`}>
              {/* No title (empty or date-like placeholder): render nothing for
                  the title line — just leave it empty. */}
              {displayTitle && (
                <h3 className={styles.videoTitle} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{displayTitle}</h3>
              )}
              <div className={styles.cardMeta}>
                {formattedDate && (
                  <span className={styles.cardDate}>{formattedDate}</span>
                )}
                {videoSize && (
                  <span className={styles.cardSize}>{`${videoSize} MB`}</span>
                )}
              </div>
              {contributorLabel && (
                <div className={styles.cardMeta}>
                  <span className={styles.cardDate}>{contributorLabel}</span>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );

  // Right sidebar for the "All Contents" view — "All contributors" (default)
  // plus one row per contributor. Selecting one filters the grid to just
  // their contributions.
  const renderContributorSidebar = () => {
    const keyOf = (c) => (c && (c.contributor_email || c.uuid)) || '';
    const selectedKey = keyOf(sidebarContributor);
    return (
      <aside className={styles.contributorSidebar}>
        <div className={styles.contributorSidebarTitle}>Contributors</div>
        <div className={`${styles.contributorSidebarItem} ${!sidebarContributor ? styles.contributorSidebarItemActive : ''}`}>
          <button
            type="button"
            className={styles.contributorSidebarSelect}
            onClick={() => handleSidebarContributorSelect(null)}
          >
            <span className={styles.contributorSidebarName}>All contributors</span>
          </button>
        </div>
        {contributors.map((c, i) => {
          const name = c.contributor_name || c.contributor_email || 'Unknown';
          const count = Number(c.contribution_count) || 0;
          const active = !!sidebarContributor && keyOf(c) === selectedKey;
          const email = (c.contributor_email || '').trim();
          const emailContributor = isEmailAddress(email);
          const viewerStatus = emailContributor ? getViewerStatusFor(email) : null;
          const busyForThis = invitePopup && invitePopup.email === email
            && (invitePopup.checking || invitePopup.inviting);
          return (
            <div
              key={keyOf(c) || i}
              className={`${styles.contributorSidebarItem} ${active ? styles.contributorSidebarItemActive : ''}`}
            >
              <button
                type="button"
                className={styles.contributorSidebarSelect}
                onClick={() => handleSidebarContributorSelect(c)}
                title={name}
              >
                <span className={styles.contributorSidebarName}>{name}</span>
                {count > 0 && <span className={styles.contributorSidebarCount}>{count}</span>}
              </button>
              {/* Viewer icon — email contributors only. Phone contributors
                  get an empty spacer so the count column stays aligned. */}
              {!emailContributor ? (
                <span className={styles.contributorViewerBtn} aria-hidden="true" />
              ) : (
                busyForThis ? (
                  <span className={styles.contributorViewerBtn} aria-hidden="true">
                    <CircularProgress size={15} style={{ color: '#065fd4' }} />
                  </span>
                ) : viewersStatusLoading ? (
                  <span className={styles.contributorViewerBtn} aria-hidden="true">
                    <CircularProgress size={15} style={{ color: '#c0c0c0' }} />
                  </span>
                ) : viewerStatus === 'viewer' ? (
                  <span
                    className={`${styles.contributorViewerBtn} ${styles.contributorViewerActive}`}
                    title="Already a viewer"
                  >
                    <IsViewerIcon style={{ fontSize: 18 }} />
                  </span>
                ) : viewerStatus === 'pending' ? (
                  <span
                    className={`${styles.contributorViewerBtn} ${styles.contributorViewerPending}`}
                    title="Viewer invite pending"
                  >
                    <PendingViewerIcon style={{ fontSize: 17 }} />
                  </span>
                ) : (
                  <button
                    type="button"
                    className={`${styles.contributorViewerBtn} ${styles.contributorViewerAdd}`}
                    onClick={() => openInvitePopup(c)}
                    title="Invite as viewer"
                    aria-label={`Invite ${name} as a viewer`}
                  >
                    <AddViewerIcon style={{ fontSize: 18 }} />
                  </button>
                )
              )}
            </div>
          );
        })}
      </aside>
    );
  };

  const downloadVideo = () => {
    setDownloading(true);
    axios({
      url: endpoints.downloadVideo,
      method: 'POST',
      data: { video_id: window.btoa(videoData?.content_id), token: getToken() },
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${videoData?.title}.${contentDetails?.extension}`
      );
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
      setTimeout(() => {
        setDownloading(false);
      }, 1000);
    }).catch((err) => {
      setDownloading(false);
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Download',
        description: 'Single video download failed',
        severity: 'high',
        errorMessage: err?.message || 'Single video download failed',
        requestUrl: endpoints.downloadVideo,
        requestMethod: 'POST',
        component: 'YourVideos',
        userAction: 'Single video download called',
      });
    });
  };

  const sanitizeName = (name) => {
    if (!name) return 'untitled';
    const sanitized = String(name)
      .normalize('NFKC')
      // eslint-disable-next-line no-control-regex
      .replace(/[\u0000-\u001F<>:"/\\|?*\u2028\u2029]+/g, '') // remove control and reserved chars
      .replace(/\s+/g, '_') // collapse whitespace
      .replace(/_{2,}/g, '_') // collapse multiple underscores
      .trim();
    return sanitized || 'untitled';
  };

  /**
   * processInBatches - process items with limited concurrency
   * @param {Array} items array of items
   * @param {number} batchSize concurrency
   * @param {(item) => Promise<void>} handler async handler for each item
   * @param {(processedCount:number) => void} [onProgress] called after each item finishes
   */
  const downloadInBatches = async ({
    allVideos,
    albumsWithPhotos,
    videosFolder,
    albumsFolder,
    setBulkDownloadProgress,
    setDownloadingFiles,
    batchSize = 10, // recommended batch size
  }) => {
    // Calculate number of items
    const totalPhotos = albumsWithPhotos.reduce(
      (sum, a) => sum + a.photos.length,
      0
    );
    const totalItems = allVideos.length + totalPhotos;

    const completedCount = { value: 0 };

    const updateProgress = () => {
      setBulkDownloadProgress({
        current: completedCount.value,
        total: totalItems,
      });
    };

    // Handler for processing a single photo
    const processPhoto = async (photo, index, i, albumFolder) => {
      try {
        const photoUrl = photo.photo_file || photo.url || photo.image;

        const response = await fetch(photoUrl);
        const blob = await response.blob();

        const ext = photoUrl.split('.').pop().split('?')[0] || 'jpg';
        const fileName = `photo_${i + index + 1}.${ext}`;

        const fileHandle = await albumFolder.getFileHandle(fileName, {
          create: true,
        });
        const writable = await fileHandle.createWritable();
        await writable.write(blob);
        await writable.close();

        completedCount.value += 1;
        updateProgress();
      } catch (err) {
        completedCount.value += 1; // still count failure
        updateProgress();
      }
    };

    // Handler for processing a single video
    const processVideo = async (video) => {
      const videoId = video.content_id || video.video_id;
      const title = video.title || `video_${videoId}`;
      const ext = video.extension || 'mp4';

      try {
        const response = await fetch(endpoints.downloadVideo, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            video_id: window.btoa(videoId),
            token: getToken(),
          }),
        });

        const blob = await response.blob();

        const fileHandle = await videosFolder.getFileHandle(
          `${title}.${ext}`,
          { create: true }
        );
        const writable = await fileHandle.createWritable();
        await writable.write(blob);
        await writable.close();

        completedCount.value += 1;
        updateProgress();

        setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
          ? { ...f, progress: 100, status: 'completed' }
          : f)));
      } catch (err) {
        completedCount.value += 1;
        updateProgress();
        logAppEvent({
          userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
          functionAffected: 'Download',
          description: `Bulk download failed for "${title}" (ID: ${videoId})`,
          severity: 'high',
          errorMessage: err?.message || 'Bulk video download failed',
          requestUrl: endpoints.downloadVideo,
          requestMethod: 'POST',
          component: 'YourVideos',
          userAction: 'Download video called',
        });
        setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId ? { ...f, status: 'error' } : f)));
      }
    };

    // -----------------------------
    // 1) Download albums (photos)
    // -----------------------------
    // eslint-disable-next-line no-restricted-syntax
    for (const album of albumsWithPhotos) {
      const albumTitle = album.title || `album_${album.content_id}`;
      const albumId = album.content_id;

      // Create album folder
      // eslint-disable-next-line no-await-in-loop
      const albumFolder = await albumsFolder.getDirectoryHandle(albumTitle, {
        create: true,
      });

      const { photos } = album;

      // Process photos in batches
      for (let i = 0; i < photos.length; i += batchSize) {
        const batch = photos.slice(i, i + batchSize);

        // eslint-disable-next-line no-await-in-loop
        await Promise.all(
          batch.map((photo, index) => processPhoto(photo, index, i, albumFolder))
        );
      }

      // Mark album as completed
      setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
        ? { ...f, progress: 100, status: 'completed' }
        : f)));
    }

    // -----------------------------
    // 2) Download videos in batches
    // -----------------------------
    for (let i = 0; i < allVideos.length; i += batchSize) {
      const batch = allVideos.slice(i, i + batchSize);

      // eslint-disable-next-line no-await-in-loop
      await Promise.all(batch.map((video) => processVideo(video)));
    }
  };
  async function downloadQueueManager(queue, concurrency, downloadFn, folder) {
    const state = { running: 0, index: 0 };

    return new Promise((resolve) => {
      const next = () => {
        if (bulkDownloadCancelRef.current) return resolve();
        if (state.index >= queue.length && state.running === 0) return resolve();

        while (state.running < concurrency && state.index < queue.length) {
          const video = queue[state.index];
          const videoId = video.content_id || video.video_id;
          state.index += 1;
          state.running += 1;

          // Immediately set status to downloading when starting
          setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
            ? { ...f, status: 'downloading' }
            : f)));

          downloadFn(video, folder)
            .finally(() => {
              state.running -= 1;
              next(); // start next immediately when any completes
            });
        }
      };

      next();
    });
  }

  /**
   * Main bulk download function.
   * Assumes component-level refs:
   *   const directoryHandleRef = useRef(null);
   *   const isPickerOpenRef = useRef(false);
   */
  // mode: 'videos' = only videos, 'photos' = only album photos, 'both' = everything
  const downloadMultipleVideos = async (mode = 'both') => {
    const downloadVideos = mode !== 'photos';
    const downloadPhotos = mode !== 'videos';

    // iOS/Safari fallback: File System Access API not supported
    // Download all videos & photos individually via blob + anchor tag
    if (typeof window.showDirectoryPicker !== 'function') {
      if (bulkDownloadCancelRef) {
        bulkDownloadCancelRef.current = false;
      }
      setIsBulkDownloading(true);
      setDownloadBox(true);
      setPreparingDownload(true);

      try {
        const videoPages = downloadVideos ? (paginatedData?.video?.no_of_pages || 1) : 0;
        const albumPages = downloadPhotos ? (paginatedData?.album?.no_of_pages || 1) : 0;
        let completedCount = 0;

        // Fetch and download videos page by page
        for (let page = 1; page <= videoPages; page += 1) {
          if (bulkDownloadCancelRef?.current) break;

          try {
            // eslint-disable-next-line no-await-in-loop
            const response = await dataFetcher(endpoints.getMyContentsBasedOnUploadDate, {
              user_id: profileID,
              order_by: order,
              sort_by: sortBy,
              page,
              search: searchTerm,
              category: selectedCategoryFilter?.value || selectedOption?.value,
            });
            const pageVideos = response.success && response.data?.video ? response.data.video : [];

            // Add this page's videos to tracking UI
            const newFiles = pageVideos.map((video) => ({
              id: video.content_id || video.video_id,
              name: video.title || `video_${video.content_id}`,
              fileName: video.video_file || video.title || `video_${video.content_id}.mp4`,
              progress: 0,
              status: 'pending',
              source: 'bulk',
              type: 'video',
            }));
            setDownloadingFiles((prev) => [...prev, ...newFiles]);
            setPreparingDownload(false);

            // Download each video one at a time
            // eslint-disable-next-line no-restricted-syntax
            for (const video of pageVideos) {
              if (bulkDownloadCancelRef?.current) break;

              const videoId = video.content_id || video.video_id;
              const title = sanitizeName(video.title || `video_${videoId}`);
              const ext = video.extension || 'mp4';

              // Create AbortController so Cancel All can abort the active fetch
              const controller = new AbortController();
              downloadAbortControllersRef.current.set(videoId, controller);

              setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                ? { ...f, status: 'downloading' }
                : f)));

              try {
                // eslint-disable-next-line no-await-in-loop
                const detailResponse = await getVideosDetail({ id: videoId });
                const videoDetails = detailResponse?.data?.success ? detailResponse?.data?.data : null;

                if (!videoDetails?.video_raw_file || videoDetails.video_raw_file.trim() === '') {
                  setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                    ? { ...f, status: 'error' }
                    : f)));
                  downloadAbortControllersRef.current.delete(videoId);
                  completedCount += 1;
                  // eslint-disable-next-line no-continue
                  continue;
                }

                // eslint-disable-next-line no-await-in-loop
                const fileResponse = await fetch(videoDetails.video_raw_file, { signal: controller.signal });
                if (!fileResponse.ok) throw new Error(`HTTP ${fileResponse.status}`);

                // Stream response to track download progress
                const contentLength = fileResponse.headers.get('content-length');
                const totalBytes = contentLength ? parseInt(contentLength, 10) : 0;
                const reader = fileResponse.body.getReader();
                const chunks = [];
                let receivedLength = 0;
                let streamCancelled = false;
                let lastReceivedLen = 0;
                let lastTs = Date.now();
                let curSpeed = 0;

                // eslint-disable-next-line no-constant-condition
                while (true) {
                  // Check cancel flag during streaming
                  if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
                    // eslint-disable-next-line no-await-in-loop
                    await reader.cancel();
                    streamCancelled = true;
                    break;
                  }

                  // eslint-disable-next-line no-await-in-loop
                  const { done, value } = await reader.read();
                  if (done) break;

                  chunks.push(value);
                  receivedLength += value.length;

                  // Calculate speed every 0.5s
                  const now = Date.now();
                  const td = (now - lastTs) / 1000;
                  if (td >= 0.5) {
                    curSpeed = (receivedLength - lastReceivedLen) / td;
                    lastReceivedLen = receivedLength;
                    lastTs = now;
                  }

                  const remBytes = totalBytes > 0 ? totalBytes - receivedLength : 0;
                  const etaVal = (curSpeed > 0 && remBytes > 0) ? Math.round(remBytes / curSpeed) : 0;

                  const dlProgress = totalBytes > 0 ? Math.round((receivedLength / totalBytes) * 100) : 0;
                  const capturedVideoId = videoId;
                  const spdSnap = curSpeed;
                  const etaSnap = etaVal;
                  const dlSnap = receivedLength;
                  setDownloadingFiles((prev) => prev.map((f) => (f.id === capturedVideoId
                    ? {
                      ...f,
                      progress: dlProgress,
                      status: 'downloading',
                      speed: spdSnap,
                      eta: etaSnap,
                      totalSize: totalBytes,
                      downloadedSize: dlSnap,
                    }
                    : f)));
                }

                downloadAbortControllersRef.current.delete(videoId);

                // If cancelled during streaming, skip saving
                if (streamCancelled) break;

                const videoMimeTypes = { mp4: 'video/mp4', mov: 'video/quicktime', avi: 'video/x-msvideo', webm: 'video/webm', mkv: 'video/x-matroska' };
                const blob = new Blob(chunks, { type: videoMimeTypes[ext] || 'video/mp4' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${title}.${ext}`;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                  URL.revokeObjectURL(url);
                  document.body.removeChild(a);
                }, 1000);

                setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                  ? { ...f, progress: 100, status: 'completed' }
                  : f)));
                completedCount += 1;

                // eslint-disable-next-line no-await-in-loop
                await new Promise((resolve) => setTimeout(resolve, 1500));
              } catch (err) {
                downloadAbortControllersRef.current.delete(videoId);

                // If aborted by cancel, don't log as error
                if (err.name === 'AbortError' || bulkDownloadCancelRef?.current) break;

                // eslint-disable-next-line no-console
                console.error(`Failed to download video ${videoId}:`, err);
                setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                  ? { ...f, status: 'error' }
                  : f)));
                completedCount += 1;
              }
            }
          } catch (fetchError) {
            // eslint-disable-next-line no-console
            console.error(`Failed to fetch video page ${page}:`, fetchError);
          }
        }

        // Fetch and download album photos page by page
        for (let page = 1; page <= albumPages; page += 1) {
          if (bulkDownloadCancelRef?.current) break;

          try {
            // eslint-disable-next-line no-await-in-loop
            const response = await dataFetcher(endpoints.getMyContentsBasedOnUploadDate, {
              user_id: profileID,
              order_by: order,
              sort_by: sortBy,
              page,
              search: searchTerm,
              category: selectedCategoryFilter?.value || selectedOption?.value,
            });
            const pageAlbums = response.success && response.data?.album ? response.data.album : [];

            // eslint-disable-next-line no-await-in-loop
            const albumsWithPhotos = await Promise.all(
              pageAlbums.map(async (album) => {
                try {
                  const albumDetail = await axios.post(`${baseUrl}/getMyAlbumDetail`, {
                    album_id: album.content_id,
                    token: getToken(),
                  });
                  const photos = albumDetail?.data?.data?.[0]?.photos || [];
                  return { ...album, photos };
                } catch (error) {
                  return { ...album, photos: [] };
                }
              })
            );

            // Add albums to tracking UI
            const albumFiles = albumsWithPhotos.map((album) => ({
              id: album.content_id,
              name: album.title || `album_${album.content_id}`,
              fileName: album.title || `album_${album.content_id}`,
              progress: 0,
              status: 'pending',
              source: 'bulk',
              totalPhotos: album.photos?.length || 0,
              type: 'photo',
            }));
            setDownloadingFiles((prev) => [...prev, ...albumFiles]);
            setPreparingDownload(false);

            // Download photos from each album
            // eslint-disable-next-line no-restricted-syntax
            for (const album of albumsWithPhotos) {
              if (bulkDownloadCancelRef?.current) break;

              const albumId = album.content_id;
              const albumTitle = sanitizeName(album.title || `album_${albumId}`);
              const photos = Array.isArray(album.photos) ? album.photos : [];

              setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                ? { ...f, status: 'downloading' }
                : f)));

              let completedPhotos = 0;

              // eslint-disable-next-line no-restricted-syntax
              for (const photo of photos) {
                if (bulkDownloadCancelRef?.current) break;

                const photoUrl = photo.photo_file || photo.url || photo.image;
                if (!photoUrl) {
                  completedPhotos += 1;
                  // eslint-disable-next-line no-continue
                  continue;
                }

                try {
                  const photoController = new AbortController();
                  downloadAbortControllersRef.current.set(`photo_${albumId}_${completedPhotos}`, photoController);

                  // eslint-disable-next-line no-await-in-loop
                  const photoResponse = await fetch(photoUrl, { signal: photoController.signal });
                  // eslint-disable-next-line no-await-in-loop
                  const blob = await photoResponse.blob();

                  downloadAbortControllersRef.current.delete(`photo_${albumId}_${completedPhotos}`);

                  const ext = photoUrl.split('.').pop().split('?')[0] || 'jpg';
                  const fileName = `${albumTitle}_photo_${completedPhotos + 1}.${ext}`;

                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = fileName;
                  a.style.display = 'none';
                  document.body.appendChild(a);
                  a.click();
                  setTimeout(() => {
                    URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                  }, 1000);

                  completedPhotos += 1;
                  completedCount += 1;

                  const currentCompleted = completedPhotos;
                  const albumProgress = Math.round((currentCompleted / photos.length) * 100);
                  setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                    ? { ...f, progress: albumProgress, status: currentCompleted === photos.length ? 'completed' : 'downloading' }
                    : f)));

                  // eslint-disable-next-line no-await-in-loop
                  await new Promise((resolve) => setTimeout(resolve, 1500));
                } catch (err) {
                  // If aborted by cancel, break out
                  if (err.name === 'AbortError' || bulkDownloadCancelRef?.current) break;

                  // eslint-disable-next-line no-console
                  console.error(`Failed to download photo from album ${albumId}:`, err);
                  completedPhotos += 1;
                  completedCount += 1;
                }
              }

              if (completedPhotos === photos.length) {
                setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                  ? { ...f, progress: 100, status: 'completed' }
                  : f)));
              }
            }
          } catch (fetchError) {
            // eslint-disable-next-line no-console
            console.error(`Failed to fetch album page ${page}:`, fetchError);
          }
        }

        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: bulkDownloadCancelRef?.current
            ? `Download canceled. ${completedCount} items downloaded`
            : `Download completed: ${completedCount} items downloaded successfully`,
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('iOS Bulk Download Error:', err);
        logAppEvent({
          userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
          functionAffected: 'Download',
          description: 'iOS bulk download failed with a fatal error',
          severity: 'high',
          errorMessage: err?.message || 'iOS bulk download fatal error',
          component: 'YourVideos',
          userAction: 'Bulk download called (iOS fallback)',
        });
        setAppSnackbar({ isVisible: true, type: 'error', message: 'Error during bulk download' });
      } finally {
        setPreparingDownload(false);
        setIsBulkDownloading(false);
        setBulkDownloadProgress({ current: 0, total: 0 });
        setPreparingProgress({ current: 0, total: 0 });
        setDownloadBatchProgress({ current: 0, total: 0 });
        setDownloadingFiles((prev) => {
          const remaining = prev.filter((f) => !(f.source === 'bulk' && (f.status === 'completed' || f.status === 'error' || f.status === 'cancelled')));
          if (remaining.length === 0) setDownloadBox(false);
          return remaining;
        });
      }

      return;
    }

    // 1️⃣ Directory picker MUST run immediately when button is clicked
    let directoryHandle;

    try {
      directoryHandle = await window.showDirectoryPicker({ mode: 'readwrite' });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Directory Picker Error =>', err);
      const isUserAbort = err?.name === 'AbortError';
      const isNotSupported = err?.name === 'NotSupportedError' || err?.name === 'TypeError' || !window.showDirectoryPicker;
      const pickerReason = isUserAbort
        ? 'User dismissed the directory picker'
        : isNotSupported
          ? 'File System Access API not supported on this device/browser (likely iOS Safari)'
          : `Directory picker failed: ${err?.name} — ${err?.message}`;
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Download',
        description: `Bulk download cancelled — ${pickerReason}`,
        severity: isUserAbort ? 'low' : 'high',
        errorMessage: err?.message || 'showDirectoryPicker failed',
        component: 'YourVideos',
        userAction: 'Multiple video download called',
      });
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Download canceled',
      });
      return; // ❗ Stop execution, can't proceed
    }

    // Store for later use
    directoryHandleRef.current = directoryHandle;

    // 2️⃣ Now safe to run async state updates
    setPreparingDownload(true);

    // Reset cancel flag (use ref for synchronous checking in loops)
    if (bulkDownloadCancelRef) {
      bulkDownloadCancelRef.current = false;
    }

    setIsBulkDownloading(true);

    try {
      // ----- CONVEYOR BELT PATTERN: Fetch page → Download immediately -----
      const videoPages = downloadVideos ? (paginatedData?.video?.no_of_pages || 1) : 0;
      const albumPages = downloadPhotos ? (paginatedData?.album?.no_of_pages || 1) : 0;

      // Debug: Log pagination data
      // eslint-disable-next-line no-console
      console.log('Download started - Pages:', { videoPages, albumPages, paginatedData });

      // 3️⃣ Create folders
      let videosFolder = directoryHandle;
      let albumsFolder = directoryHandle;

      if (videoPages > 0) {
        videosFolder = await directoryHandle.getDirectoryHandle('videos', { create: true });
      }

      if (albumPages > 0) {
        albumsFolder = await directoryHandle.getDirectoryHandle('albums', { create: true });
      }

      // Initialize download tracking
      let completedItems = 0;

      // Show download box - loader will be hidden by onDownloadPanelVisibleRef callback
      setDownloadBox(true);
      setBulkDownloadProgress({ current: 0, total: 0 }); // Will update as we discover items
      setDownloadBatchProgress({ current: 0, total: videoPages + albumPages });

      // Progress callback
      const updateUnifiedProgress = () => {
        completedItems += 1;
        setBulkDownloadProgress((prev) => ({ ...prev, current: completedItems }));
      };

      // Helper: Wait for internet connection to come back
      const waitForOnline = () => new Promise((resolve) => {
        if (navigator.onLine) {
          resolve();
          return;
        }
        const handleOnline = () => {
          window.removeEventListener('online', handleOnline);
          resolve();
        };
        window.addEventListener('online', handleOnline);
      });

      // Helper: Download single video with retry logic
      const downloadVideoWithRetry = async (video, videosFolder) => {
        const videoId = video.content_id || video.video_id;
        const title = sanitizeName(video.title || `video_${videoId}`);
        const ext = video.extension || 'mp4';

        // Fetch detailed video information to get video_raw_file URL
        let videoDetails;
        let detailAttempts = 0;
        const MAX_DETAIL_ATTEMPTS = 3;

        while (detailAttempts < MAX_DETAIL_ATTEMPTS) {
          // Wait for internet if offline
          if (!navigator.onLine) {
            // eslint-disable-next-line no-await-in-loop
            await waitForOnline();
          }

          try {
            // eslint-disable-next-line no-await-in-loop
            const detailResponse = await getVideosDetail({ id: videoId });
            if (detailResponse?.data?.success && detailResponse?.data?.data) {
              videoDetails = detailResponse.data.data;
              break; // Success, exit loop
            } else {
              detailAttempts += 1;
              if (detailAttempts >= MAX_DETAIL_ATTEMPTS) {
                logAppEvent({
                  userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
                  functionAffected: 'Download',
                  description: `Bulk download failed — getVideosDetail API returned no data for "${title}" (ID: ${videoId})`,
                  severity: 'high',
                  errorMessage: 'getVideosDetail returned no data after max attempts',
                  requestUrl: endpoints.getVideosDetail,
                  requestMethod: 'POST',
                  component: 'YourVideos',
                  userAction: 'Download video called',
                });
                setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                  ? { ...f, status: 'error' }
                  : f)));
                updateUnifiedProgress();
                return false;
              }
            }
          } catch (error) {
            // Check if network error
            const isNetworkError = !navigator.onLine
              || error.message?.includes('Failed to fetch')
              || error.message?.includes('network')
              || error.message?.includes('Network')
              || error.name === 'TypeError';

            if (isNetworkError) {
              // eslint-disable-next-line no-console
              console.log(`Network error fetching details for ${videoId}, waiting...`);
              // eslint-disable-next-line no-await-in-loop
              await waitForOnline();
              // Don't increment attempts for network errors
              // eslint-disable-next-line no-continue
              continue;
            }

            // eslint-disable-next-line no-console
            console.error(`Failed to fetch video details for ${videoId}:`, error);
            logAppEvent({
              userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
              functionAffected: 'Download',
              description: `Bulk download failed — getVideosDetail API failed for "${title}" (ID: ${videoId}) (attempt ${detailAttempts + 1})`,
              severity: 'high',
              errorMessage: error?.message || 'getVideosDetail failed',
              requestUrl: endpoints.getVideosDetail,
              requestMethod: 'POST',
              component: 'YourVideos',
              userAction: 'Download video called',
            });
            detailAttempts += 1;
            if (detailAttempts >= MAX_DETAIL_ATTEMPTS) {
              setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                ? { ...f, status: 'error' }
                : f)));
              updateUnifiedProgress();
              return false;
            }
          }
        }

        // Check if video_raw_file URL exists
        if (!videoDetails.video_raw_file || videoDetails.video_raw_file.trim() === '') {
          logAppEvent({
            userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
            functionAffected: 'Download',
            description: `Bulk download failed — no video_raw_file URL for "${title}" (ID: ${videoId})`,
            severity: 'high',
            errorMessage: 'video_raw_file URL is missing or empty',
            requestUrl: endpoints.getVideosDetail,
            requestMethod: 'POST',
            component: 'YourVideos',
            userAction: 'Download video called',
          });
          setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
            ? { ...f, status: 'error' }
            : f)));
          updateUnifiedProgress();
          return false;
        }

        let attempt = 0;
        const MAX_ATTEMPTS = 3;

        while (attempt < MAX_ATTEMPTS) {
          // Wait for internet if offline before attempting
          if (!navigator.onLine) {
            // eslint-disable-next-line no-await-in-loop
            await waitForOnline();
          }

          // Create fresh AbortController for each attempt
          const controller = new AbortController();
          downloadAbortControllersRef.current.set(videoId, controller);
          // Check if paused before each attempt
          if (pausedDownloadsRef.current.has(videoId)) {
            setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
              ? { ...f, status: 'paused' }
              : f)));

            // Register resume trigger so this video can be restarted when user clicks Resume
            resumeTriggersRef.current.set(videoId, () => {
              downloadVideoWithRetry(video, videosFolder);
            });

            return 'paused';
          }

          // Check if cancelled
          if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
            setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
              ? { ...f, status: 'cancelled' }
              : f)));
            // Don't increment completedItems for cancelled downloads
            return 'cancelled';
          }

          try {
            // eslint-disable-next-line no-await-in-loop
            const response = await fetch(videoDetails.video_raw_file, {
              method: 'GET',
              signal: controller.signal, // Add abort signal
            });

            // Check again before writing (download completed but before file write)
            if (pausedDownloadsRef.current.has(videoId)) {
              return 'paused';
            }

            if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
              updateUnifiedProgress();
              return 'cancelled';
            }

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Get total file size from headers
            const contentLength = response.headers.get('content-length');
            const total = contentLength ? parseInt(contentLength, 10) : 0;

            // Create file handle and writable stream BEFORE downloading
            // This allows us to write chunks directly to disk instead of storing in memory
            // eslint-disable-next-line no-await-in-loop
            const fileHandle = await videosFolder.getFileHandle(`${title}.${ext}`, { create: true });
            // eslint-disable-next-line no-await-in-loop
            const writable = await fileHandle.createWritable();

            // Read the response stream with progress tracking
            const reader = response.body.getReader();
            let receivedLength = 0;
            let lastReceivedLength = 0;
            let lastTimestamp = Date.now();
            let currentSpeed = 0;
            try {
              // eslint-disable-next-line no-constant-condition
              while (true) {
                // Check if offline before each chunk read
                if (!navigator.onLine) {
                  // eslint-disable-next-line no-await-in-loop
                  await reader.cancel();
                  // eslint-disable-next-line no-await-in-loop
                  await writable.abort();
                  throw new Error('Network offline');
                }

                // eslint-disable-next-line no-await-in-loop
                const { done, value } = await reader.read();

                if (done) break;

                // Write chunk directly to disk (stream-write approach)
                // This prevents memory overflow for large files
                // eslint-disable-next-line no-await-in-loop
                await writable.write(value);

                receivedLength += value.length;

                // Calculate speed and ETA
                const now = Date.now();
                const timeDiff = (now - lastTimestamp) / 1000; // in seconds
                if (timeDiff >= 0.5) { // Update speed every 500ms
                  const bytesDiff = receivedLength - lastReceivedLength;
                  currentSpeed = bytesDiff / timeDiff; // bytes per second
                  lastReceivedLength = receivedLength;
                  lastTimestamp = now;
                }

                const remainingBytes = total > 0 ? total - receivedLength : 0;
                const etaValue = (currentSpeed > 0 && remainingBytes > 0)
                  ? Math.round(remainingBytes / currentSpeed)
                  : 0;

                // Update progress with speed and ETA
                const progress = total > 0 ? Math.round((receivedLength / total) * 100) : 0;
                // Capture values to avoid unsafe references in callback
                const speedSnapshot = currentSpeed;
                const downloadedSnapshot = receivedLength;
                const etaSnapshot = etaValue;
                setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                  ? {
                    ...f,
                    progress,
                    status: 'downloading',
                    speed: speedSnapshot,
                    eta: etaSnapshot,
                    totalSize: total,
                    downloadedSize: downloadedSnapshot,
                  }
                  : f)));

                // Check for pause/cancel during download
                if (pausedDownloadsRef.current.has(videoId)) {
                  // eslint-disable-next-line no-await-in-loop
                  await reader.cancel();
                  // eslint-disable-next-line no-await-in-loop
                  await writable.abort();

                  // Register resume trigger so this video can be restarted when user clicks Resume
                  resumeTriggersRef.current.set(videoId, () => {
                    downloadVideoWithRetry(video, videosFolder);
                  });

                  return 'paused';
                }

                if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
                  // eslint-disable-next-line no-await-in-loop
                  await reader.cancel();
                  // eslint-disable-next-line no-await-in-loop
                  await writable.abort();
                  updateUnifiedProgress();
                  return 'cancelled';
                }
              }

              // Close the writable stream after all chunks are written
              // eslint-disable-next-line no-await-in-loop
              await writable.close();
            } catch (writeError) {
              // If writing fails, clean up and rethrow
              // eslint-disable-next-line no-await-in-loop
              await writable.abort().catch(() => { });
              throw writeError;
            }

            // Clean up abort controller on success
            downloadAbortControllersRef.current.delete(videoId);

            setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
              ? { ...f, progress: 100, status: 'completed' }
              : f)));

            updateUnifiedProgress();
            return true;
          } catch (error) {
            // Abort the current controller to clean up the stale connection
            try {
              controller.abort();
            } catch (abortErr) {
              // Ignore abort errors
            }

            // Check if error is due to abort (fetch throws AbortError)
            if (error.name === 'AbortError' || error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
              setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                ? { ...f, status: 'cancelled' }
                : f)));
              // Don't increment completedItems for cancelled downloads
              return 'cancelled';
            }

            // Check if it's a network error (offline)
            const isNetworkError = !navigator.onLine
              || error.message?.includes('Failed to fetch')
              || error.message?.includes('network')
              || error.message?.includes('Network')
              || error.message?.includes('offline')
              || error.message?.includes('NetworkError')
              || error.name === 'TypeError'; // fetch throws TypeError on network failure

            if (isNetworkError) {
              // eslint-disable-next-line no-console
              console.log(`Network error for ${videoId}, waiting for connection...`);
              // Wait for internet to come back, then retry (don't count as attempt)
              // eslint-disable-next-line no-await-in-loop
              await waitForOnline();
              // Don't increment attempt for network errors - just continue to retry
              // eslint-disable-next-line no-continue
              continue;
            }

            // Non-network error - increment attempt counter
            attempt += 1;

            // eslint-disable-next-line no-console
            console.error(`Failed to download video ${videoId} (attempt ${attempt}/${MAX_ATTEMPTS}):`, error.message || error);

            if (attempt >= MAX_ATTEMPTS) {
              downloadAbortControllersRef.current.delete(videoId);
              setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                ? { ...f, status: 'error' }
                : f)));
              logAppEvent({
                userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
                functionAffected: 'Download',
                description: `Video "${title}" (ID: ${videoId}) failed to download after ${MAX_ATTEMPTS} attempts — S3 fetch failed. S3 URL: ${videoDetails?.video_raw_file || 'unknown'}`,
                severity: 'high',
                errorMessage: error?.message || 'Multiple video download failed',
                responseStatus: error?.response?.status || null,
                responseBody: error?.response?.data?.message || null,
                requestUrl: videoDetails?.video_raw_file || endpoints.downloadVideo,
                requestMethod: 'GET',
                component: 'YourVideos',
                userAction: 'Multiple video download called',
              });
              updateUnifiedProgress();
              return false;
            }

            // Short delay before retry with fresh connection
            const delay = 1000; // 1 second before retry
            // eslint-disable-next-line no-await-in-loop
            await new Promise((resolve) => setTimeout(resolve, delay));
          }
        }

        downloadAbortControllersRef.current.delete(videoId);
        return false;
      };

      // 5️⃣ CONVEYOR BELT: Fetch pages and download concurrently
      if (videoPages > 0) {
        const videoQueue = []; // Each item: { video, pageNum }
        let downloadManagerPromise = null;
        let isDownloadManagerRunning = false;

        // Start download manager that continuously processes the queue
        const startDownloadManager = () => {
          if (isDownloadManagerRunning) return;
          isDownloadManagerRunning = true;

          downloadManagerPromise = (async () => {
            const state = { running: 0, index: 0 };

            await new Promise((resolve) => {
              const next = () => {
                if (bulkDownloadCancelRef.current) {
                  isDownloadManagerRunning = false;
                  return resolve();
                }

                // Start new downloads up to concurrency limit
                while (state.running < 2 && state.index < videoQueue.length) {
                  const { video, pageNum } = videoQueue[state.index];
                  const videoId = video.content_id || video.video_id;
                  state.index += 1;
                  state.running += 1;

                  // Update batch progress when item from a new page starts downloading
                  setDownloadBatchProgress((prev) => ({
                    ...prev,
                    current: Math.max(prev.current, pageNum)
                  }));

                  // Set status to downloading
                  setDownloadingFiles((prev) => prev.map((f) => (f.id === videoId
                    ? { ...f, status: 'downloading' }
                    : f)));

                  downloadVideoWithRetry(video, videosFolder)
                    .finally(() => {
                      state.running -= 1;
                      next(); // Start next immediately when any completes
                    });
                }

                // Check if we're done (no running downloads and processed all items)
                if (state.running === 0 && state.index >= videoQueue.length) {
                  // Check again after a small delay in case new items were added
                  setTimeout(() => {
                    if (state.index >= videoQueue.length && state.running === 0) {
                      isDownloadManagerRunning = false;
                      resolve();
                    } else {
                      next();
                    }
                  }, 100);
                }
              };

              next();
            });
          })();
        };

        // Fetch all pages and add to queue (downloads start as items are added)
        for (let page = 1; page <= videoPages; page += 1) {
          if (bulkDownloadCancelRef?.current) break;

          try {
            // eslint-disable-next-line no-await-in-loop
            const response = await dataFetcher(endpoints.getMyContentsBasedOnUploadDate, {
              user_id: profileID,
              order_by: order,
              sort_by: sortBy,
              page,
              search: searchTerm,
              category: selectedCategoryFilter?.value || selectedOption?.value,
            });

            const pageVideos = response.success && response.data?.video ? response.data.video : [];

            // Don't add items if download was cancelled
            if (bulkDownloadCancelRef?.current) break;

            // Add videos from this page to tracking UI
            const newVideoFiles = pageVideos.map((video) => ({
              id: video.content_id || video.video_id,
              name: video.title || `video_${video.content_id}`,
              fileName: video.video_file || video.title || `video_${video.content_id}.mp4`,
              progress: 0,
              status: 'pending',
              source: 'bulk',
              type: 'video',
            }));
            setDownloadingFiles((prev) => [...prev, ...newVideoFiles]);

            // Add to queue with page number - downloads will pick up new items automatically
            pageVideos.forEach((video) => {
              videoQueue.push({ video, pageNum: page });
            });

            // Start download manager if not already running
            startDownloadManager();
          } catch (fetchError) {
            // Network error while fetching page - log and continue with existing queue
            // eslint-disable-next-line no-console
            console.error(`Failed to fetch page ${page}:`, fetchError);
            // Don't break - continue trying other pages or let existing downloads complete
          }
        }

        // Wait for all downloads to complete
        if (downloadManagerPromise) {
          await downloadManagerPromise;
        }
      }

      // 6️⃣ CONVEYOR BELT: Fetch albums page by page → Fetch photos → Download photos
      if (albumPages > 0 && !bulkDownloadCancelRef?.current) {
        for (let page = 1; page <= albumPages; page += 1) {
          // Check if cancel all was triggered
          if (bulkDownloadCancelRef?.current) {
            break;
          }

          // Update batch progress - currently processing this album page
          setDownloadBatchProgress((prev) => ({ ...prev, current: videoPages + page }));

          let pageAlbums = [];
          try {
            // Fetch album page
            // eslint-disable-next-line no-await-in-loop
            const response = await dataFetcher(endpoints.getMyContentsBasedOnUploadDate, {
              user_id: profileID,
              order_by: order,
              sort_by: sortBy,
              page,
              search: searchTerm,
              category: selectedCategoryFilter?.value || selectedOption?.value,
            });

            pageAlbums = response.success && response.data?.album ? response.data.album : [];
          } catch (fetchError) {
            // Network error while fetching album page - log and continue
            // eslint-disable-next-line no-console
            console.error(`Failed to fetch album page ${page}:`, fetchError);
            // eslint-disable-next-line no-continue
            continue;
          }

          if (pageAlbums.length === 0) {
            // eslint-disable-next-line no-continue
            continue;
          }

          // Fetch album details immediately for this page
          // eslint-disable-next-line no-await-in-loop
          const albumsWithPhotos = await Promise.all(
            pageAlbums.map(async (album) => {
              try {
                const albumDetail = await axios.post(`${baseUrl}/getMyAlbumDetail`, {
                  album_id: album.content_id,
                  token: getToken(),
                });

                const photos = albumDetail?.data?.data?.[0]?.photos || [];
                return { ...album, photos };
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Failed to fetch details for album ${album.content_id}:`, error);
                return { ...album, photos: [] };
              }
            })
          );

          // Don't add items if download was cancelled
          if (bulkDownloadCancelRef?.current) break;

          // Add to tracking UI
          const newAlbumFiles = albumsWithPhotos.map((album) => ({
            id: album.content_id,
            name: album.title || `album_${album.content_id}`,
            fileName: album.title || `album_${album.content_id}`,
            progress: 0,
            status: 'pending',
            source: 'bulk',
            totalPhotos: album.photos?.length || 0,
            type: 'photo',
          }));
          setDownloadingFiles((prev) => [...prev, ...newAlbumFiles]);

          // Update total count with actual photo counts
          const photosCount = albumsWithPhotos.reduce((sum, a) => sum + (a.photos?.length || 0), 0);
          setBulkDownloadProgress((prev) => ({ ...prev, total: prev.total + photosCount }));

          // Download photos for each album immediately
          // eslint-disable-next-line no-restricted-syntax
          for (const album of albumsWithPhotos) {
            // Check cancel before processing each album
            if (bulkDownloadCancelRef?.current) {
              break;
            }

            const albumId = album.content_id;
            const albumTitle = sanitizeName(album.title || `album_${albumId}`);

            // Check if album is paused
            if (pausedDownloadsRef.current.has(albumId)) {
              setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                ? { ...f, status: 'paused' }
                : f)));
            } else {
              setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                ? { ...f, status: 'downloading' }
                : f)));

              // Create AbortController for album
              const albumController = new AbortController();
              downloadAbortControllersRef.current.set(albumId, albumController);

              try {
                // Create album subfolder
                // eslint-disable-next-line no-await-in-loop
                const albumFolderHandle = await albumsFolder.getDirectoryHandle(albumTitle, { create: true });

                const photos = Array.isArray(album.photos) ? album.photos : [];
                const PHOTO_BATCH_SIZE = 2; // Download 2 photos at a time
                const completedPhotosCount = { value: 0 };

                for (let i = 0; i < photos.length; i += PHOTO_BATCH_SIZE) {
                  // Check if cancelled or paused
                  if (bulkDownloadCancelRef?.current || albumController.signal.aborted || pausedDownloadsRef.current.has(albumId)) {
                    break;
                  }

                  const batch = photos.slice(i, i + PHOTO_BATCH_SIZE);

                  // eslint-disable-next-line no-await-in-loop
                  await Promise.all(
                    batch.map(async (photo, batchIndex) => {
                      try {
                        // Check pause/cancel before each photo
                        if (bulkDownloadCancelRef?.current || albumController.signal.aborted || pausedDownloadsRef.current.has(albumId)) {
                          return;
                        }

                        const photoUrl = photo.photo_file || photo.url || photo.image;
                        if (!photoUrl) {
                          completedPhotosCount.value += 1;
                          updateUnifiedProgress();
                          return;
                        }

                        const photoIndex = i + batchIndex + 1;
                        const ext = photoUrl.split('.').pop().split('?')[0] || 'jpg';
                        const photoFileName = `photo_${photoIndex}.${ext}`;

                        const response = await fetch(photoUrl, {
                          signal: albumController.signal, // Add abort signal
                        });

                        const blob = await response.blob();

                        const fileHandle = await albumFolderHandle.getFileHandle(photoFileName, { create: true });
                        const writable = await fileHandle.createWritable();
                        await writable.write(blob);
                        await writable.close();

                        completedPhotosCount.value += 1;

                        const albumProgress = Math.round((completedPhotosCount.value / photos.length) * 100);
                        setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                          ? { ...f, progress: albumProgress, status: completedPhotosCount.value === photos.length ? 'completed' : 'downloading' }
                          : f)));

                        updateUnifiedProgress();
                      } catch (error) {
                        // Check if error is due to abort (fetch throws AbortError)
                        if (error.name === 'AbortError' || error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
                          return;
                        }

                        // eslint-disable-next-line no-console
                        console.error(`Failed to download photo from album ${albumId}:`, error);

                        completedPhotosCount.value += 1;
                        updateUnifiedProgress();
                      }
                    })
                  );
                }

                // Clean up controller
                downloadAbortControllersRef.current.delete(albumId);

                // Mark album as completed
                setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                  ? { ...f, status: 'completed', progress: 100 }
                  : f)));
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Failed to process album ${albumId}:`, error);
                logAppEvent({
                  userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
                  functionAffected: 'Download',
                  description: `Bulk download failed — album download failed (ID: ${albumId})`,
                  severity: 'high',
                  errorMessage: error?.message || 'Album download failed',
                  component: 'YourVideos',
                  userAction: 'Download video called',
                });
                setDownloadingFiles((prev) => prev.map((f) => (f.id === albumId
                  ? { ...f, status: 'error' }
                  : f)));
              }
            }
          }
        }
      }

      // eslint-disable-next-line no-console
      console.log('Download completed! Total items:', completedItems);

      // Check if download was cancelled
      if (bulkDownloadCancelRef?.current) {
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: `Download canceled. ${completedItems} items downloaded`,
        });
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: `Download completed: ${completedItems} items downloaded successfully`,
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Bulk Download Fatal Error:', err);
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Download',
        description: 'Bulk download failed with a fatal error',
        severity: 'high',
        errorMessage: err?.message || 'Bulk download fatal error',
        errorStack: err?.stack || null,
        component: 'YourVideos',
        userAction: 'Bulk download called',
      });
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Error during bulk download',
      });
    } finally {
      setPreparingDownload(false);
      setIsBulkDownloading(false);
      setBulkDownloadProgress({ current: 0, total: 0 });
      setPreparingProgress({ current: 0, total: 0 });
      setDownloadBatchProgress({ current: 0, total: 0 });

      // Remove only bulk-sourced completed/error items, preserve other active downloads
      setDownloadingFiles((prev) => {
        const remaining = prev.filter((f) => !(f.source === 'bulk' && (f.status === 'completed' || f.status === 'error' || f.status === 'cancelled')));
        if (remaining.length === 0) {
          setDownloadBox(false);
        }
        return remaining;
      });
    }
  };

  /**
   * Download only the selected videos from the sidebar panel.
   * Uses the same download logic as downloadMultipleVideos but only for selected items.
   */
  const downloadSelectedVideos = async (videosToDownload) => {
    if (!videosToDownload || videosToDownload.length === 0) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'No videos selected for download',
      });
      return;
    }

    // iOS/Safari fallback: File System Access API not supported
    // Shows bottom sheet with progress bar, same as bulk download
    if (typeof window.showDirectoryPicker !== 'function') {
      // Reset cancel flag so previous cancellations don't block this download
      if (bulkDownloadCancelRef) {
        bulkDownloadCancelRef.current = false;
      }

      setPreparingDownload(true);
      setDownloadBox(true);

      const batchTimestamp = Date.now();
      const trackingEntries = videosToDownload.map((video, idx) => ({
        id: `${video.content_id || video.video_id}_${batchTimestamp}_${idx}`,
        videoId: video.content_id || video.video_id,
        name: video.title || `video_${video.content_id || video.video_id}`,
        fileName: video.video_file || video.title || `video_${video.content_id || video.video_id}.mp4`,
        progress: 0,
        status: 'pending',
        source: 'bulk',
        type: 'video',
      }));
      setDownloadingFiles((prev) => [...prev, ...trackingEntries]);
      setPreparingDownload(false);

      let completedCount = 0;
      let wasCancelled = false;

      // eslint-disable-next-line no-restricted-syntax
      for (const entry of trackingEntries) {
        if (bulkDownloadCancelRef?.current) {
          wasCancelled = true;
          break;
        }

        setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
          ? { ...f, status: 'downloading' }
          : f)));

        // Create AbortController so Cancel All can abort the active fetch
        const controller = new AbortController();
        downloadAbortControllersRef.current.set(entry.id, controller);

        try {
          // eslint-disable-next-line no-await-in-loop
          const detailResponse = await getVideosDetail({ id: entry.videoId });
          const videoDetails = detailResponse?.data?.success ? detailResponse?.data?.data : null;

          if (!videoDetails?.video_raw_file || videoDetails.video_raw_file.trim() === '') {
            setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
              ? { ...f, status: 'error' }
              : f)));
            downloadAbortControllersRef.current.delete(entry.id);
            completedCount += 1;
            // eslint-disable-next-line no-continue
            continue;
          }

          // eslint-disable-next-line no-await-in-loop
          const response = await fetch(videoDetails.video_raw_file, { signal: controller.signal });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          // Stream the response to track download progress
          const contentLength = response.headers.get('content-length');
          const total = contentLength ? parseInt(contentLength, 10) : 0;
          const reader = response.body.getReader();
          const chunks = [];
          let receivedLength = 0;
          let lastReceivedLength = 0;
          let lastTimestamp = Date.now();
          let currentSpeed = 0;

          // eslint-disable-next-line no-constant-condition
          while (true) {
            // Check cancel flag during streaming
            if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
              // eslint-disable-next-line no-await-in-loop
              await reader.cancel();
              wasCancelled = true;
              break;
            }

            // eslint-disable-next-line no-await-in-loop
            const { done, value } = await reader.read();
            if (done) break;

            chunks.push(value);
            receivedLength += value.length;

            // Calculate speed every 0.5s
            const now = Date.now();
            const timeDiff = (now - lastTimestamp) / 1000;
            if (timeDiff >= 0.5) {
              const bytesDiff = receivedLength - lastReceivedLength;
              currentSpeed = bytesDiff / timeDiff;
              lastReceivedLength = receivedLength;
              lastTimestamp = now;
            }

            const remainingBytes = total > 0 ? total - receivedLength : 0;
            const etaValue = (currentSpeed > 0 && remainingBytes > 0)
              ? Math.round(remainingBytes / currentSpeed)
              : 0;

            const progress = total > 0 ? Math.round((receivedLength / total) * 100) : 0;
            const capturedId = entry.id;
            const speedSnapshot = currentSpeed;
            const etaSnapshot = etaValue;
            const downloadedSnapshot = receivedLength;
            setDownloadingFiles((prev) => prev.map((f) => (f.id === capturedId
              ? {
                ...f,
                progress,
                status: 'downloading',
                speed: speedSnapshot,
                eta: etaSnapshot,
                totalSize: total,
                downloadedSize: downloadedSnapshot,
              }
              : f)));
          }

          // If cancelled during streaming, skip saving
          if (wasCancelled) {
            downloadAbortControllersRef.current.delete(entry.id);
            break;
          }

          // Use video.extension (same as Chrome flow) or extract from URL
          const videoObj = videosToDownload.find((v) => (v.content_id || v.video_id) === entry.videoId);
          const ext = videoObj?.extension || (videoDetails.video_raw_file.split('?')[0].split('.').pop() || 'mp4').toLowerCase();
          const mimeTypes = { mp4: 'video/mp4', mov: 'video/quicktime', avi: 'video/x-msvideo', webm: 'video/webm', mkv: 'video/x-matroska' };
          const blob = new Blob(chunks, { type: mimeTypes[ext] || 'video/mp4' });
          const fileName = `${sanitizeName(entry.name)}.${ext}`;

          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 1000);

          downloadAbortControllersRef.current.delete(entry.id);

          setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
            ? { ...f, progress: 100, status: 'completed' }
            : f)));
          completedCount += 1;

          // Small delay between downloads so iOS Safari can register each one
          if (trackingEntries.length > 1) {
            // eslint-disable-next-line no-await-in-loop
            await new Promise((resolve) => setTimeout(resolve, 1500));
          }
        } catch (err) {
          downloadAbortControllersRef.current.delete(entry.id);

          // If aborted by cancel, don't log as error
          if (err.name === 'AbortError' || bulkDownloadCancelRef?.current) {
            wasCancelled = true;
            break;
          }

          // eslint-disable-next-line no-console
          console.error(`Failed to download video ${entry.videoId}:`, err);
          logAppEvent({
            userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
            functionAffected: 'Download',
            description: `iOS download failed for "${entry.name}" (ID: ${entry.videoId})`,
            severity: 'high',
            errorMessage: err?.message || 'iOS video download failed',
            component: 'YourVideos',
            userAction: 'Download video called (iOS fallback)',
          });
          setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
            ? { ...f, status: 'error' }
            : f)));
          completedCount += 1;
        }
      }

      if (wasCancelled) {
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: `Download canceled. ${completedCount} ${completedCount === 1 ? 'item' : 'items'} downloaded`,
        });
      } else {
        setAppSnackbar({
          isVisible: true,
          type: completedCount > 0 ? 'success' : 'error',
          message: completedCount > 0
            ? `Download completed: ${completedCount} video${completedCount !== 1 ? 's' : ''}`
            : 'Download failed',
        });
      }

      // Cleanup after 2s
      setTimeout(() => {
        setDownloadingFiles((prev) => {
          const remaining = prev.filter((f) => !trackingEntries.some((e) => e.id === f.id));
          if (remaining.length === 0) setDownloadBox(false);
          return remaining;
        });
      }, 2000);

      return;
    }

    const validVideos = videosToDownload;

    // 1. Directory picker MUST run immediately when button is clicked
    let directoryHandle;

    try {
      directoryHandle = await window.showDirectoryPicker({ mode: 'readwrite' });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Directory Picker Error =>', err);
      const isUserAbort = err?.name === 'AbortError';
      const isNotSupported = err?.name === 'NotSupportedError' || err?.name === 'TypeError' || !window.showDirectoryPicker;
      const pickerReason = isUserAbort
        ? 'User dismissed the directory picker'
        : isNotSupported
          ? 'File System Access API not supported on this device/browser (likely iOS Safari)'
          : `Directory picker failed: ${err?.name} — ${err?.message}`;
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Download',
        description: `Selected videos download cancelled — ${pickerReason}`,
        severity: isUserAbort ? 'low' : 'high',
        errorMessage: err?.message || 'showDirectoryPicker failed',
        component: 'YourVideos',
        userAction: 'Multiple selected videos download called',
      });
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Download canceled',
      });
      return;
    }

    // Store for later use
    directoryHandleRef.current = directoryHandle;

    // Close the panel once download starts (directory picked successfully)
    setSelectedItems([]);
    setSelectAllChecked(false);
    setEditItems([]);
    setSelectedDraftIds([]);
    setSelectedContentIds([]);

    // 2. Now safe to run async state updates
    setPreparingDownload(true);
    let batchTrackingIds = new Set();

    // Reset cancel flag from any previous download
    if (bulkDownloadCancelRef) {
      bulkDownloadCancelRef.current = false;
    }

    try {
      // 3. Create videos folder
      const videosFolder = await directoryHandle.getDirectoryHandle('videos', { create: true });

      // Initialize download tracking
      let completedItems = 0;
      const totalItems = validVideos.length;

      // Show download box
      setDownloadBox(true);
      setBulkDownloadProgress({ current: 0, total: totalItems });

      // Add videos to tracking UI (append to preserve any in-progress downloads)
      // Each entry gets a unique id so the same video can be downloaded multiple times without glitching
      const batchTimestamp = Date.now();
      const videoFiles = validVideos.map((video, idx) => ({
        id: `${video.content_id || video.video_id}_${batchTimestamp}_${idx}`,
        videoId: video.content_id || video.video_id,
        name: video.title || `video_${video.content_id || video.video_id}`,
        fileName: video.video_file || video.title || `video_${video.content_id || video.video_id}.mp4`,
        progress: 0,
        status: 'pending',
        source: 'bulk',
        type: 'video',
      }));
      setDownloadingFiles((prev) => [...prev, ...videoFiles]);
      batchTrackingIds = new Set(videoFiles.map((vf) => vf.id));

      // Hide preparing loader once download panel is visible
      setPreparingDownload(false);

      // Progress callback
      const updateProgress = () => {
        completedItems += 1;
        setBulkDownloadProgress((prev) => ({ ...prev, current: completedItems }));
      };

      // Helper: Wait for internet connection
      const waitForOnline = () => new Promise((resolve) => {
        if (navigator.onLine) {
          resolve();
          return;
        }
        const handleOnline = () => {
          window.removeEventListener('online', handleOnline);
          resolve();
        };
        window.addEventListener('online', handleOnline);
      });

      // Map original video IDs to their unique tracking ids for this batch
      const trackingIdMap = {};
      videoFiles.forEach((vf) => {
        trackingIdMap[vf.videoId] = vf.id;
      });

      // Helper: Download single video with retry logic
      const downloadVideoWithRetry = async (video) => {
        const videoId = video.content_id || video.video_id;
        const trackingId = trackingIdMap[videoId];
        const title = sanitizeName(video.title || `video_${videoId}`);
        const ext = video.extension || 'mp4';

        // Fetch detailed video information to get video_raw_file URL
        let videoDetails;
        let detailAttempts = 0;
        const MAX_DETAIL_ATTEMPTS = 3;

        while (detailAttempts < MAX_DETAIL_ATTEMPTS) {
          if (!navigator.onLine) {
            // eslint-disable-next-line no-await-in-loop
            await waitForOnline();
          }

          try {
            // eslint-disable-next-line no-await-in-loop
            const detailResponse = await getVideosDetail({ id: videoId });
            if (detailResponse?.data?.success && detailResponse?.data?.data) {
              videoDetails = detailResponse.data.data;
              break;
            } else {
              detailAttempts += 1;
              if (detailAttempts >= MAX_DETAIL_ATTEMPTS) {
                logAppEvent({
                  userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
                  functionAffected: 'Download',
                  description: `Selected videos download failed — getVideosDetail API returned no data for "${title}" (ID: ${videoId})`,
                  severity: 'high',
                  errorMessage: 'getVideosDetail returned no data after max attempts',
                  requestUrl: endpoints.getVideosDetail,
                  requestMethod: 'POST',
                  component: 'YourVideos',
                  userAction: 'Download video called',
                });
                setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
                  ? { ...f, status: 'error' }
                  : f)));
                updateProgress();
                return false;
              }
            }
          } catch (error) {
            const isNetworkError = !navigator.onLine
              || error.message?.includes('Failed to fetch')
              || error.message?.includes('network')
              || error.name === 'TypeError';

            if (isNetworkError) {
              // eslint-disable-next-line no-await-in-loop
              await waitForOnline();
              // eslint-disable-next-line no-continue
              continue;
            }

            logAppEvent({
              userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
              functionAffected: 'Download',
              description: `Selected videos download failed — getVideosDetail API failed for "${title}" (ID: ${videoId}) (attempt ${detailAttempts + 1})`,
              severity: 'high',
              errorMessage: error?.message || 'getVideosDetail failed',
              requestUrl: endpoints.getVideosDetail,
              requestMethod: 'POST',
              component: 'YourVideos',
              userAction: 'Download video called',
            });
            detailAttempts += 1;
            if (detailAttempts >= MAX_DETAIL_ATTEMPTS) {
              setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
                ? { ...f, status: 'error' }
                : f)));
              updateProgress();
              return false;
            }
          }
        }

        // Check if video_raw_file URL exists
        if (!videoDetails?.video_raw_file || videoDetails.video_raw_file.trim() === '') {
          logAppEvent({
            userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
            functionAffected: 'Download',
            description: `Selected videos download failed — no video_raw_file URL for "${title}" (ID: ${videoId})`,
            severity: 'high',
            errorMessage: 'video_raw_file URL is missing or empty',
            requestUrl: endpoints.getVideosDetail,
            requestMethod: 'POST',
            component: 'YourVideos',
            userAction: 'Download video called',
          });
          setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
            ? { ...f, status: 'error' }
            : f)));
          updateProgress();
          return false;
        }

        let attempt = 0;
        const MAX_ATTEMPTS = 3;

        while (attempt < MAX_ATTEMPTS) {
          if (!navigator.onLine) {
            // eslint-disable-next-line no-await-in-loop
            await waitForOnline();
          }

          const controller = new AbortController();
          downloadAbortControllersRef.current.set(trackingId, controller);

          if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
            setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
              ? { ...f, status: 'cancelled' }
              : f)));
            return 'cancelled';
          }

          try {
            // eslint-disable-next-line no-await-in-loop
            const response = await fetch(videoDetails.video_raw_file, {
              method: 'GET',
              signal: controller.signal,
            });

            if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
              updateProgress();
              return 'cancelled';
            }

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const contentLength = response.headers.get('content-length');
            const total = contentLength ? parseInt(contentLength, 10) : 0;

            // Generate unique filename to avoid overwriting existing files
            let fileName = `${title}.${ext}`;
            let copyNum = 1;
            // eslint-disable-next-line no-constant-condition
            while (true) {
              try {
                // eslint-disable-next-line no-await-in-loop
                await videosFolder.getFileHandle(fileName);
                // File exists, try next name
                fileName = `${title} (${copyNum}).${ext}`;
                copyNum += 1;
              } catch {
                // File doesn't exist, use this name
                break;
              }
            }
            // eslint-disable-next-line no-await-in-loop
            const fileHandle = await videosFolder.getFileHandle(fileName, { create: true });
            // eslint-disable-next-line no-await-in-loop
            const writable = await fileHandle.createWritable();

            const reader = response.body.getReader();
            let receivedLength = 0;
            let lastReceivedLength = 0;
            let lastTimestamp = Date.now();
            let currentSpeed = 0;

            try {
              // eslint-disable-next-line no-constant-condition
              while (true) {
                if (!navigator.onLine) {
                  // eslint-disable-next-line no-await-in-loop
                  await reader.cancel();
                  // eslint-disable-next-line no-await-in-loop
                  await writable.abort();
                  throw new Error('Network offline');
                }

                // eslint-disable-next-line no-await-in-loop
                const { done, value } = await reader.read();

                if (done) break;

                // eslint-disable-next-line no-await-in-loop
                await writable.write(value);

                receivedLength += value.length;

                const now = Date.now();
                const timeDiff = (now - lastTimestamp) / 1000;
                if (timeDiff >= 0.5) {
                  const bytesDiff = receivedLength - lastReceivedLength;
                  currentSpeed = bytesDiff / timeDiff;
                  lastReceivedLength = receivedLength;
                  lastTimestamp = now;
                }

                const remainingBytes = total > 0 ? total - receivedLength : 0;
                const etaValue = (currentSpeed > 0 && remainingBytes > 0)
                  ? Math.round(remainingBytes / currentSpeed)
                  : 0;

                const progress = total > 0 ? Math.round((receivedLength / total) * 100) : 0;
                const speedSnapshot = currentSpeed;
                const downloadedSnapshot = receivedLength;
                const etaSnapshot = etaValue;

                setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
                  ? {
                    ...f,
                    progress,
                    status: 'downloading',
                    speed: speedSnapshot,
                    eta: etaSnapshot,
                    totalSize: total,
                    downloadedSize: downloadedSnapshot,
                  }
                  : f)));

                if (bulkDownloadCancelRef?.current || controller.signal.aborted) {
                  // eslint-disable-next-line no-await-in-loop
                  await reader.cancel();
                  // eslint-disable-next-line no-await-in-loop
                  await writable.abort();
                  updateProgress();
                  return 'cancelled';
                }
              }

              // eslint-disable-next-line no-await-in-loop
              await writable.close();
            } catch (writeError) {
              // eslint-disable-next-line no-await-in-loop
              await writable.abort().catch(() => { });
              throw writeError;
            }

            downloadAbortControllersRef.current.delete(trackingId);

            setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
              ? { ...f, progress: 100, status: 'completed' }
              : f)));

            updateProgress();
            return true;
          } catch (error) {
            try {
              controller.abort();
            } catch (abortErr) {
              // Ignore abort errors
            }

            if (error.name === 'AbortError' || error.name === 'CanceledError') {
              setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
                ? { ...f, status: 'cancelled' }
                : f)));
              return 'cancelled';
            }

            const isNetworkError = !navigator.onLine
              || error.message?.includes('Failed to fetch')
              || error.message?.includes('network')
              || error.message?.includes('offline')
              || error.name === 'TypeError';

            if (isNetworkError) {
              // eslint-disable-next-line no-await-in-loop
              await waitForOnline();
              // eslint-disable-next-line no-continue
              continue;
            }

            attempt += 1;

            if (attempt >= MAX_ATTEMPTS) {
              downloadAbortControllersRef.current.delete(trackingId);
              setDownloadingFiles((prev) => prev.map((f) => (f.id === trackingId
                ? { ...f, status: 'error' }
                : f)));
              logAppEvent({
                userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
                functionAffected: 'Download',
                description: `Video "${title}" (ID: ${videoId}) failed to download after ${MAX_ATTEMPTS} attempts — S3 fetch failed. S3 URL: ${videoDetails?.video_raw_file || 'unknown'}`,
                severity: 'high',
                errorMessage: error?.message || 'Selected videos download failed',
                responseStatus: error?.response?.status || null,
                responseBody: error?.response?.data?.message || null,
                requestUrl: videoDetails?.video_raw_file || endpoints.downloadVideo,
                requestMethod: 'GET',
                component: 'YourVideos',
                userAction: 'Multiple selected videos download called',
              });
              updateProgress();
              return false;
            }

            // eslint-disable-next-line no-await-in-loop
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }

        downloadAbortControllersRef.current.delete(trackingId);
        return false;
      };

      // Download videos with concurrency limit of 2
      const CONCURRENCY = 2;
      const videoQueue = [...validVideos];
      const state = { activeDownloads: 0, queueIndex: 0 };

      await new Promise((resolve) => {
        const processNext = () => {
          if (bulkDownloadCancelRef?.current) {
            if (state.activeDownloads === 0) resolve();
            return;
          }

          while (state.activeDownloads < CONCURRENCY && state.queueIndex < videoQueue.length) {
            const video = videoQueue[state.queueIndex];
            const videoId = video.content_id || video.video_id;
            const queueTrackingId = trackingIdMap[videoId];
            state.queueIndex += 1;
            state.activeDownloads += 1;

            setDownloadingFiles((prev) => prev.map((f) => (f.id === queueTrackingId
              ? { ...f, status: 'downloading' }
              : f)));

            downloadVideoWithRetry(video)
              .finally(() => {
                state.activeDownloads -= 1;
                processNext();
              });
          }

          if (state.activeDownloads === 0 && state.queueIndex >= videoQueue.length) {
            resolve();
          }
        };

        processNext();
      });

      // eslint-disable-next-line no-console
      console.log('Selected videos download completed! Total items:', completedItems);

      if (bulkDownloadCancelRef?.current) {
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: `Download canceled. ${completedItems} videos downloaded`,
        });
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: `Download completed: ${completedItems} videos downloaded successfully`,
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Selected Videos Download Error:', err);
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Error during download',
      });
    } finally {
      setPreparingDownload(false);

      // Remove only this batch's items from tracking
      setDownloadingFiles((prev) => {
        const remaining = prev.filter((f) => !batchTrackingIds.has(f.id));
        if (remaining.length === 0) {
          setDownloadBox(false);
        }
        return remaining;
      });
    }
  };

  // Single video download now routes through downloadSelectedVideos
  // so single and multi downloads share the same progress UI
  const downloadSelectedVideo = () => {
    if (selectedItems?.length !== 1 || tabTitle !== 0) return;
    downloadSelectedVideos(selectedItems);
  };

  /**
   * Download the photos the user selected inside an album (right-side panel).
   * Each selected photo is fetched and saved individually — select 5, get 5
   * files. Mirrors the single-photo download in PhotoEditModal (blob + anchor)
   * rather than the folder-based album download.
   */
  const downloadSelectedPhotos = async (photosToDownload) => {
    if (!photosToDownload || photosToDownload.length === 0) {
      setAppSnackbar({ isVisible: true, type: 'error', message: 'No photos selected for download' });
      return;
    }

    setAppSnackbar({
      isVisible: true,
      message: photosToDownload.length === 1
        ? 'Downloading photo...'
        : `Downloading ${photosToDownload.length} photos...`,
    });

    let completed = 0;
    let failed = 0;

    // eslint-disable-next-line no-restricted-syntax
    for (let i = 0; i < photosToDownload.length; i += 1) {
      const photo = photosToDownload[i];
      const photoUrl = photo?.photo_file || photo?.url || photo?.image || photo?.imagekit_url;

      if (!photoUrl) {
        failed += 1;
        // eslint-disable-next-line no-continue
        continue;
      }

      try {
        // eslint-disable-next-line no-await-in-loop
        const response = await fetch(photoUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        // eslint-disable-next-line no-await-in-loop
        const blob = await response.blob();

        const ext = (photoUrl.split('?')[0].split('.').pop() || 'jpg').toLowerCase();
        const rawName = String(photo?.title || `photo_${i + 1}`)
          .replace(/[<>:"/\\|?*]+/g, '')
          .replace(/\s+/g, '_')
          .trim() || `photo_${i + 1}`;
        const fileName = rawName.includes('.') ? rawName : `${rawName}.${ext}`;

        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          URL.revokeObjectURL(objectUrl);
          document.body.removeChild(a);
        }, 1000);

        completed += 1;

        // Small gap so the browser processes each download reliably
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, 600));
      } catch (err) {
        failed += 1;
        logAppEvent({
          userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
          functionAffected: 'Download Album Photo',
          description: 'Selected album photo download failed',
          severity: 'medium',
          errorMessage: err?.message || 'Photo download failed',
          component: 'YourVideos',
          userAction: 'Click download on selected album photos',
        });
      }
    }

    setAppSnackbar({
      isVisible: true,
      type: completed === 0 ? 'error' : 'success',
      message: completed === 0
        ? 'Oops! Something went wrong while downloading photos'
        : failed > 0
          ? `Downloaded ${completed} photo${completed !== 1 ? 's' : ''}, ${failed} failed`
          : `Downloaded ${completed} photo${completed !== 1 ? 's' : ''} successfully`,
    });

    setSelectedPhotos([]);
  };

  /**
   * Download the selected photo albums from the sidebar panel.
   * Each album becomes a folder (named after the album) containing all its photos.
   * Mirrors downloadSelectedVideos: Chrome/desktop uses the File System Access API
   * (one folder per album in the chosen directory); iOS/Safari falls back to
   * sequential anchor downloads with an album-name prefix on each file.
   */
  const downloadSelectedAlbums = async (albumsToDownload) => {
    if (!albumsToDownload || albumsToDownload.length === 0) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'No albums selected for download',
      });
      return;
    }

    // Use already-loaded photos when available, otherwise fetch album detail
    const getAlbumPhotos = async (album) => {
      if (Array.isArray(album.photos) && album.photos.length > 0) return album.photos;
      try {
        const albumDetail = await axios.post(`${baseUrl}/getMyAlbumDetail`, {
          album_id: album.content_id,
          token: getToken(),
        });
        return albumDetail?.data?.data?.[0]?.photos || [];
      } catch (error) {
        return [];
      }
    };

    // iOS/Safari fallback: File System Access API not supported
    if (typeof window.showDirectoryPicker !== 'function') {
      if (bulkDownloadCancelRef) {
        bulkDownloadCancelRef.current = false;
      }
      setPreparingDownload(true);
      setDownloadBox(true);

      const batchTimestamp = Date.now();
      const trackingEntries = albumsToDownload.map((album, idx) => ({
        id: `album_${album.content_id}_${batchTimestamp}_${idx}`,
        albumId: album.content_id,
        name: album.title || `album_${album.content_id}`,
        fileName: album.title || `album_${album.content_id}`,
        progress: 0,
        status: 'pending',
        source: 'bulk',
        totalPhotos: album.photos?.length || 0,
        type: 'photo',
      }));
      setDownloadingFiles((prev) => [...prev, ...trackingEntries]);
      setPreparingDownload(false);

      let completedCount = 0;
      let wasCancelled = false;

      for (let aIdx = 0; aIdx < albumsToDownload.length; aIdx += 1) {
        if (bulkDownloadCancelRef?.current) {
          wasCancelled = true;
          break;
        }

        const album = albumsToDownload[aIdx];
        const entry = trackingEntries[aIdx];
        const albumTitle = sanitizeName(album.title || `album_${album.content_id}`);

        setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
          ? { ...f, status: 'downloading' }
          : f)));

        // eslint-disable-next-line no-await-in-loop
        const photos = await getAlbumPhotos(album);
        setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
          ? { ...f, totalPhotos: photos.length }
          : f)));

        let completedPhotos = 0;

        // eslint-disable-next-line no-restricted-syntax
        for (const photo of photos) {
          if (bulkDownloadCancelRef?.current) {
            wasCancelled = true;
            break;
          }

          const photoUrl = photo.photo_file || photo.url || photo.image;
          if (!photoUrl) {
            completedPhotos += 1;
            // eslint-disable-next-line no-continue
            continue;
          }

          try {
            const controller = new AbortController();
            downloadAbortControllersRef.current.set(`${entry.id}_${completedPhotos}`, controller);

            // eslint-disable-next-line no-await-in-loop
            const photoResponse = await fetch(photoUrl, { signal: controller.signal });
            // eslint-disable-next-line no-await-in-loop
            const blob = await photoResponse.blob();

            downloadAbortControllersRef.current.delete(`${entry.id}_${completedPhotos}`);

            const ext = photoUrl.split('?')[0].split('.').pop() || 'jpg';
            const fileName = `${albumTitle}_photo_${completedPhotos + 1}.${ext}`;

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              URL.revokeObjectURL(url);
              document.body.removeChild(a);
            }, 1000);

            completedPhotos += 1;
            completedCount += 1;

            const completedSnapshot = completedPhotos;
            const albumProgress = photos.length > 0
              ? Math.round((completedSnapshot / photos.length) * 100)
              : 100;
            setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
              ? { ...f, progress: albumProgress, status: completedSnapshot === photos.length ? 'completed' : 'downloading' }
              : f)));

            // Small delay between downloads so iOS Safari can register each one
            // eslint-disable-next-line no-await-in-loop
            await new Promise((resolve) => setTimeout(resolve, 1500));
          } catch (err) {
            if (err.name === 'AbortError' || bulkDownloadCancelRef?.current) {
              wasCancelled = true;
              break;
            }
            // eslint-disable-next-line no-console
            console.error(`Failed to download photo from album ${album.content_id}:`, err);
            completedPhotos += 1;
          }
        }

        setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
          ? { ...f, progress: 100, status: completedPhotos >= photos.length ? 'completed' : 'error' }
          : f)));

        if (wasCancelled) break;
      }

      setAppSnackbar({
        isVisible: true,
        type: completedCount > 0 ? 'success' : 'error',
        message: wasCancelled
          ? `Download canceled. ${completedCount} ${completedCount === 1 ? 'photo' : 'photos'} downloaded`
          : completedCount > 0
            ? `Download completed: ${completedCount} ${completedCount === 1 ? 'photo' : 'photos'} downloaded`
            : 'Download failed',
      });

      setTimeout(() => {
        setDownloadingFiles((prev) => {
          const remaining = prev.filter((f) => !trackingEntries.some((e) => e.id === f.id));
          if (remaining.length === 0) setDownloadBox(false);
          return remaining;
        });
      }, 2000);

      return;
    }

    // Chrome / desktop: File System Access API
    // 1. Directory picker MUST run immediately when button is clicked
    let directoryHandle;
    try {
      directoryHandle = await window.showDirectoryPicker({ mode: 'readwrite' });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Directory Picker Error =>', err);
      const isUserAbort = err?.name === 'AbortError';
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Download',
        description: `Selected albums download cancelled — ${isUserAbort ? 'user dismissed the directory picker' : `directory picker failed: ${err?.name}`}`,
        severity: isUserAbort ? 'low' : 'high',
        errorMessage: err?.message || 'showDirectoryPicker failed',
        component: 'YourVideos',
        userAction: 'Multiple selected albums download called',
      });
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Download canceled',
      });
      return;
    }

    directoryHandleRef.current = directoryHandle;

    // Close the panel once download starts (directory picked successfully)
    setSelectedItems([]);
    setSelectAllChecked(false);
    setEditItems([]);
    setSelectedDraftIds([]);
    setSelectedContentIds([]);

    setPreparingDownload(true);
    let batchTrackingIds = new Set();

    if (bulkDownloadCancelRef) {
      bulkDownloadCancelRef.current = false;
    }

    try {
      setDownloadBox(true);

      const batchTimestamp = Date.now();
      const albumFiles = albumsToDownload.map((album, idx) => ({
        id: `album_${album.content_id}_${batchTimestamp}_${idx}`,
        albumId: album.content_id,
        name: album.title || `album_${album.content_id}`,
        fileName: album.title || `album_${album.content_id}`,
        progress: 0,
        status: 'pending',
        source: 'bulk',
        totalPhotos: album.photos?.length || 0,
        type: 'photo',
      }));
      setDownloadingFiles((prev) => [...prev, ...albumFiles]);
      batchTrackingIds = new Set(albumFiles.map((af) => af.id));
      setPreparingDownload(false);

      let completedCount = 0;

      for (let aIdx = 0; aIdx < albumsToDownload.length; aIdx += 1) {
        if (bulkDownloadCancelRef?.current) break;

        const album = albumsToDownload[aIdx];
        const entry = albumFiles[aIdx];
        const albumTitle = sanitizeName(album.title || `album_${album.content_id}`);

        setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
          ? { ...f, status: 'downloading' }
          : f)));

        const albumController = new AbortController();
        downloadAbortControllersRef.current.set(entry.id, albumController);

        try {
          // eslint-disable-next-line no-await-in-loop
          const photos = await getAlbumPhotos(album);
          setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
            ? { ...f, totalPhotos: photos.length }
            : f)));

          // Create a folder named after the album (unique if a folder already exists)
          let folderName = albumTitle;
          let copyNum = 1;
          // eslint-disable-next-line no-constant-condition
          while (true) {
            try {
              // eslint-disable-next-line no-await-in-loop
              await directoryHandle.getDirectoryHandle(folderName);
              folderName = `${albumTitle} (${copyNum})`;
              copyNum += 1;
            } catch {
              break;
            }
          }
          // eslint-disable-next-line no-await-in-loop
          const albumFolderHandle = await directoryHandle.getDirectoryHandle(folderName, { create: true });

          const PHOTO_BATCH_SIZE = 2; // Download 2 photos at a time
          const completedPhotosCount = { value: 0 };

          for (let i = 0; i < photos.length; i += PHOTO_BATCH_SIZE) {
            if (bulkDownloadCancelRef?.current || albumController.signal.aborted) break;

            const batch = photos.slice(i, i + PHOTO_BATCH_SIZE);

            // eslint-disable-next-line no-await-in-loop
            await Promise.all(
              batch.map(async (photo, batchIndex) => {
                try {
                  if (bulkDownloadCancelRef?.current || albumController.signal.aborted) return;

                  const photoUrl = photo.photo_file || photo.url || photo.image;
                  if (!photoUrl) {
                    completedPhotosCount.value += 1;
                    return;
                  }

                  const photoIndex = i + batchIndex + 1;
                  const ext = photoUrl.split('?')[0].split('.').pop() || 'jpg';
                  const photoFileName = `photo_${photoIndex}.${ext}`;

                  const response = await fetch(photoUrl, { signal: albumController.signal });
                  const blob = await response.blob();

                  const fileHandle = await albumFolderHandle.getFileHandle(photoFileName, { create: true });
                  const writable = await fileHandle.createWritable();
                  await writable.write(blob);
                  await writable.close();

                  completedPhotosCount.value += 1;

                  const albumProgress = photos.length > 0
                    ? Math.round((completedPhotosCount.value / photos.length) * 100)
                    : 100;
                  setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
                    ? { ...f, progress: albumProgress, status: completedPhotosCount.value === photos.length ? 'completed' : 'downloading' }
                    : f)));
                } catch (error) {
                  if (error.name === 'AbortError' || error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
                    return;
                  }
                  // eslint-disable-next-line no-console
                  console.error(`Failed to download photo from album ${album.content_id}:`, error);
                  completedPhotosCount.value += 1;
                }
              })
            );
          }

          downloadAbortControllersRef.current.delete(entry.id);
          completedCount += completedPhotosCount.value;

          setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
            ? { ...f, status: 'completed', progress: 100 }
            : f)));
        } catch (error) {
          downloadAbortControllersRef.current.delete(entry.id);
          if (error.name === 'AbortError') {
            setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
              ? { ...f, status: 'cancelled' }
              : f)));
          } else {
            // eslint-disable-next-line no-console
            console.error(`Failed to process album ${album.content_id}:`, error);
            logAppEvent({
              userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
              functionAffected: 'Download',
              description: `Selected albums download failed — album download failed (ID: ${album.content_id})`,
              severity: 'high',
              errorMessage: error?.message || 'Album download failed',
              component: 'YourVideos',
              userAction: 'Multiple selected albums download called',
            });
            setDownloadingFiles((prev) => prev.map((f) => (f.id === entry.id
              ? { ...f, status: 'error' }
              : f)));
          }
        }
      }

      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: bulkDownloadCancelRef?.current
          ? `Download canceled. ${completedCount} photos downloaded`
          : `Download completed: ${completedCount} photos downloaded successfully`,
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Selected Albums Download Error:', err);
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Error during download',
      });
    } finally {
      setPreparingDownload(false);
      setDownloadingFiles((prev) => {
        const remaining = prev.filter((f) => !batchTrackingIds.has(f.id));
        if (remaining.length === 0) {
          setDownloadBox(false);
        }
        return remaining;
      });
    }
  };

  const handlePageClick = (event) => {
    setDataLoader(true);
    setSelectedItems([]);
    setSelectAllChecked(false);
    selectPage(parseInt(event.selected, 10) + 1);
    if (videoListContainerRef.current) {
      videoListContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  function changeColorhover(e) {
    e.target.style.fill = 'red';
  }

  function changeColorleave(e) {
    e.target.style.fill = 'white';
  }

  const doCancelAction = () => {
    // onHide();
  };
  const [imageErrorOn, setImageLoadErrorOn] = useState([]);
  function handleImageError(e, indx) {
    const ar = imageErrorOn;
    setImageLoadErrorOn(ar.concat(indx));
  }

  // Get the URL query parameters
  const params = new URLSearchParams(window.location.search);
  // Get the value of the "tab" parameter
  const tabParam = params.get('tab');
  const navigate = useNavigate();

  useEffect(() => {
    if (tabParam === 'draft') {
      fetchData();
      selectVideo(undefined);
      setContent(mergeDrafts);
      // Perform actions specific to the "draft" tab
      setTabTitle(0);
      // Remove the 'tab' parameter from the URL
      params.delete('tab');
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      navigate(newUrl, { replace: true });
      setVideoData(undefined);
      selectType(undefined);
    }
    if (tabParam === 'publish') {
      fetchData();
      // Perform actions specific to the "draft" tab
      selectVideo(undefined);
      setTabTitle(0);
      // Remove the 'tab' parameter from the URL
      params.delete('tab');
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      navigate(newUrl, { replace: true });
    }
  }, [params]);
  useEffect(() => {
    if (tabParam === 'tabtitle3' && mergeDrafts?.length) {
      setTabTitle(0);
      setContent(mergeDrafts);
      // // Remove the 'tab' parameter from the URL
      params.delete('tab');
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      navigate(newUrl, { replace: true });
    }
  }, [allContent, mergeDrafts, content]);

  const [data, setData] = useState([]);
  const [dataD, setDataD] = useState([]);
  useEffect(() => {
    const dataCallback = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        setData(dataObj);
      }
    };
    onValue(databaseRef, dataCallback);
    return () => {
      off(databaseRef, 'value', dataCallback);
    };
  }, []);

  useEffect(() => {
    const dataCallback = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        setDataD(dataObj);
      }
    };
    onValue(databaseRefD, dataCallback);
    return () => {
      off(databaseRefD, 'value', dataCallback);
    };
  }, []);

  const renderContent = (
    draft_id,
    content_status,
    status,
    video_id,
    transcoder_status,
    workflow_status
  ) => {
    // For Shared tab, just return the content_status directly (no upload logic)
    if (tabTitle === 2) {
      return content_status || 'Shared';
    }

    const isInQueue = uploadQueue.some((item) => item.draftId === draft_id);
    let result;
    if (draft_id?.slice(0, 9) !== 'old_video') {
      // Check if upload is pending/queued (new upload system)
      if (UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM && uploadStatuses[draft_id] === UPLOAD_STATUS.PENDING) {
        result = 'Waiting in queue';
      } else if (UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM && uploadStatuses[draft_id] === UPLOAD_STATUS.PAUSED) {
        result = <AddDotLoader text="Paused" />;
      } else if (UPLOAD_CONFIG.USE_NEW_UPLOAD_SYSTEM && uploadStatuses[draft_id] === UPLOAD_STATUS.NETWORK_ERROR) {
        result = <AddDotLoader text="Network Error - Will Resume" />;
      } else if (typeof uploadPercentages[draft_id] === 'number') {
        result = (
          <AddDotLoader
            // text={`Uploading ${tempUploadPercentages[draft_id]}%`}
            text={`Uploading ${tempUploadPercentages && tempUploadPercentages[draft_id] ? tempUploadPercentages[draft_id] : uploadPercentages[draft_id]}%`}
          />
        );
      } else if (
        transcoder_status != null
        && transcoder_status !== 'Finished'
      ) {
        result = <AddDotLoader text="Processing" />;
      } else if (status && workflow_status === 'Complete') {
        switch (content_status) {
          case 'Public':
            result = 'All Viewers';
            break;
          default:
            result = content_status;
            break;
        }
      } else if (tabTitle === 2) {
        result = video_id ? (
          'Completed'
        ) : tempUploadPercentages && (tempUploadPercentages[draft_id] === 'Starting Upload'
          || tempUploadPercentages[draft_id] === 'Please wait') ? (
          <AddDotLoader text={tempUploadPercentages[draft_id]} />
        ) : (!tempUploadPercentages || tempUploadPercentages[draft_id] === undefined) && isInQueue ? (
          'Your upload is in queue'
        ) : (
          'Failed to Upload'
        );
      } else if (
        tempUploadPercentages && (
          tempUploadPercentages[draft_id] === 'Starting Upload'
          || tempUploadPercentages[draft_id] === 'Please wait'
        )
      ) {
        result = <AddDotLoader text={tempUploadPercentages[draft_id]} />;
      } else if ((!tempUploadPercentages || tempUploadPercentages[draft_id] === undefined) && isInQueue) {
        result = 'Your upload is in queue';
      } else if (tempUploadPercentages && tempUploadPercentages[draft_id] === 'completed') {
        result = 'Processing';
      } else if (tabTitle !== 1) {
        // Don't show "Failed to Upload" for photo albums (tabTitle === 1)
        result = 'Failed to Upload';
      } else {
        result = 'Completed';
      }
    } else {
      result = tabTitle === 2
        ? video_id
          ? 'Completed'
          : 'In Progress'
        : tabTitle === 0
          ? status
            ? content_status
            : 'Processing'
          : content_status;
    }
    // if (draft_id?.slice(0, 9) !== 'old_video') {
    //   if (data[draft_id]) {
    //     if (data[draft_id].status === 'STATUS_UPDATE') {
    //       result = 'Public';
    //     } else if (data[draft_id].status === 'ERROR' || data[draft_id].status === 'COMPLETE' || data[draft_id].status === 'COMPLETED' || data[draft_id].status === 'NEW_WARNING' || data[draft_id].status === 'INPUT_INFORMATION') {
    //       if (tabTitle === 2) {
    //         result = 'Completed';
    //       } else if (content_status !== '' && content_status !== undefined) {
    //         result = content_status;
    //       } else {
    //         // result = <AddDotLoader text="Loading" />; // will show in stage of blank screen
    //         result = 'Public';
    //       }
    //     } else if (data[draft_id].status === 'DELETED') {
    //       result = <AddDotLoader text="Canceling" />;
    //     } else if (data[draft_id].status === 'FINISHED') {
    //       fetchContent();
    //       changeFieldFromFirebase(draft_id, 'COMPLETED');
    //     } else {
    //       // result = <AddDotLoader text={data[draft_id].status} />;
    //       result = tabTitle === 2 ? (video_id ? 'Completed' : 'In Progress') : tabTitle === 0 ? status ? content_status : 'Processing' : content_status;
    //     }
    //   } else if (tabTitle !== 1) {
    //     if (tempUploadPercentages[draft_id] === 'Starting Upload' || tempUploadPercentages[draft_id] === 'Initializing' || tempUploadPercentages[draft_id] === 'Please wait' || tempUploadPercentages[draft_id] === 'Failed to Upload') {
    //       result = <AddDotLoader text={tempUploadPercentages[draft_id]} />;
    //     } else if (tempUploadPercentages[draft_id]) {
    //       result = <AddDotLoader text={`Uploading ${tempUploadPercentages[draft_id]}%`} />;
    //     } else {
    //       result = 'Failed to Upload';
    //     }
    //   } else {
    //     result = content_status;
    //   }
    // } else {
    //   result = tabTitle === 2 ? (video_id ? 'Completed' : 'In Progress') : tabTitle === 0 ? status ? content_status : 'Processing' : content_status;
    // }
    return result === 'Public' ? 'All Viewers' : result;
  };

  useEffect(() => {
    setHoldTheWeb(false);
  }, []);
  const [allSelectHint, setallSelectHint] = useState(false);
  const [draft_idPLacer, setDraft_idPLacer] = useState(undefined);
  const [isUnSelected, setisUnSelected] = useState(false);

  // Helper function to check if an item is selected
  const isItemSelected = (itemId) => selectedItems.some((item) => {
    const currentItemId = item.draft_id
      || item.content_id
      || item.video_id
      || item.draft_content_id;
    return currentItemId === itemId;
  });
  const toggleItemSelection = (itemId, itemType, status, videoObject) => {
    setSingleEdit(false);
    selectVideo();
    if (status !== 1) {
      setEditItemsStatus([]);
    }
    setisUnSelected(!isUnSelected);
    if (tabTitle === 1) {
      selectType('album');
    } else {
      selectType(undefined);
    }
    setSelectedItems((prevSelected) => {
      const existingIndex = prevSelected.findIndex((item) => {
        // Check based on the specific itemType being toggled
        if (itemType === 'draft_id') {
          return item.draft_id === itemId || item.draft_content_id === itemId;
        }
        if (itemType === 'content_id') {
          return item.content_id === itemId;
        }
        if (itemType === 'video_id') {
          return item.video_id === itemId;
        }
        // Fallback to checking all fields
        const currentItemId = item.draft_id
          || item.content_id
          || item.video_id
          || item.draft_content_id;
        return currentItemId === itemId;
      });

      if (existingIndex !== -1) {
        return prevSelected.filter((_, index) => index !== existingIndex);
      }
      return [...prevSelected, videoObject];
    });
    if (selectedItems.length === 1) {
      setallSelectHint(true);
    }
    if (itemType === 'draft_id') {
      setSelectedDraftIds((prevSelected) => {
        if (!prevSelected.includes(itemId)) {
          return [...prevSelected, itemId];
        }
        return prevSelected.filter((id) => id !== itemId); // Remove duplicate entry
      });
    } else if (itemType === 'content_id') {
      setSelectedContentIds((prevSelected) => {
        if (!prevSelected.includes(itemId)) {
          return [...prevSelected, itemId];
        }
        return prevSelected.filter((id) => id !== itemId); // Remove duplicate entry
      });
    }
  };

  useEffect(() => {
    if (selectedItems.length > 0) {
      if (content.length !== selectedItems.length) {
        setSelectAllChecked(false);
        // setisUnSelected(false);
      } else {
        setSelectAllChecked(true);
      }
    }
  }, [isUnSelected]);

  useEffect(() => {
    if (allSelectHint === true && selectedItems.length === 0) {
      setSelectedItems([]);
      setSelectedDraftIds([]);
      setSelectedContentIds([]);
      setallSelectHint(false);
    }
  }, [allSelectHint]);

  // Handle panel transition when selectedItems changes
  useEffect(() => {
    if (selectedItems?.length > 0) {
      if (panelTransitionState === 'exited') {
        setPanelTransitionState('entering');
        setTimeout(() => setPanelTransitionState('entered'), 50);
      }
    } else if (panelTransitionState === 'entered') {
      setPanelTransitionState('exiting');
      setTimeout(() => setPanelTransitionState('exited'), 300);
    }
  }, [selectedItems?.length, panelTransitionState]);

  // Same slide-in/out transition for the album-photo selection panel.
  useEffect(() => {
    if (selectedPhotos?.length > 0) {
      if (photosPanelTransitionState === 'exited') {
        setPhotosPanelTransitionState('entering');
        setTimeout(() => setPhotosPanelTransitionState('entered'), 50);
      }
    } else if (photosPanelTransitionState === 'entered') {
      setPhotosPanelTransitionState('exiting');
      setTimeout(() => setPhotosPanelTransitionState('exited'), 300);
    }
  }, [selectedPhotos?.length, photosPanelTransitionState]);

  // Clear photo selection when leaving the album view (tab change or album switch).
  useEffect(() => {
    setSelectedPhotos([]);
  }, [tabTitle, selectedAlbumFilter?.content_id]);

  // Check video_raw_file availability when single video is selected
  useEffect(() => {
    const checkVideoDownloadAvailability = async () => {
      console.log('[DOWNLOAD PRE-CHECK] Started', { selectedItemsCount: selectedItems?.length, tabTitle });
      // Only check for single video selection on videos tab
      if (selectedItems?.length !== 1 || tabTitle !== 0) {
        console.log('[DOWNLOAD PRE-CHECK] Skipped — not single video or not video tab');
        setIsDownloadDisabled(false);
        setIsCheckingDownload(false);
        setCachedVideoRawFile(null);
        setCachedVideoTitle(null);
        return;
      }

      const selectedVideo = selectedItems[0];
      const videoId = selectedVideo?.content_id || selectedVideo?.video_id || selectedVideo?.draft_id;
      console.log('[DOWNLOAD PRE-CHECK] Selected video:', { videoId, selectedVideo });

      if (!videoId) {
        console.log('[DOWNLOAD PRE-CHECK] No videoId found — disabling download');
        setIsDownloadDisabled(true);
        setIsCheckingDownload(false);
        setCachedVideoRawFile(null);
        setCachedVideoTitle(null);
        return;
      }

      setIsCheckingDownload(true);
      setIsDownloadDisabled(true); // Disable while checking

      try {
        console.log('[DOWNLOAD PRE-CHECK] Calling getVideosDetail for:', videoId);
        const response = await getVideosDetail({ id: videoId });
        console.log('[DOWNLOAD PRE-CHECK] getVideosDetail response:', { success: response?.data?.success, hasData: !!response?.data?.data });

        if (response?.data?.success && response?.data?.data) {
          const videoData = response.data.data;
          console.log('[DOWNLOAD PRE-CHECK] video_raw_file:', videoData?.video_raw_file ? `${videoData.video_raw_file.substring(0, 80)}...` : 'EMPTY/NULL');

          // Check if video_raw_file URL exists
          if (videoData?.video_raw_file && videoData.video_raw_file.trim() !== '') {
            try {
              console.log('[DOWNLOAD PRE-CHECK] Checking S3 file availability via Range request...');
              // Range request with just 1 byte (fastest way to check file exists)
              // fileCheckResponse = await fetch(videoData.video_raw_file, { method: 'HEAD' });
              const fileCheckResponse = await fetch(videoData.video_raw_file, {
                method: 'GET',
                headers: { Range: 'bytes=0-0' },
              });

              // Check content-type - S3 errors return application/xml
              const contentType = fileCheckResponse.headers.get('content-type') || '';
              const isXmlError = contentType.includes('xml');
              console.log('[DOWNLOAD PRE-CHECK] S3 check result:', { status: fileCheckResponse.status, ok: fileCheckResponse.ok, contentType, isXmlError });

              if (fileCheckResponse.ok && !isXmlError) {
                console.log('[DOWNLOAD PRE-CHECK] ✅ File available — enabling download');
                setCachedVideoRawFile(videoData.video_raw_file);
                setCachedVideoTitle(videoData.title || 'video');
                setIsDownloadDisabled(false);
              } else {
                console.log('[DOWNLOAD PRE-CHECK] ❌ File NOT available — disabling download');
                setCachedVideoRawFile(null);
                setCachedVideoTitle(null);
                setIsDownloadDisabled(true);
              }
            } catch (fileCheckErr) {
              console.log('[DOWNLOAD PRE-CHECK] ❌ S3 check fetch failed:', fileCheckErr);
              setCachedVideoRawFile(null);
              setCachedVideoTitle(null);
              setIsDownloadDisabled(true);
            }
          } else {
            console.log('[DOWNLOAD PRE-CHECK] ❌ No video_raw_file URL in response');
            setCachedVideoRawFile(null);
            setCachedVideoTitle(null);
            setIsDownloadDisabled(true);
          }
        } else {
          console.log('[DOWNLOAD PRE-CHECK] ❌ getVideosDetail failed or no data');
          setCachedVideoRawFile(null);
          setCachedVideoTitle(null);
          setIsDownloadDisabled(true);
        }
      } catch (detailErr) {
        console.log('[DOWNLOAD PRE-CHECK] ❌ getVideosDetail threw error:', detailErr);
        setCachedVideoRawFile(null);
        setCachedVideoTitle(null);
        setIsDownloadDisabled(true);
      } finally {
        setIsCheckingDownload(false);
      }
    };

    checkVideoDownloadAvailability();
  }, [selectedItems, tabTitle]);

  const deleteSelectedItems = () => {
    setholdWhileDelete(true);
    axios
      .post(`${baseUrl}/deleteDraftContent`, {
        token: getToken(),
        draft_id: selectedDraftIds,
        content_id: selectedContentIds,
      })
      .then((response) => {
        if (response?.data?.message !== true) {
          setAppSnackbar({
            isVisible: true,
            message: response?.data?.message,
          });
          fetchData();
        } else {
          // fetchContent();
          if (selectedDraftIds?.length > 0) {
            selectedDraftIds.map((dId) => {
              changeFieldFromFirebase(dId, 'DELETED');
              return null;
            });
          }
          // Handle success
          selectVideo(null);
          selectedDraftIds.map((item) => {
            updateDummy(item, 0);
            return null;
          });
          setEditItemsStatus([]);
          setEditItems([]);
          setSelectedItems([]);
          setSelectedDraftIds([]);
          setSelectedContentIds([]);
          setSelectAllChecked(false);
          setDataLoading(false);
          setIsContentLoaded(false);
          // fetchContent();
          getSubscription();
          autoSignIn();
          setisCompleted('nothing');
          setTimeout(() => {
            setholdWhileDelete(false);
          }, 2000);
        }
      })
      .catch((error) => {
        setAppSnackbar({
          isVisible: true,
          message: error?.response?.data?.message,
        });
        setholdWhileDelete(false);
        setSelectedItems([]);
        setEditItemsStatus([]);
        selectedDraftIds.map((item) => {
          updateDummy(item, 0);
          return null;
        });
        setEditItems([]);
        setSelectedDraftIds([]);
        setSelectedContentIds([]);
        getSubscription();
        setDataLoading(false);
        // fetchContent();
      });
  };

  const [droper, setDroper] = useState(false);
  const [videoFiles, setVideoFiles] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [uploadModalIsVisible, setUploadModalVisibility] = useState(false);
  const [popUpModalVisible, setPopUpModalVisible] = useState(false);

  const revealUploadModal = () => {
    localStorage.setItem('opened_draft_id', null);
    autoSignIn().then((res) => {
      if (
        !res?.data?.subscription
        && res?.data?.totalContentUploaded >= ALLOWED_UPLOADS_COUNT
      ) {
        setPopUpModalVisible(true);
        setEditLoader(false);
      } else {
        setUploadModalVisibility(true);
        setEditLoader(false);
      }
    });
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleDrop = (e) => {
    // setEditLoader(true);
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const typeVideoFiles = files.filter((file) => file.type.startsWith('video/'));
    const typeImageFiles = files.filter((file) => file.type.startsWith('image/'));
    setVideoFiles(typeVideoFiles);
    setImageFiles(typeImageFiles);
    setDroper(false);
    if (imageFiles.length > 0) {
      revealUploadModal();
    }
    if (videoFiles.length > 0) {
      handleOpen();
    }
  };

  const dragOver = (e) => {
    e.preventDefault();
    setDroper(true);
  };
  const dragLeave = (e) => {
    e.preventDefault();
    setDroper(false);
  };

  const hideUploadModal = () => {
    setUploadModalVisibility(false);
  };

  const VideoCard = ({
    video,
    index,
    isSelected,
    onSelect,
    onCardClick,
    onViewPhotos,
  }) => {
    const {
      content_id,
      video_id,
      draft_content_id,
      title,
      description,
      video_description,
      thumbnail,
      thumbnails,
      category_name,
      category,
      content_status,
      status,
      publish_date,
      created,
      video_size,
      draft_id,
      transcoder_status,
      workflow_status,
    } = video;

    const videoId = tabTitle === 2 ? draft_content_id : content_id || video_id;
    const videoTitle = title || 'Untitled';
    const videoDescription = description || video_description || '';
    const videoThumbnail = Array.isArray(thumbnail)
      ? thumbnail[0] || AlterImage
      : thumbnail || thumbnails || AlterImage;
    const videoCategory = tabTitle === 2 ? category_name || category : category;
    const videoStatus = renderContent(
      draft_id,
      content_status,
      status,
      video_id,
      transcoder_status,
      workflow_status
    );
    const videoDate = changeDateFormat(publish_date?.split(' ')[0]) || created?.split(' ')[0];
    const videoSizeFormatted = video_size < 1 && video_size > 0
      ? `${(video_size * 1024).toFixed(2)} KB`
      : video_size < 1000 && video_size > 1
        ? `${video_size} MB`
        : video_size > 1000
          ? `${(video_size / 1024).toFixed(2)} GB`
          : '--';

    return (
      <div
        className={`${styles.videoCard} ${isSelected ? styles.selected : ''}`}
      >
        <div className={styles.cardHeader}>
          {draft_content_id || content_id || video_id ? (
            <SquareCheckbox
              selected={isItemSelected(
                draft_id && draft_id?.slice(0, 9) !== 'old_video'
                  ? draft_id
                  : draft_id || content_id || draft_content_id
              )}
              onClick={() => {
                if (draft_id && draft_id?.slice(0, 9) !== 'old_video') {
                  toggleItemSelection(draft_id, 'draft_id', status, video);
                } else {
                  toggleItemSelection(
                    draft_id || draft_content_id || content_id,
                    'draft_id',
                    status,
                    video
                  );
                }
                setEditItems((prevSelected) => {
                  const idToUse = tabTitle === 0
                    ? content_id
                    : tabTitle === 2 && draft_content_id;
                  if (prevSelected.includes(idToUse)) {
                    return prevSelected.filter((id) => id !== idToUse);
                  }
                  return [...prevSelected, idToUse];
                });
                setEditItemsStatus((prevSelectedStatus) => {
                  const idToUse = status;
                  if (prevSelectedStatus.includes(idToUse)) {
                    return prevSelectedStatus.filter((id) => id !== idToUse);
                  }
                  return [...prevSelectedStatus, idToUse];
                });
              }}
            />
          ) : (
            <Spinner />
          )}
        </div>
        <div className={styles.cardContent} onClick={() => (draft_content_id || content_id || video_id) && onCardClick(video)}>
          <div className={styles.thumbnailContainer}>
            <img
              src={videoThumbnail}
              alt={videoTitle}
              style={{ cursor: (draft_content_id || content_id || video_id) ? 'default' : 'pointer' }}
              className={styles.thumbnail}
              onError={(e) => {
                e.target.src = AlterImage;
              }}
            />
            {/* {(video.type === 'album' || tabTitle === 1) && onViewPhotos && (
              <button
                className={styles.viewPhotosCardButton}
                onClick={(e) => {
                  e.stopPropagation();
                  console.log('View Photos clicked for video:', video);
                  onViewPhotos(video);
                }}
                title="View Photos"
                aria-label={`View photos in ${videoTitle}`}
              >
                <span className={styles.viewPhotosIcon}>👁️</span>
                <span className={styles.viewPhotosText}>View Photos</span>
              </button>
            )} */}
          </div>
          <div className={styles.cardInfo}>
            <h3 className={styles.cardTitle}>{videoTitle}</h3>
            <p className={styles.cardDescription}>{videoDescription}</p>
            <div className={styles.cardFlex}>
              <div className={styles.cardMeta}>
                {!cancellingState[draft_id] && (
                  <span className={styles.status}>{videoStatus}</span>
                )}
                <span className={styles.category}>{videoCategory}</span>
                <span className={styles.date}>{videoDate}</span>
                <span className={styles.size}>{videoSizeFormatted}</span>
              </div>
              {/* Cancel button for dummy items */}
              {cancellingState[draft_id] ? (
                <div className={styles.cancellingMessage}>
                  <div className={styles.cancellingText}>Cancellation in progress...</div>
                  <div className={styles.cancellingProgressBar}>
                    <div className={styles.cancellingProgressFill} />
                  </div>
                </div>
              ) : dummyObject
              && dummyObject[draft_id]
              && uploadPercentages
              && uploadPercentages[draft_id] !== 'Please wait'
              && uploadPercentages[draft_id] !== 'Processing'}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const DetailsPanel = ({ video, isOpen, onClose }) => {
    if (!video || !isOpen) return null;

    const {
      title,
      description,
      video_description,
      thumbnail,
      thumbnails,
      category_name,
      category,
      content_status,
      status,
      publish_date,
      created,
      video_size,
      draft_id,
      transcoder_status,
      workflow_status,
    } = video;

    const videoTitle = title || 'Untitled';
    const videoDescription = description || video_description || '';
    const videoThumbnail = Array.isArray(thumbnail)
      ? thumbnail[0] || AlterImage
      : thumbnail || thumbnails || AlterImage;
    const videoCategory = tabTitle === 2 ? category_name || category : category;
    const videoStatus = renderContent(
      draft_id,
      content_status,
      status,
      video.video_id,
      transcoder_status,
      workflow_status
    );
    const videoDate = changeDateFormat(publish_date?.split(' ')[0]) || created?.split(' ')[0];

    return (
      <div className={`${styles.detailsPanel} ${isOpen ? styles.open : ''}`}>
        <div className={styles.panelHeader}>
          <h2>Video Details</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.panelContent}>
          <div className={styles.previewContainer}>
            <img
              src={videoThumbnail}
              alt={videoTitle}
              className={styles.previewImage}
            />
          </div>
          <div className={styles.detailsInfo}>
            <h3>{videoTitle}</h3>
            <p className={styles.detailsDescription}>{videoDescription}</p>
            <div className={styles.detailsMeta}>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Category:</span>
                <span>{videoCategory}</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Status:</span>
                <span>{videoStatus}</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Date:</span>
                <span>{videoDate}</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Size:</span>
                <span>
                  {video_size < 1 && video_size > 0
                    ? `${(video_size * 1024).toFixed(2)} KB`
                    : video_size < 1000 && video_size > 1
                      ? `${video_size} MB`
                      : video_size > 1000
                        ? `${(video_size / 1024).toFixed(2)} GB`
                        : '--'}
                </span>
              </div>
            </div>
          </div>
          <div className={styles.panelActions}>
            <button
              className={styles.actionButton}
              onClick={() => handleButtonClick(
                tabTitle === 2
                  ? video.draft_content_id
                  : video.content_id || video.video_id
              )}
            >
              Edit
            </button>
            <button
              className={styles.actionButton}
              onClick={() => setModal(true)}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleCardClick = (video) => {
    if (tabTitle === 1) {
      fetchAlbumData(video.content_id);
    } else {
      handleButtonClick(video.content_id || video.draft_id || video.video_id);
    }
  };

  const handleCardSelect = (videoId, video) => {
    if (tabTitle === 1) {
      toggleItemSelection(videoId, 'content_id', undefined, video);
      setEditItems((prevSelected) => {
        if (prevSelected.includes(videoId)) {
          return prevSelected.filter((id) => id !== videoId);
        }
        return [...prevSelected, videoId];
      });
    } else {
      const draftId = video.draft_id;
      if (draftId && draftId?.slice(0, 9) !== 'old_video') {
        toggleItemSelection(draftId, 'draft_id', video.status, video);
      } else {
        toggleItemSelection(
          draftId || video.draft_content_id,
          'draft_id',
          video.status,
          video
        );
      }
      setEditItems((prevSelected) => {
        const idToUse = tabTitle === 0
          ? video.content_id
          : tabTitle === 2 && video.draft_content_id;
        if (prevSelected.includes(idToUse)) {
          return prevSelected.filter((id) => id !== idToUse);
        }
        return [...prevSelected, idToUse];
      });
    }
  };

  // --- Reorder handlers ---
  const moveCard = useCallback((dragIndex, hoverIndex) => {
    setContent((prevContent) => {
      const newContent = [...prevContent];
      const [draggedItem] = newContent.splice(dragIndex, 1);
      newContent.splice(hoverIndex, 0, draggedItem);
      // Store latest reordered content in ref for the drag-end handler
      reorderedContentRef.current = newContent;
      return newContent;
    });
  }, []);

  const saveReorder = useCallback(async () => {
    if (!selectedCategoryFilter?.value) return;
    // Use ref to get the latest reordered content (avoids stale closure)
    const reorderedContent = reorderedContentRef.current;
    if (!reorderedContent || reorderedContent.length === 0) return;

    setReorderLoading(true);
    try {
      // Fetch ALL videos for this category (across all pages) to build full order map
      const categoryResponse = await dataFetcher(endpoints.getMyCategory, {
        category_id: selectedCategoryFilter.value,
      });

      if (!categoryResponse?.success || !categoryResponse?.data?.[0]?.videos) {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Failed to fetch full category data',
        });
        setReorderLoading(false);
        return;
      }

      const allCategoryVideos = categoryResponse.data[0].videos;

      // Build the order map. The display list is read back ASCENDING by
      // order_number (getMyContentsBasedOnUploadDate uses order_by:1) and
      // getMyCategory also returns ASCENDING — so we must NOT rebuild global
      // positions from either raw order. Instead, keep every video's existing
      // order_number and only permute the CURRENT page's order_numbers among
      // its own items to match the new drag order. This leaves all other pages
      // exactly where they are and works regardless of which page is reordered.
      const items = {};
      allCategoryVideos.forEach((video) => {
        items[video.id] = Number(video.order_number);
      });

      // The page's own order_numbers, lowest first (display is ascending),
      // handed out top→bottom across the reordered items.
      const pageOrderNumbers = reorderedContent
        .map((item) => Number(item.order_number))
        .sort((a, b) => a - b);
      reorderedContent.forEach((item, idx) => {
        items[item.content_id] = pageOrderNumbers[idx];
      });

      await dataFetcher(endpoints.updateCategoryListVideoOrder, {
        category_id: selectedCategoryFilter.value,
        items,
      });

      setAppSnackbar({
        isVisible: true,
        message: 'Order updated',
      });
      reorderedContentRef.current = null;
      fetchContent();
    } catch (err) {
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Reorder Videos',
        description: 'Video reorder failed',
        severity: 'medium',
        errorMessage: err?.response?.data?.message || err?.message || 'Video reorder failed',
        responseStatus: err?.response?.status || null,
        responseBody: err?.response?.data?.message || null,
        requestUrl: endpoints.updateCategoryListVideoOrder,
        requestMethod: 'POST',
        component: 'YourVideos',
        userAction: 'Reorder videos called',
      });
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Failed to update order',
      });
    } finally {
      setReorderLoading(false);
    }
  }, [selectedCategoryFilter, fetchContent, setAppSnackbar]);

  useEffect(() => {
    if (open === true) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }, []);

  const toggleSelectAll = () => {
    setSelectAllChecked(!selectAllChecked);
    if (!selectAllChecked) {
      const selectedDraftIds = [];
      const selectedContentIds = [];
      const selectedVideoObjects = [];

      content?.forEach((item) => {
        if (item.uploadIsTrying === 1) {
          // Omit items with uploadIsTrying === 1
          return;
        }

        if (tabTitle === 2) {
          selectType(undefined);
          const idToPass = item?.content_id || item.draft_content_id;
          setEditItems((prevAlbumIdGroup) => {
            const uniqueSet = new Set([...prevAlbumIdGroup, idToPass]);
            const uniqueArray = Array.from(uniqueSet);
            return uniqueArray;
          });
          if (item?.draft_id?.startsWith('old_video')) {
            selectedContentIds.push(item.content_id || item.draft_content_id);
          } else {
            selectedDraftIds.push(item.draft_id);
          }
          selectedVideoObjects.push(item);
        } else if (tabTitle === 1) {
          selectType('album');
          const idToUse = item?.content_id;
          selectedVideoObjects.push(item);
        } else if (tabTitle === 0) {
          selectType(undefined);
          const idToPass = item?.content_id;
          setEditItems((prevAlbumIdGroup) => {
            const uniqueSet = new Set([...prevAlbumIdGroup, idToPass]);
            const uniqueArray = Array.from(uniqueSet);
            return uniqueArray;
          });
          if (item?.draft_id?.startsWith('old_video')) {
            selectedContentIds.push(item.content_id);
          } else {
            selectedDraftIds.push(item.draft_id);
          }
          selectedVideoObjects.push(item);
        }
      });

      setSelectedDraftIds(selectedDraftIds);
      setSelectedContentIds(selectedContentIds);
      setSelectedItems(selectedVideoObjects);
    } else {
      makeEveryThingNull();
    }
  };

  useEffect(() => {
    setNeedToShowETA(true);
    setTopOrBottom(true);
    return () => {
      setTopOrBottom(false); // Set topOrBottom to false when leaving the component
      setSelectedItems([]);
      setSelectedDraftIds([]); // Clear the selected draft IDs
      setSelectedContentIds([]); // Clear the selected content IDs
      setSelectAllChecked(false);
    };
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <DragLayer />
      <Page
        onClick={() => setIsDropdownOpen(false)}
        className={styles.page}
        contentClassName={styles.pageContent}
        id="videos-page"
        headerTheme={styles.headerTheme}
      >
        {/* { droper && <DropMe dragLeave={dragLeave} dragOver={dragOver} handleDrop={handleDrop} />} */}
        <UploadModal
          imageFiles={imageFiles}
          isVisible={uploadModalIsVisible}
          onHide={hideUploadModal}
        />
        {/* {openEditInBulk && (
        <BulkEdit
          fetchContent={fetchContent}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          openEditInBulk={openEditInBulk}
          setOpenEditInBulk={setOpenEditInBulk}
        />
      )} */}

        {/* Main Layout with Left and Right Sidebar */}
        <div className={styles.mainLayout}>
          {/* Left Sidebar - Categories, Albums, or Folders */}
          <div className={styles.leftSidebar}>
            {tabTitle === 2 ? (
              <SharedSidebar
                links={links}
                selectedLink={selectedLink}
                onLinkSelect={handleLinkSelect}
                loading={fetchingLinks}
              />
            ) : tabTitle === 1 ? (
              <AlbumsSidebar
                albums={albumFilterOptions}
                selectedAlbum={selectedAlbumFilter}
                onAlbumSelect={handleSidebarAlbumSelect}
                loading={fetchingGetMyContent}
                totalAlbumsCount={content?.length || 0}
              />
            ) : (
              <CategoriesSidebar
                setIsDummyLoader={setIsDummyLoader}
                isDummyLoader={isDummyLoader}
                categories={categoryFilterOptions}
                selectedCategory={selectedCategoryFilter}
                setSelectedItems={setSelectedItems}
                onCategorySelect={handleSidebarCategorySelect}
                loading={fetchingCategoryFilter}
                content={content}
                paginatedData={paginatedData}
                fetchContent={fetchContent}
              />
            )}
          </div>
          {/* Main Content Area */}
          <div className={styles.contentArea}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', width: '100%' }}>
              <Tabs
                value={tabTitle}
                TabIndicatorProps={{
                  style: { background: '#02071A', height: '4px' },
                }}
                onChange={handleTabChange}
                aria-label="simple tabs example"
                style={{
                  ...(getAccessChecker?.success === true && { marginTop: '31px' }),
                }}
              >
                <Tab
                  label={(
                    <span
                      className={
                        tabTitle === 0
                          ? classes.activeTab
                          : classes.customStyleOnTab
                      }
                    >
                      {contentText?.videos || 'Videos'}
                    </span>
                  )}
                />
                <Tab
                  label={(
                    <span
                      className={
                        tabTitle === 1
                          ? classes.activeTab
                          : classes.customStyleOnTab
                      }
                    >
                      {contentText?.photoAlbums || 'Photo Albums'}
                    </span>
                  )}
                />
                {SHARED_FEATURE_ENABLED && (
                  <Tab
                    label={(
                      <span
                        className={
                          tabTitle === 2
                            ? classes.activeTab
                            : classes.customStyleOnTab
                        }
                      >
                        Shared
                      </span>
                    )}
                  />
                )}
              </Tabs>
              {content?.length > 0 && (tabTitle === 0 || tabTitle === 1) && userDetails?.isSubscription && (
                <div ref={downloadControlRef} style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, paddingRight: 15 }}>
                  <span
                    className={styles.downloadText}
                    onClick={!isBulkDownloading && !preparingDownload
                      ? () => setDownloadMenuAnchor(downloadControlRef.current)
                      : undefined}
                    style={{ cursor: isBulkDownloading || preparingDownload ? 'default' : 'pointer' }}
                  >
                    Download all your videos & photos
                  </span>
                  <button
                    className={styles.bulkDownloadIconButton}
                    onClick={() => setDownloadMenuAnchor(downloadControlRef.current)}
                    disabled={isBulkDownloading || preparingDownload}
                  >
                    {preparingDownload ? (
                      <CircularProgress size={20} style={{ color: '#5aa5ef' }} />
                    ) : (
                      <DownloadIcon />
                    )}
                  </button>
                  <Menu
                    anchorEl={downloadMenuAnchor}
                    open={Boolean(downloadMenuAnchor)}
                    onClose={() => setDownloadMenuAnchor(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    marginThreshold={0}
                    PaperProps={{
                      style: {
                        width: downloadMenuAnchor ? downloadMenuAnchor.offsetWidth - 15 : undefined,
                        marginTop: 8,
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        setDownloadMenuAnchor(null);
                        downloadMultipleVideos('videos');
                      }}
                    >
                      Only Videos
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setDownloadMenuAnchor(null);
                        downloadMultipleVideos('photos');
                      }}
                    >
                      Only Photos
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setDownloadMenuAnchor(null);
                        downloadMultipleVideos('both');
                      }}
                    >
                      All Photos and Videos
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </div>
            {/* Render contributions content for Shared tab */}
            {tabTitle === 2 && (
              <div className={styles.sharedContent}>
                {/* Back bar with selection actions - shown when viewing a contributor's files */}
                {selectedContributor && (
                  <div className={styles.sharedBackBar}>
                    <button
                      type="button"
                      className={styles.sharedBackBtn}
                      onClick={() => handleContributorSelect(null)}
                      aria-label="Back to contributors"
                    >
                      <ArrowBackIcon className={styles.icon} />
                    </button>
                    <span className={styles.sharedBreadcrumb}>
                      {selectedLink?.label ? `${selectedLink.label} / ` : ''}
                      {selectedContributor.contributor_name || selectedContributor.contributor_email || 'Contributor'}
                    </span>
                    <div className={styles.sharedBackBarActions}>
                      {contributions.length > 0 && unpublishedContributions.length > 0 && (
                        <>
                          <button
                            type="button"
                            className={styles.selectAllBtn}
                            onClick={toggleSelectAllContributions}
                          >
                            {selectedContributions.length === unpublishedContributions.length && unpublishedContributions.length > 0 ? (
                              <>
                                <RadioButtonChecked className={styles.icon} />
                                Deselect All
                              </>
                            ) : (
                              <>
                                <RadioButtonUnchecked className={styles.icon} />
                                Select All
                              </>
                            )}
                          </button>
                          {selectedContributions.length > 0 && (
                            <button
                              type="button"
                              className={styles.publishBtn}
                              onClick={() => setShowPublishSettingsModal(true)}
                              disabled={publishingContributions}
                            >
                              {publishingContributions ? (
                                <CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} />
                              ) : null}
                              {`Publish (${selectedContributions.length})`}
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                {/* Contributors-level header (folder selected, no contributor yet) - holds Copy Link */}
                {selectedLink && !selectedContributor && (
                  <div className={styles.sharedBackBar}>
                    <button
                      type="button"
                      className={styles.sharedBackBtn}
                      onClick={() => handleLinkSelect(null)}
                      aria-label="Back to folders"
                    >
                      <ArrowBackIcon className={styles.icon} />
                    </button>
                    <span className={styles.sharedBreadcrumb}>
                      {selectedLink.label || 'Folder'}
                    </span>
                    {/* Toggle: all contributions (default) vs. contributor list */}
                    {/* <div className={styles.sharedViewToggle}>
                      <button
                        type="button"
                        className={`${styles.sharedViewToggleBtn} ${sharedFolderView === 'contributions' ? styles.sharedViewToggleActive : ''}`}
                        onClick={() => handleSharedFolderViewChange('contributions')}
                      >
                        All Contents
                      </button>
                      <button
                        type="button"
                        className={`${styles.sharedViewToggleBtn} ${sharedFolderView === 'contributors' ? styles.sharedViewToggleActive : ''}`}
                        onClick={() => handleSharedFolderViewChange('contributors')}
                      >
                        Contributors
                      </button>
                    </div> */}
                    <div className={styles.sharedBackBarActions}>
                      {/* Select all / Publish: only in the all-contributions view */}
                      {sharedFolderView === 'contributions' && unpublishedContributions.length > 0 && (
                        <>
                          <button
                            type="button"
                            className={styles.selectAllBtn}
                            onClick={toggleSelectAllContributions}
                          >
                            {selectedContributions.length === unpublishedContributions.length && unpublishedContributions.length > 0 ? (
                              <>
                                <RadioButtonChecked className={styles.icon} />
                                Deselect All
                              </>
                            ) : (
                              <>
                                <RadioButtonUnchecked className={styles.icon} />
                                Select All
                              </>
                            )}
                          </button>
                          {selectedContributions.length > 0 && (
                            <button
                              type="button"
                              className={styles.publishBtn}
                              onClick={() => setShowPublishSettingsModal(true)}
                              disabled={publishingContributions}
                            >
                              {publishingContributions ? (
                                <CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} />
                              ) : null}
                              {`Publish (${selectedContributions.length})`}
                            </button>
                          )}
                        </>
                      )}
                      {/* Edit folder: available for every folder */}
                      <button
                        type="button"
                        className={styles.copyLinkBtn}
                        onClick={openEditFolderModal}
                        title="Edit folder"
                      >
                        <EditFolderIcon className={styles.icon} />
                        Edit
                      </button>
                      {/* Copy Link: active copies directly, revoked opens reactivate popup, expired hidden */}
                      {getFolderStatus(selectedLink) !== 'expired' && (
                        <button
                          type="button"
                          className={`${styles.copyLinkBtn} ${copiedFolderLink ? styles.copied : ''}`}
                          onClick={handleCopyFolderLink}
                          title="Copy shared folder link"
                        >
                          <ShareLinkIcon className={styles.icon} />
                          {copiedFolderLink ? 'Copied!' : 'Copy Link'}
                        </button>
                      )}
                    </div>
                  </div>
                )}
                {fetchingLinks || fetchingContributions || fetchingContributors ? (
                  <div className={styles.loadingGrid}>
                    {Array.from({ length: 6 }).map((_, index) => (
                      <div key={index} className={styles.skeletonCard}>
                        <div className={styles.skeletonThumbnail} />
                        <div className={styles.skeletonText} />
                        <div className={styles.skeletonMeta} />
                      </div>
                    ))}
                  </div>
                ) : !selectedLink ? (
                  // Folder (link) level - no folder selected yet
                  links.length > 0 ? (
                    <div className={styles.contributorFoldersGrid}>
                      {links.map((link, index) => (
                        <LinkFolderCard
                          key={link.uuid || link.id || index}
                          link={link}
                          onClick={handleLinkSelect}
                          coverUrl={folderCovers[link.uuid]}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className={styles.emptyState}>
                      <p>No folders found</p>
                    </div>
                  )
                ) : !selectedContributor ? (
                  // Folder selected: either the contributor list or every
                  // contribution in the folder (default), based on the toggle
                  sharedFolderView === 'contributors' ? (
                    contributors.length > 0 ? (
                      <div className={styles.contributorFoldersGrid}>
                        {contributors.map((contributor, index) => (
                          <ContributorFolderCard
                            key={contributor.contributor_email || contributor.uuid || index}
                            contributor={contributor}
                            onClick={handleContributorSelect}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className={styles.emptyState}>
                        <p>No contributors found</p>
                      </div>
                    )
                  ) : (
                    // "All Contents" view: grid on the left, contributor
                    // filter sidebar on the right.
                    <div className={styles.contributionsLayout}>
                      <div
                        className={styles.contributionsMain}
                        style={filteringContributions ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
                      >
                        {contributions.length === 0 ? (
                          <div className={styles.emptyState}>
                            <p>{sidebarContributor ? 'No contributions from this contributor yet' : 'No contributions found'}</p>
                          </div>
                        ) : (
                          renderContributionsGrid()
                        )}
                      </div>
                      {contributors.length > 0 && renderContributorSidebar()}
                    </div>
                  )
                ) : contributions.length === 0 ? (
                  // Files level - contributor selected but nothing to show
                  <div className={styles.emptyState}>
                    <p>No contributions found</p>
                  </div>
                ) : (
                  renderContributionsGrid()
                )}
              </div>
            )}
            {tabTitle !== 2 && (
              <div className={styles.filterBar}>
                <div className={styles.filterBarOrder}>Most Recent</div>
                <div className={styles.filterButton}>
                  <FilterIcon className={styles.filterButtonIcon} />
                </div>
              </div>
            )}
            {tabTitle !== 2 && (
            <div className={styles.dropdiv}>
              {/* {loading ? <RotatingLoader /> : ( */}
              <div className={styles.flexBorad}>
                {!(tabTitle === 1 && selectedAlbumFilter) && (
                  <div className={styles.search_container}>
                    <input
                      value={searchTerm}
                      onChange={handleSearchInputChange}
                      type="text"
                      className={styles.search_input}
                      placeholder="Search by title"
                    />
                    {searchTerm !== '' && (
                      <button
                        type="submit"
                        className={styles.search_button}
                        onClick={performSearch}
                      >
                        <img src={Close} alt="Close" />
                      </button>
                    )}
                  </div>
                )}
                <div className={styles.viewToggle}>
                  <button
                    className={`${styles.viewButton} ${viewMode === 'grid' ? styles.active : ''
                      }`}
                    onClick={() => setViewMode('grid')}
                    title="Grid view"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path d="M1 2h4v4H1V2zm0 6h4v4H1V8zm6-6h4v4H7V2zm0 6h4v4H7V8zm6-6v4h4V2h-4zm0 6h4v4h-4V8z" />
                    </svg>
                  </button>
                  <button
                    className={`${styles.viewButton} ${viewMode === 'list' ? styles.active : ''
                      }`}
                    onClick={() => setViewMode('list')}
                    title="List view"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path d="M1 2h14v2H1V2zm0 4h14v2H1V6zm0 4h14v2H1v-2z" />
                    </svg>
                  </button>
                </div>
                <div className={styles.droperSelection}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      minWidth: 280,
                      backgroundColor: 'white',
                      borderRadius: 8
                    }}
                  >
                    <Select
                      value={`${sortBy}-${order}`}
                      onChange={(e) => sortHandler(e.target.value)}
                      displayEmpty
                      style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        fontFamily: "'Montserrat', sans-serif",
                      }}
                      startAdornment={
                        <SortIcon style={{ marginRight: 8, fontSize: 18, color: '#666' }} />
                      }
                    >
                      {((selectedCategoryFilter && tabTitle === 0)
                        || (tabTitle === 1 && selectedAlbumFilter)) && (
                        <MenuItem value="order_number-1">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                            <LayoutIcon style={{ fontSize: 18, color: '#666' }} />
                            <span className={styles.eachSortOpt}>Layout Order</span>
                          </div>
                        </MenuItem>
                      )}
                      {!(tabTitle === 1 && selectedAlbumFilter) && [
                        <MenuItem key="date-0" value="date-0">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                            <DateIcon style={{ fontSize: 18, color: '#666' }} />
                            <span className={styles.eachSortOpt}>Date Published</span>
                            <ArrowUpward style={{ fontSize: 16, color: '#4CAF50' }} />
                          </div>
                        </MenuItem>,
                        <MenuItem key="date-1" value="date-1">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                            <DateIcon style={{ fontSize: 18, color: '#666' }} />
                            <span className={styles.eachSortOpt}>Date Published</span>
                            <ArrowDownward style={{ fontSize: 16, color: '#FF9800' }} />
                          </div>
                        </MenuItem>
                      ]}
                      <MenuItem value="name-1">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                          <TextIcon style={{ fontSize: 18, color: '#666' }} />
                          <span className={styles.eachSortOpt}>Name (A-Z)</span>
                          <ArrowUpward style={{ fontSize: 16, color: '#4CAF50' }} />
                        </div>
                      </MenuItem>
                      <MenuItem value="name-0">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                          <TextIcon style={{ fontSize: 18, color: '#666' }} />
                          <span className={styles.eachSortOpt}>Name (Z-A)</span>
                          <ArrowDownward style={{ fontSize: 16, color: '#FF9800' }} />
                        </div>
                      </MenuItem>
                      {(tabTitle === 0 || tabTitle === 2) && !selectedCategoryFilter && [
                        <MenuItem key="category-0" value="category-1">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                            <CategoryIcon style={{ fontSize: 18, color: '#666' }} />
                            <span className={styles.eachSortOpt}>Category (A-Z)</span>
                            <ArrowUpward style={{ fontSize: 16, color: '#4CAF50' }} />
                          </div>
                        </MenuItem>,
                        <MenuItem key="category-1" value="category-0">
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                            <CategoryIcon style={{ fontSize: 18, color: '#666' }} />
                            <span className={styles.eachSortOpt}>Category (Z-A)</span>
                            <ArrowDownward style={{ fontSize: 16, color: '#FF9800' }} />
                          </div>
                        </MenuItem>
                      ]}
                      {/* <MenuItem value="status">
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
                        <VisibilityIcon style={{ fontSize: 18, color: '#666' }} />
                        <span style={{ flex: 1 }}>Visibility (A-Z)</span>
                        <ArrowUpward style={{ fontSize: 16, color: '#4CAF50' }} />
                      </div>
                    </MenuItem> */}
                    </Select>
                  </FormControl>
                  {removeSort === true && (
                    <CancelIcon
                      style={{
                        cursor: 'pointer',
                        marginLeft: 8,
                        color: '#f44336',
                        fontSize: 24,
                        transition: 'color 0.2s'
                      }}
                      onClick={() => {
                        if (selectedCategoryFilter || (tabTitle === 1 && selectedAlbumFilter)) {
                          // On a specific category or album: restore Layout Order
                          setDataLoader(true);
                          setRemoveSort(false);
                          setLoading(true);
                          setOrder(1);
                          setSortBy('order_number');
                        } else {
                          resetFilters();
                        }
                        handleSelect('');
                        selectPage(1);
                        setTimeout(() => { fetchContent(); }, 0);
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = '#d32f2f';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = '#f44336';
                      }}
                    />
                  )}
                </div>

                {/* Sort Order Toggle */}
                {/* <div className={styles.sortOrderButtons}>
                <button
                  className={`${styles.sortOrderButton} ${styles.active}`}
                  onClick={() => {
                    setOrder(order === 1 ? 0 : 1);
                    setDataLoader(true);
                  }}
                  title={order === 1 ? 'Ascending order' : 'Descending order'}
                >
                  {order === 1 ? <ArrowUpward style={{ fontSize: 18 }} /> : <ArrowDownward style={{ fontSize: 18 }} />}
                </button>
              </div> */}
              </div>
            </div>
            )}
            {editLoader === true ? (
              <RotatingLoader />
            ) : (
              <>
                {/* VideoEditModal for single video edit */}
                {tabTitle === 0 && openEditVideoModal && (
                  <VideoEditModal
                    open={openEditVideoModal}
                    onClose={() => hideModal('edit')}
                    videoId={contentDetails?.id || selectedItems[0]?.id || selectedItems[0]}
                    initialVideoData={contentDetails}
                    onSaveSuccess={() => {
                      fetchContent();
                      hideModal('edit');
                    }}
                    onDownloadVideos={downloadSelectedVideos}
                  />
                )}

                {/* MultipleVideoEditModal for bulk edit - only opens from "Edit in Bulk" button */}
                {tabTitle === 0 && openEditInBulk && selectedItems?.length > 1 && (
                  <MultipleVideoEditModal
                    open={openEditInBulk}
                    onClose={() => {
                      setOpenEditInBulk(false);
                      setSelectedItems([]);
                      setSelectAllChecked(false);
                    }}
                    selectedItems={selectedItems}
                    videoIds={selectedItems?.map((item) => item?.id || item)}
                    onSaveSuccess={() => {
                      fetchContent();
                      setOpenEditInBulk(false);
                      setSelectedItems([]);
                      setSelectAllChecked(false);
                    }}
                  />
                )}
                {/* Use PhotoEditModal for photo albums */}
                {tabTitle === 1 && (
                  <PhotoEditModal
                    selectedItems={selectedItems}
                    contentDetails={contentDetails}
                    open={openEditVideoModal}
                    onClose={() => hideModal('edit')}
                    userData={null}
                    onDownloadAlbums={downloadSelectedAlbums}
                  />
                )}
              </>
            )}
            {dataLoader === true && tabTitle !== 2 && <RotatingLoader />}
            {fetchingCategories && tabTitle !== 2 && <RotatingLoader />}
            <div
              ref={videoListContainerRef}
              className={styles.videoListContainer}
              style={tabTitle === 2 ? { display: 'none' } : undefined}
              onDrop={handleDrop}
              onDragOver={(e) => dragOver(e)}
              onDragLeave={(e) => dragLeave(e)}
            >
              {viewMode === 'grid' ? (
                <div className={styles.contentContainer}>
                  {tabTitle === 1 && selectedAlbumFilter ? (
                    <AlbumPhotosView
                      ref={albumPhotosViewRef}
                      album={selectedAlbumFilter}
                      sortBy={sortBy}
                      order={order}
                      onLoadingChange={(isLoading) => {
                        setDataLoader(isLoading);
                        setLoading(isLoading);
                      }}
                      selectedPhotos={selectedPhotos}
                      setSelectedPhotos={setSelectedPhotos}
                    />
                  ) : (
                  <>
                  {content?.length > 0 && !holdWhileDelete && tabTitle !== 2 && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '4px 0' }}>
                      <button
                        className={`${styles.selectAllButton} ${selectAllChecked ? styles.active : ''}`}
                        onClick={toggleSelectAll}
                      >
                        {selectAllChecked ? (
                          <>
                            <RadioButtonChecked className={styles.icon} />
                            Deselect All
                          </>
                        ) : (
                          <>
                            <RadioButtonUnchecked className={styles.icon} />
                            Select All
                          </>
                        )}
                      </button>
                    </div>
                  )}
                  {tabTitle === 2 ? null : isDummyLoader ? (
                    <div className={styles.loadingGrid}>
                      {Array.from({ length: 10 }).map((_, index) => (
                        <div key={index} className={styles.skeletonCard}>
                          <div className={styles.skeletonThumbnail} />
                          <div className={styles.skeletonText} />
                          <div className={styles.skeletonMeta} />
                        </div>
                      ))}
                    </div>
                  ) : (content?.length === 0 && Object.keys(dummyObject).length === 0) ? (
                    <div className={styles.emptyState}>
                      <p>
                        {tabTitle === 0
                          ? 'No Videos'
                          : 'No Photos'}
                      </p>
                    </div>
                  ) : (
                    <>
                      {reorderLoading && <RotatingLoader />}
                    <div className={styles.videoGrid}>
                      {addDummyObject()}
                      {content?.map((video, index) => {
                        if (video.type === 'album') {
                          return (
                            <DraggableVideoCard
                              key={video.content_id || index}
                              video={video}
                              index={index}
                              isSelected={
                                selectedVideo === video.content_id
                                || isItemSelected(video.content_id)
                              }
                              onSelect={handleCardSelect}
                              onCardClick={handleCardClick}
                              onViewPhotos={handleViewAlbumPhotos}
                              tabTitle={tabTitle}
                              isItemSelected={isItemSelected}
                              toggleItemSelection={toggleItemSelection}
                              setEditItems={setEditItems}
                              setEditItemsStatus={setEditItemsStatus}
                              renderContent={renderContent}
                              changeDateFormat={changeDateFormat}
                              selectedItems={selectedItems}
                              isDragActive={isDragActive}
                              setIsDragActive={setIsDragActive}
                              // canReorder={!!selectedCategoryFilter && tabTitle === 0}
                              canReorder={false}
                              moveCard={moveCard}
                              onReorderEnd={saveReorder}
                            />
                          );
                        }
                        const videoId = video.content_id || video.video_id || video.draft_content_id;
                        return (
                          <DraggableVideoCard
                            key={videoId || index}
                            video={video}
                            index={index}
                            isSelected={
                              isItemSelected(videoId) || selectedVideo === videoId
                            }
                            onSelect={handleCardSelect}
                            onCardClick={handleCardClick}
                            onViewPhotos={
                              tabTitle === 1 ? handleViewAlbumPhotos : undefined
                            }
                            tabTitle={tabTitle}
                            isItemSelected={isItemSelected}
                            toggleItemSelection={toggleItemSelection}
                            setEditItems={setEditItems}
                            setEditItemsStatus={setEditItemsStatus}
                            renderContent={renderContent}
                            changeDateFormat={changeDateFormat}
                            selectedItems={selectedItems}
                            isDragActive={isDragActive}
                            setIsDragActive={setIsDragActive}
                            // canReorder={!!selectedCategoryFilter && tabTitle === 0}
                            canReorder={false}
                            moveCard={moveCard}
                            onReorderEnd={saveReorder}
                          />
                        );
                      })}
                    </div>
                    </>
                  )}
                  </>
                  )}
                  <DetailsPanel
                    video={selectedVideoForPanel}
                    isOpen={isPanelOpen}
                    onClose={() => {
                      setSelectedVideoForPanel(null);
                      setIsPanelOpen(false);
                    }}
                  />
                </div>
              ) : (
                <Table id="menu-bar-table">
                  {/* <hr className={styles.linexr} /> */}
                  <TableHead className={styles.tableHeaderSticky}>
                    {selectedVideo || selectedItems?.length > 0 ? (
                      <>
                        <TableRow className={styles.preferenceContainer}>
                          <TableHeaderCell
                            className={styles.preferences}
                            colSpan={7}
                            scope="col"
                          >
                            <div className={styles.sticlyMe}>
                              <div className={styles.preferencesContent}>
                                <div className={styles.prefOptions}>
                                  {selectedItems?.length <= 1 ? (
                                    <div className={styles.editOptions}>
                                      <div
                                        className={styles.numVideosSelected}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          if (singleEdit === true) {
                                            setEditVideoModal(true);
                                          } else if (tabTitle === 1) {
                                            fetchAlbumData(
                                              selectedItems[0]?.content_id
                                            );
                                          } else {
                                            handleButtonClick(
                                              editItems[0],
                                              editItemsStatus[0]
                                            );
                                          }
                                        }}
                                      >
                                        {commonText?.edit || 'Edit'}
                                      </div>
                                      <div>
                                        <PrefDropDown
                                          name={
                                            contentText?.moreActions
                                            || 'More Actions'
                                          }
                                          options={
                                            tabTitle
                                              ? [
                                                {
                                                  name: deletingVideo
                                                    ? `${commonText?.deleting
                                                    || 'Deleting'
                                                    }...`
                                                    : commonText?.delete
                                                    || 'Delete',
                                                  action: async () => {
                                                    setDraft_idPLacer(
                                                      undefined
                                                    );
                                                    setModal(true);
                                                  },
                                                },
                                              ]
                                              : [
                                                {
                                                  name: deletingVideo
                                                    ? `${commonText?.deleting
                                                    || 'Deleting'
                                                    }...`
                                                    : commonText?.delete
                                                    || 'Delete',
                                                  action: async () => {
                                                    setDraft_idPLacer(
                                                      undefined
                                                    );
                                                    setModal(true);
                                                  },
                                                },
                                              ]
                                          }
                                        />
                                      </div>
                                    </div>
                                  ) : selectedItems?.length > 1 ? (
                                    <div className={styles.editOptions}>
                                      <div
                                        className={styles.numVideosSelected}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setOpenEditInBulk(true)}
                                      >
                                        {commonText?.edit || 'Edit'}
                                      </div>
                                      <div
                                        className={styles.numVideosSelected}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setModal(true)}
                                      >
                                        {commonText?.delete || 'Delete'}
                                        {' '}
                                        {selectedItems?.length}
                                        {' '}
                                        {tabTitle === 1 ? 'Album' : 'Videos'}
                                      </div>
                                    </div>
                                  ) : null}
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  {isDownloading && (
                                    <>
                                      <div
                                        className={styles.numVideosSelected}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          setEditVideoModal(true);
                                        }}
                                      >
                                        {commonText?.prepareFileDownload
                                          || 'Preparing file for download'}
                                      </div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <div className={styles.dotFlashing} />
                                    </>
                                  )}
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </div>

                                <div className={styles.preferencesContentButtons}>
                                  {(editMenu || categoriesMenu) && (
                                    <>
                                      <label
                                        className={styles.cancelEditMenu}
                                        htmlFor="close-button-input"
                                        style={{
                                          cursor: 'pointer',
                                          color: '#5AA5EF',
                                        }}
                                      >
                                        {commonText?.cancel || 'Cancel'}
                                      </label>
                                      &nbsp;&nbsp;&nbsp;
                                    </>
                                  )}
                                  {selectAllChecked && (
                                    <div
                                      style={{ marginRight: '10px' }}
                                      className={styles.numVideosSelected}
                                    >
                                      {`items of page ${selectedPage} is selected`}
                                    </div>
                                  )}
                                  <CancelIcon
                                    className={styles.closeButton}
                                    onClick={() => makeEveryThingNull()}
                                  />
                                  &nbsp;&nbsp;&nbsp;
                                </div>
                              </div>
                            </div>
                            <a
                              download={videoData?.title}
                              target="_blank"
                              id="video-download"
                              rel="noreferrer"
                              href={videoData?.file}
                              hidden
                            >
                              {commonText?.download || 'Download'}
                            </a>
                            {editMenu && (
                              <EditMenu
                                formField={editMenu[3]}
                                id={editMenu[0]}
                                name={editMenu[1]}
                                onChange={() => {
                                  onDataChange();
                                  fetchData();
                                  onMenuClose();
                                  selectVideo(undefined);
                                }}
                                onClose={onMenuClose}
                                setActionStatus={setActionHandlingStatus}
                                value={editMenu[2]}
                                type={selectedType}
                              />
                            )}
                            {visibilityMenu && (
                              <VisibilityMenu
                                category={visibilityMenu[5]}
                                subCategory={visibilityMenu[6]}
                                defaultGroup={visibilityMenu[4]}
                                id={visibilityMenu[0]}
                                onChange={() => {
                                  onDataChange();
                                  fetchData();
                                  onMenuClose();
                                  selectVideo(undefined);
                                }}
                                onClose={onMenuClose}
                                setActionStatus={setActionHandlingStatus}
                                value={visibilityMenu[2]}
                                setVisibilityMenu={setVisibilityMenu}
                                type={selectedType}
                              />
                            )}
                            {categoriesMenu && (
                              <CategoriesMenuContainer
                                defaultCategory={categoriesMenu[1]}
                                defaultSubCategory={categoriesMenu[2]}
                                id={categoriesMenu[0]}
                                onChange={() => {
                                  fetchData();
                                  onMenuClose();
                                  selectVideo(undefined);
                                }}
                                onClose={onMenuClose}
                                setActionStatus={setActionHandlingStatus}
                                visibility={categoriesMenu[3]}
                              />
                            )}
                          </TableHeaderCell>
                        </TableRow>
                        <tr className={styles.preferenceContainerFill} />
                      </>
                    ) : null}
                    <TableRow>
                      {/* {tabTitle !== 1
              ? ( */}
                      <TableHeaderCell
                        align="center"
                        className={cn({
                          [styles.headerCell]: true,
                          [styles.checkboxCell]: true,
                        })}
                      >
                        {!isContentLoaded || fetchingGetMyContent ? (
                          <Skeleton
                            animation="wave"
                            variant="circle"
                            width={45}
                            height={45}
                          />
                        ) : (
                          <Checkbox
                            status={selectAllChecked} // Use a state variable to manage the select all checkbox
                            onClick={toggleSelectAll} // Implement a function to toggle select all
                            setSelectAllChecked={setSelectAllChecked}
                          />
                        )}
                      </TableHeaderCell>
                      {/* ) : (
                      <TableHeaderCell
                align="center"
                className={cn({ [styles.headerCell]: true, [styles.checkboxCell]: true })}
                      />
                        )} */}
                      <TableHeaderCell align="left" className={styles.headerCell}>
                        <SubTitle
                          titleName={contentText?.preview || 'Content Preview'}
                          sortType="name"
                          isTitle
                        />
                      </TableHeaderCell>
                      {tabTitle === 0 || tabTitle === 2 ? (
                        <TableHeaderCell
                          align="center"
                          className={styles.headerCell}
                        >
                          <SubTitle
                            titleName={contentText?.categoryTitle || 'Category'}
                            sortType="category"
                          />
                        </TableHeaderCell>
                      ) : null}
                      {/* <TableHeaderCell align="center" className={styles.headerCell}>
                <SubTitle
                  titleName="Local status"
                  sortType="status"
                />
              </TableHeaderCell> */}
                      <TableHeaderCell
                        align="center"
                        className={styles.headerCell}
                      >
                        <SubTitle titleName="Visibility" sortType="status" />
                      </TableHeaderCell>
                      <TableHeaderCell
                        align="center"
                        justifyContent="center"
                        className={styles.headerCell}
                      >
                        {/* <div className={styles.theFlex}> */}
                        <SubTitle
                          titleName={
                            contentText?.datePublished || 'Date Published'
                          }
                          sortType="date"
                        />
                        {/* {loading && <CircularProgress />}
                </div> */}
                      </TableHeaderCell>
                      <TableHeaderCell
                        align="center"
                        className={styles.headerCell}
                      >
                        {`${contentText?.size || 'Size'}`}
                      </TableHeaderCell>
                    </TableRow>
                  </TableHead>
                  {/* <hr className={styles.linex} /> */}
                  <TableBody className={styles.tableBody}>
                    {addDummyObject()}
                    {isDummyLoader ? (
                      <DummyRow />
                    ) : dataLoading
                      || !isContentLoaded
                      || fetchingGetMyContent ? (
                      <>
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                        <DummyRow />
                      </>
                    ) : content?.length === 0 ? (
                      <PreloadData>
                        {tabTitle === 0 || tabTitle === 2
                          ? 'No Videos'
                          : 'No Photos'}
                      </PreloadData>
                    ) : (
                      <>
                        {content?.length ? (
                          content?.map(
                            (
                              {
                                content: contentData,
                                content_type,
                                category_id,
                                video_id,
                                content_id,
                                created,
                                description,
                                video_description,
                                thumbnail,
                                file,
                                publish_date,
                                status,
                                subcategory_id,
                                draft_content_id,
                                title,
                                category_name,
                                type,
                                views,
                                visibility,
                                photos,
                                thumbnails,
                                content_status,
                                category,
                                album_size,
                                video_size,
                                draft_id,
                                initializing,
                                transcoder_status,
                                workflow_status,
                              },
                              idx,
                              arr
                            ) => (type === 'album' ? (
                              <>
                                <TableRow
                                  className={cn({
                                    [styles.tableRow]: true,
                                    [styles.selectedRow]:
                                      selectedType === 'album'
                                      && selectedVideo === content_id,
                                  })}
                                  key={uuid()}
                                >
                                  <TableCell className={styles.bodyCell}>
                                    <Checkbox
                                      status={
                                        selectedVideo === content_id
                                        || isItemSelected(content_id)
                                      }
                                      //
                                      onClick={() => {
                                        const videoObject = {
                                          content_id,
                                          video_id,
                                          title,
                                          description,
                                          video_description,
                                          thumbnail,
                                          thumbnails,
                                          category_name,
                                          category,
                                          content_status,
                                          status,
                                          publish_date,
                                          created,
                                          video_size,
                                          draft_id,
                                          transcoder_status,
                                          workflow_status,
                                          draft_content_id,
                                          type,
                                          views,
                                          visibility,
                                          photos,
                                          album_size,
                                          category_id,
                                          subcategory_id,
                                          content: contentData,
                                          content_type,
                                          file,
                                          initializing,
                                        };
                                        toggleItemSelection(
                                          content_id,
                                          'content_id',
                                          undefined,
                                          videoObject
                                        );
                                        setEditItems((prevSelected) => {
                                          const idToUse = content_id;
                                          if (prevSelected.includes(idToUse)) {
                                            return prevSelected.filter(
                                              (id) => id !== idToUse
                                            );
                                          }
                                          return [...prevSelected, idToUse];
                                        });
                                        setEditItemsStatus(
                                          (prevSelectedStatus) => {
                                            const idToUse = status;
                                            if (
                                              prevSelectedStatus.includes(
                                                idToUse
                                              )
                                            ) {
                                              return prevSelectedStatus.filter(
                                                (id) => id !== idToUse
                                              );
                                            }
                                            return [
                                              ...prevSelectedStatus,
                                              idToUse,
                                            ];
                                          }
                                        );
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    className={cn({
                                      [styles.bodyCell]: true,
                                      [styles.videoPreviewCell]: true,
                                    })}
                                  >
                                    <div className={styles.previewContainer}>
                                      {/* eslint-disable-next-line */}
                                      <img
                                        onClick={() => {
                                          toggleVideoSelection(
                                            content_id,
                                            arr[idx],
                                            'album',
                                            true
                                          );
                                        }}
                                        className={cn({
                                          [styles.previewImage]: true,
                                          [styles.albumImage]: true,
                                        })}
                                        src={thumbnail}
                                        alt={content_id}
                                      />
                                      <div className={styles.previewText}>
                                        {/* eslint-disable-next-line */}
                                        <TruncatedTitle
                                          title={title}
                                          className={styles.previewTitle}
                                        />
                                        {showImage === content_id ? (
                                          <DownIcon
                                            className={styles.expandIcon}
                                            onClick={() => {
                                              setCallAlbum([]);
                                              setShowImage(null);
                                              setAlbumImages(undefined);
                                            }}
                                          />
                                        ) : (
                                          <UpIcon
                                            className={styles.expandIcon}
                                            onClick={() => {
                                              showAlbumImages(content_id);
                                              setShowImage(content_id);
                                              setAlbumImages(photos);
                                            }}
                                          />
                                        )}
                                        {/* eslint-disable-next-line */}
                                        <span
                                          className={styles.previewDescription}
                                        >
                                          {description}
                                        </span>
                                        {/* <span onClick={() => { toggleVideoSelection(content_id, arr[idx], 'album', true); }} className={styles.previewDescription}>{description}</span> */}
                                      </div>
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={styles.bodyCell}
                                  >
                                    {tempUploadPercentages && tempUploadPercentages[content_id]
                                      ? tempUploadPercentages[content_id]
                                      : content_status === 'Public'
                                        ? 'All Viewers'
                                        : content_status}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={styles.bodyCell}
                                  >
                                    {changeDateFormat(
                                      publish_date?.split(' ')[0]
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    className={styles.bodyCell}
                                  >
                                    {tempUploadSizes[content_id]
                                      ? tempUploadSizes[content_id]
                                      : album_size < 1 && album_size > 0
                                        ? `${(album_size * 1024).toFixed(2)} KB`
                                        : album_size < 1000 && album_size > 1
                                          ? `${album_size} MB`
                                          : album_size > 1000
                                            ? `${(album_size / 1024).toFixed(2)} GB`
                                            : '--'}
                                  </TableCell>
                                </TableRow>
                                {showImage === content_id ? (
                                  <TableRow
                                    className={cn({
                                      [styles.tableRow]: true,
                                      [styles.selectedRow]:
                                        selectedType === 'album'
                                        && selectedVideo === content_id,
                                    })}
                                    key={uuid()}
                                  >
                                    <TableCell
                                      align="center"
                                      className={styles.bodyCell}
                                      colSpan={7}
                                    >
                                      <PhotoList
                                        photos={callAlbum[0]?.photos}
                                        albumId={content_id}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ) : null}
                              </>
                            ) : filter && status ? (
                              <TableRow
                                className={cn({
                                  [styles.tableRow]: true,
                                  [styles.processingVideo]:
                                    tabTitle === 0 && !status,
                                  [styles.selectedRow]:
                                    selectedType === 'video'
                                    && selectedVideo
                                    === (draft_content_id
                                      || content_id
                                      || video_id),
                                })}
                                key={uuid()}
                              >
                                <TableCell className={styles.bodyCell}>
                                  {draft_content_id
                                    || content_id
                                    || video_id ? (
                                    <Checkbox
                                      status={
                                        selectedVideo !== undefined
                                        && selectedVideo
                                        === (tabTitle === 2
                                          ? draft_content_id
                                          : content_id || video_id)
                                      }
                                      onClick={() => {
                                        const videoObject = {
                                          content_id,
                                          video_id,
                                          title,
                                          description,
                                          video_description,
                                          thumbnail,
                                          thumbnails,
                                          category_name,
                                          category,
                                          content_status,
                                          status,
                                          publish_date,
                                          created,
                                          video_size,
                                          draft_id,
                                          transcoder_status,
                                          workflow_status,
                                          draft_content_id,
                                          type,
                                          views,
                                          visibility,
                                          photos,
                                          album_size,
                                          category_id,
                                          subcategory_id,
                                          content: contentData,
                                          content_type,
                                          file,
                                          initializing,
                                        };
                                        if (
                                          draft_id
                                          && draft_id?.slice(0, 9) !== 'old_video'
                                        ) {
                                          toggleItemSelection(
                                            draft_id,
                                            'draft_id',
                                            status,
                                            videoObject
                                          );
                                        } else {
                                          toggleItemSelection(
                                            draft_id || draft_content_id,
                                            'draft_id',
                                            status,
                                            videoObject
                                          );
                                        }
                                        setEditItems((prevSelected) => {
                                          const idToUse = tabTitle === 0
                                            ? content_id
                                            : tabTitle === 2
                                            && draft_content_id;
                                          if (prevSelected.includes(idToUse)) {
                                            return prevSelected.filter(
                                              (id) => id !== idToUse
                                            );
                                          }
                                          return [...prevSelected, idToUse];
                                        });
                                        setEditItemsStatus(
                                          (prevSelectedStatus) => {
                                            const idToUse = status;
                                            if (
                                              prevSelectedStatus.includes(
                                                idToUse
                                              )
                                            ) {
                                              return prevSelectedStatus.filter(
                                                (id) => id !== idToUse
                                              );
                                            }
                                            return [
                                              ...prevSelectedStatus,
                                              idToUse,
                                            ];
                                          }
                                        );
                                      }}
                                      selected={isItemSelected(
                                        draft_id
                                          && draft_id?.slice(0, 9) !== 'old_video'
                                          ? draft_id
                                          : content_id || draft_content_id
                                      )}
                                    />
                                  ) : (
                                    <Spinner />
                                  )}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={cn({
                                    [styles.bodyCell]: true,
                                    [styles.videoPreviewCell]: true,
                                  })}
                                >
                                  <div
                                    onClick={() => {
                                      setSelectedIdType(
                                        video_id || content_id
                                          ? 'videoId'
                                          : 'draft'
                                      );
                                    }}
                                    className={styles.previewContainer}
                                  >
                                    {/* <div onClick={() => { (content_id || video_id || draft_content_id) && toggleVideoSelection(tabTitle === 2 ? draft_content_id : (content_id || video_id), arr[idx], 'video', true); setSelectedIdType((video_id || content_id) ? 'videoId' : 'draft'); }} className={styles.previewContainer}> */}
                                    <img
                                      className={styles.previewImage}
                                      src={
                                        Array.isArray(thumbnail)
                                          ? thumbnail[0] || AlterImage
                                          : thumbnail
                                          || thumbnails
                                          || AlterImage
                                      }
                                      alt={title}
                                    />
                                    <div className={styles.previewText}>
                                      <TruncatedTitle
                                        title={title}
                                        className={styles.previewTitle}
                                      />
                                      <span
                                        className={styles.previewDescription}
                                      >
                                        {description || video_description}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {tabTitle === 2 ? category_name : category}
                                </TableCell>
                                {/* <TableCell align="center" className={styles.bodyCell}>
                              {dataD[draft_id]?.status === 'Finished' ? (
                                <a href={dataD[draft_id]?.key}>M3U8</a>
                              ) : (
                                dataD[draft_id]?.status
                              )}
                            </TableCell> */}
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {renderContent(
                                    draft_id,
                                    content_status,
                                    status,
                                    video_id
                                  )}
                                  {tabTitle !== 1
                                    && (uploadPercentages[draft_id] > 0
                                      || uploadPercentages[draft_id]
                                      === 'Starting Upload')
                                    && (draft_content_id
                                      || content_id
                                      || video_id) && (
                                      <button
                                        onClick={() => {
                                          setModal(true);
                                          setDraft_idPLacer(draft_id);
                                        }}
                                        className={styles.cancelPlz}
                                      >
                                        Cancel
                                      </button>
                                    )}
                                  {/* {!Number.isNaN(eta) && tabTitle !== 1 && uploadPercentages[draft_id] > 0 && (
                                <div className={styles.Sppped}>
                                  {eta > 1 ? `${eta} Minutes remaining` : eta <= 1 ? 'Less than a minute' : 'Calculating'}
                                </div>
                                  )} */}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {changeDateFormat(
                                    publish_date?.split(' ')[0]
                                  ) || created?.split(' ')[0]}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {video_size < 1 && video_size > 0
                                    ? `${(video_size * 1024).toFixed(2)} KB`
                                    : video_size < 1000 && video_size > 1
                                      ? `${video_size} MB`
                                      : video_size > 1000
                                        ? `${(video_size / 1024).toFixed(2)} GB`
                                        : '--'}
                                </TableCell>
                              </TableRow>
                            ) : !filter ? (
                              <TableRow
                                className={cn({
                                  [styles.tableRow]: true,
                                  [styles.processingVideo]:
                                    tabTitle === 0 && !status,
                                  [styles.selectedRow]:
                                    selectedType === 'video'
                                    && selectedVideo
                                    === (draft_content_id
                                      || content_id
                                      || video_id),
                                })}
                                key={uuid()}
                              >
                                <TableCell className={styles.bodyCell}>
                                  {draft_content_id
                                    || content_id
                                    || video_id ? (
                                    <Checkbox
                                      status={
                                        selectedVideo !== undefined
                                        && selectedVideo
                                        === (tabTitle === 2
                                          ? draft_content_id
                                          : content_id || video_id)
                                      }
                                      onClick={() => {
                                        const videoObject = {
                                          content_id,
                                          video_id,
                                          title,
                                          description,
                                          video_description,
                                          thumbnail,
                                          thumbnails,
                                          category_name,
                                          category,
                                          content_status,
                                          status,
                                          publish_date,
                                          created,
                                          video_size,
                                          draft_id,
                                          transcoder_status,
                                          workflow_status,
                                          draft_content_id,
                                          type,
                                          views,
                                          visibility,
                                          photos,
                                          album_size,
                                          category_id,
                                          subcategory_id,
                                          content: contentData,
                                          content_type,
                                          file,
                                          initializing,
                                        };
                                        if (
                                          draft_id
                                          && draft_id?.slice(0, 9) !== 'old_video'
                                        ) {
                                          toggleItemSelection(
                                            draft_id,
                                            'draft_id',
                                            status,
                                            videoObject
                                          );
                                        } else {
                                          toggleItemSelection(
                                            draft_id || draft_content_id,
                                            'draft_id',
                                            status,
                                            videoObject
                                          );
                                        }
                                        setEditItems((prevSelected) => {
                                          const idToUse = tabTitle === 0
                                            ? content_id
                                            : tabTitle === 2
                                            && draft_content_id;
                                          if (prevSelected.includes(idToUse)) {
                                            return prevSelected.filter(
                                              (id) => id !== idToUse
                                            );
                                          }
                                          return [...prevSelected, idToUse];
                                        });
                                        setEditItemsStatus(
                                          (prevSelectedStatus) => {
                                            const idToUse = status;
                                            if (
                                              prevSelectedStatus.includes(
                                                idToUse
                                              )
                                            ) {
                                              return prevSelectedStatus.filter(
                                                (id) => id !== idToUse
                                              );
                                            }
                                            return [
                                              ...prevSelectedStatus,
                                              idToUse,
                                            ];
                                          }
                                        );
                                      }}
                                      selected={isItemSelected(
                                        draft_id
                                          && draft_id?.slice(0, 9) !== 'old_video'
                                          ? draft_id
                                          : draft_id
                                          || content_id
                                          || draft_content_id
                                      )}
                                    />
                                  ) : (
                                    <Spinner />
                                  )}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className={cn({
                                    [styles.bodyCell]: true,
                                    [styles.videoPreviewCell]: true,
                                  })}
                                >
                                  <div
                                    onClick={() => {
                                      setSelectedIdType(
                                        video_id || content_id
                                          ? 'videoId'
                                          : 'draft'
                                      );
                                    }}
                                    className={styles.previewContainer}
                                  >
                                    {/* <div onClick={() => { (content_id || video_id || draft_content_id) && toggleVideoSelection(tabTitle === 2 ? draft_content_id : (content_id || video_id), arr[idx], 'video', true); setSelectedIdType((video_id || content_id) ? 'videoId' : 'draft'); }} className={styles.previewContainer}> */}
                                    <img
                                      className={styles.previewImage}
                                      src={
                                        Array.isArray(thumbnail)
                                          ? thumbnail[0] || AlterImage
                                          : thumbnail
                                          || thumbnails
                                          || AlterImage
                                      }
                                      // eslint-disable-next-line
                                      onError={(event) => (event.target.src = AlterImage)}
                                      alt={title}
                                    />
                                    <div className={styles.previewText}>
                                      <TruncatedTitle
                                        title={title}
                                        className={styles.previewTitle}
                                      />
                                      {dummyObject && dummyObject[draft_id] && (
                                        <button
                                          className={styles.cancelButton}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleEncouter(draft_id);
                                            dispatch(removeDummy(draft_id));
                                          }}
                                          title="Cancel upload"
                                        >
                                          Cancel upload
                                        </button>
                                      )}
                                      <span
                                        className={styles.previewDescription}
                                      >
                                        {description || video_description}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {tabTitle === 2
                                    ? category_name || category
                                    : category}
                                </TableCell>
                                {/* <TableCell align="center" className={styles.bodyCell}>
                                    {dataD[draft_id]?.status === 'Finished' ? (
                                      <a href={dataD[draft_id]?.key}>M3U8</a>
                                    ) : (
                                      dataD[draft_id]?.status
                                    )}
                                  </TableCell> */}
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {/* {renderContent(draft_id, content_status, status, video_id) === '' ? 'Publishing video' : transcoder_status != null && transcoder_status !== 'Finished' ? <AddDotLoader text="Processing" /> : typeof uploadPercentages[draft_id] === 'number' ? <AddDotLoader text={`Uploading ${tempUploadPercentages[draft_id]}%`} /> : content_status === 'Public' ? 'All Viewers' : renderContent(draft_id, content_status, status, video_id)} */}
                                  {renderContent(
                                    draft_id,
                                    content_status,
                                    status,
                                    video_id,
                                    transcoder_status,
                                    workflow_status
                                  )}
                                  {tabTitle !== 1
                                    && (uploadPercentages[draft_id] > 0
                                      || uploadPercentages[draft_id]
                                      === 'Starting Upload')
                                    && (draft_content_id
                                      || content_id
                                      || video_id) && (
                                      <button
                                        onClick={() => {
                                          setModal(true);
                                          setDraft_idPLacer(draft_id);
                                        }}
                                        className={styles.cancelPlz}
                                      >
                                        Cancel
                                      </button>
                                    )}
                                  {/* {!Number.isNaN(eta) && tabTitle !== 1 && uploadPercentages[draft_id] > 0 && (
                                      <div className={styles.Sppped}>
                                        {eta > 1 ? `${eta} Minutes remaining` : eta <= 1 ? 'Less than a minute' : 'Calculating'}
                                      </div>
                                        )} */}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {changeDateFormat(
                                    publish_date?.split(' ')[0]
                                  ) || created?.split(' ')[0]}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={styles.bodyCell}
                                >
                                  {video_size < 1 && video_size > 0
                                    ? `${(video_size * 1024).toFixed(2)} KB`
                                    : video_size < 1000 && video_size > 1
                                      ? `${video_size} MB`
                                      : video_size > 1000
                                        ? `${(video_size / 1024).toFixed(2)} GB`
                                        : '--'}
                                </TableCell>
                              </TableRow>
                            ) : null)
                          )
                        ) : (
                          <PreloadData>No content uploaded</PreloadData>
                        )}
                      </>
                    )}
                  </TableBody>
                </Table>
              )}
            </div>
            {selectedPage && !selectedVideo && tabTitle !== 1 && tabTitle !== 2 ? (
              <ReactPaginate
                nextLabel={`${window.screen.width > 900 ? 'next >' : '>'}`}
                onPageChange={handlePageClick}
                pageRangeDisplayed={1}
                marginPagesDisplayed={1}
                pageCount={pageCount}
                previousLabel={`${window.screen.width > 900 ? '< previous' : '<'
                  }`}
                pageClassName={styles.pageItem}
                pageLinkClassName={styles.pageLink}
                previousClassName={styles.pageItem}
                previousLinkClassName={styles.pageLink}
                nextClassName={styles.pageItem}
                nextLinkClassName={styles.pageLink}
                breakLabel="..."
                breakClassName={styles.pageItem}
                breakLinkClassName={styles.pageLink}
                containerClassName={styles.pagination}
                activeClassName={styles.active}
                renderOnZeroPageCount={null}
                forcePage={selectedPage - 1}
              />
            ) : null}

            {isOpenModal && (
              <InfoModal
                isVisible={isOpenModal}
                title={
                  draft_idPLacer
                    ? 'Are you sure you want to cancel ?'
                    : 'Are you sure you want to delete?'
                }
                onHide={() => {
                  setModal(false);
                }}
                continueButton={draft_idPLacer ? 'Exit' : 'Go back'}
                isLoading={dataLoading}
                // content="You are now deleting, all videos and photos will now be a draft until you
                // Add them to a new category. Are you sure you want to continue?"
                action={() => {
                  setModal(false);
                  setIsDummyLoader(true);
                  setSelectedItems([]);
                  if (draft_idPLacer) {
                    handleEncouter(draft_idPLacer);
                  } else if (tabTitle === 1) {
                    deleteVideo();
                    setDataLoading(true);
                  } else {
                    deleteSelectedItems();
                    setDataLoading(true);
                  }
                }}
                actionButton={draft_idPLacer ? 'Continue to cancel' : 'Delete'}
                isDelete
              />
            )}
          </div>
          {/* Close contentArea */}

          {/* Right Sidebar - Video Panel */}
          {(selectedItems?.length > 0 || panelTransitionState !== 'exited')
            && viewMode === 'grid' && (
              <div
                className={`${styles.rightSidebar} ${styles[panelTransitionState]}`}
              >
                <VideoPanel
                  formatFileSize={formatFileSize}
                  setOpenEditInBulk={setOpenEditInBulk}
                  selectedItems={selectedItems}
                  onClearSelection={() => {
                    setSelectedItems([]);
                    setSelectAllChecked(false);
                    setEditItems([]);
                    setSelectedDraftIds([]);
                    setSelectedContentIds([]);
                    setOpenEditInBulk(false);
                  }}
                  onPlayVideo={(video) => {
                    setOpenPopupModal(true);
                    selectVideo(
                      video.content_id || video.video_id || video.draft_id
                    );
                  }}
                  tabTitle={tabTitle}
                  onEditVideo={(video) => {
                    if (tabTitle === 1) {
                      fetchAlbumData(video.content_id);
                    } else {
                      handleButtonClick(
                        video.content_id || video.draft_id || video.video_id
                      );
                    }
                  }}
                  onDeleteVideo={(videos) => {
                    setModal(true);
                  }}
                  onDownloadVideo={downloadSelectedVideo}
                  onBulkDownload={downloadSelectedVideos}
                  onDownloadAlbums={downloadSelectedAlbums}
                  isDownloadDisabled={isDownloadDisabled}
                  isCheckingDownload={isCheckingDownload}
                  isBulkDownloading={isBulkDownloading}
                  downloadingFiles={downloadingFiles}
                />
              </div>
            )}

          {(selectedPhotos?.length > 0 || photosPanelTransitionState !== 'exited')
            && viewMode === 'grid'
            && tabTitle === 1
            && selectedAlbumFilter && (
              <div
                className={`${styles.rightSidebar} ${styles[photosPanelTransitionState]}`}
              >
                <VideoPanel
                  itemType="photo"
                  formatFileSize={formatFileSize}
                  selectedItems={selectedPhotos}
                  tabTitle={tabTitle}
                  onClearSelection={() => setSelectedPhotos([])}
                  onDownloadPhotos={downloadSelectedPhotos}
                  onDeleteVideo={() => {
                    albumPhotosViewRef.current?.requestBulkDelete();
                  }}
                />
              </div>
            )}
        </div>
        {/* Close mainLayout */}

        <AlbumPhotosModal
          open={albumPhotosModalOpen}
          onClose={handleCloseAlbumPhotosModal}
          album={selectedAlbumForPhotos}
        />

        <PublishSettingsModal
          open={showPublishSettingsModal}
          onClose={() => setShowPublishSettingsModal(false)}
          onPublish={publishSelectedContributions}
          selectedItems={contributions.filter((c) => selectedContributions.includes(c.id))}
          isPublishing={publishingContributions}
        />

        {/* Reactivate-and-copy confirmation for a revoked folder link */}
        {showReactivatePopup && (
          <div
            className={styles.reactivateOverlay}
            role="presentation"
            onClick={() => !reactivatingFolder && setShowReactivatePopup(false)}
          >
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
            <div
              className={styles.reactivateModal}
              role="dialog"
              aria-modal="true"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className={styles.reactivateTitle}>Link Revoked</h3>
              <p className={styles.reactivateText}>
                This folder&apos;s link has already been revoked. Do you want to reactivate
                and copy the link?
              </p>
              <div className={styles.reactivateActions}>
                <button
                  type="button"
                  className={styles.reactivateCancelBtn}
                  onClick={() => setShowReactivatePopup(false)}
                  disabled={reactivatingFolder}
                >
                  No
                </button>
                <button
                  type="button"
                  className={styles.reactivateConfirmBtn}
                  onClick={handleReactivateAndCopy}
                  disabled={reactivatingFolder}
                >
                  {reactivatingFolder ? (
                    <CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} />
                  ) : null}
                  Yes &amp; Copy
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Shared-tab folder edit — reuses the same UploadLinkModal as the
            share flow, opened straight into its edit view for this folder. */}
        <UploadLinkModal
          open={showEditFolderModal}
          editLink={selectedLink}
          onClose={() => setShowEditFolderModal(false)}
          onUpdated={handleFolderEdited}
        />

        {/* Add-as-viewer confirmation popup */}
        {invitePopup && (
          <div
            className={styles.reactivateOverlay}
            role="presentation"
            onClick={() => !invitePopup.inviting && !invitePopup.checking && setInvitePopup(null)}
          >
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
            <div
              className={styles.reactivateModal}
              role="dialog"
              aria-modal="true"
              onClick={(e) => e.stopPropagation()}
            >
              {invitePopup.checking ? (
                <div className={styles.inviteChecking}>
                  <CircularProgress size={30} style={{ color: '#065fd4' }} />
                  <span>Checking…</span>
                </div>
              ) : (
                <>
                  <h3 className={styles.reactivateTitle}>Invite as viewer</h3>
                  {invitePopup.foundUser ? (
                    <div className={styles.invitePersonRow}>
                      {invitePopup.foundUser.image ? (
                        <img
                          src={invitePopup.foundUser.image}
                          alt=""
                          className={styles.inviteAvatar}
                          onError={(e) => { e.target.style.display = 'none'; }}
                        />
                      ) : null}
                      <div>
                        <div className={styles.inviteName}>
                          {`${invitePopup.foundUser.firstname || ''} ${invitePopup.foundUser.lastname || ''}`.trim() || invitePopup.email}
                        </div>
                        <div className={styles.inviteEmail}>{invitePopup.email}</div>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.inviteEmail} style={{ marginBottom: 4 }}>{invitePopup.email}</div>
                  )}
                  <p className={styles.inviteMessage}>
                    {invitePopup.foundUser
                      ? `Found ${`${invitePopup.foundUser.firstname || ''} ${invitePopup.foundUser.lastname || ''}`.trim() || 'this user'}. Are you sure you want to send them an invite to be your viewer?`
                      : 'This user isn’t on Projector yet. Are you sure you want to invite them to join Projector and become your viewer?'}
                  </p>
                  <div className={styles.reactivateActions}>
                    <button
                      type="button"
                      className={styles.reactivateCancelBtn}
                      onClick={() => setInvitePopup(null)}
                      disabled={invitePopup.inviting}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className={styles.reactivateConfirmBtn}
                      onClick={confirmInvite}
                      disabled={invitePopup.inviting}
                    >
                      {invitePopup.inviting ? (
                        <CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} />
                      ) : null}
                      Invite
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <VideoPopupModal
          isVisible={isOpenPopupModal}
          onHide={() => {
            setOpenPopupModal(false);
          }}
          showVideo={modalShowPopUp === '1'}
        />
        {/* {iosDownloadOverlay && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
            }}
          >
            <div
              style={{
                backgroundColor: '#fff',
                borderRadius: 12,
                padding: '24px 32px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 12,
              }}
            >
              <CircularProgress size={36} style={{ color: '#5aa5ef' }} />
              <div style={{ fontSize: 16, fontWeight: 500, color: '#333' }}>Downloading file...</div>
            </div>
          </div>
        )} */}
      </Page>
    </DndProvider>
  );
};
export default YourVideos;
